
import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import _, { constant, template } from "lodash";
import cx from "classnames";
import Chart from "react-google-charts";

import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import contentSubtypeActions from "../../actions/contentSubtypeActions";
import { ContentSubType } from "../../../test-template/types/ContentSubTypeBody";
import { getContentSubType } from "../../../test-template/actions/testTemplateActions";
import contentActions from "../../actions/contentActions";
import {
  saveTestTemplate,
  updateTestTemplate,
} from "../../../test-template/actions/testTemplateActions";
import { withStyles } from "@material-ui/core/styles";
import { Theme } from "@material-ui/core/styles/createMuiTheme";
import ErrorOutlineIcon from "@material-ui/icons/ErrorOutline";
import ACLService from "../../../acl/services/aclService";
import PerfectScrollbar from "react-perfect-scrollbar";
import MuiDialogContent from "@material-ui/core/DialogContent";
import MuiDialogActions from "@material-ui/core/DialogActions";
import TestTemplateNamePopup from "./TestTemplateNamePopup";
import MyPATMultiSelect from "../../../common/MyPATMultiSelect";
import {
  WithStyles,
  createStyles,
  Typography,
  Grid,
  RadioGroup,
  FormGroup,
  Radio,
  Checkbox,
  FormControlLabel,
  Button,
  Collapse,
  Tabs,
  Tab,
  Card,
  CardContent,
  TableBody,
  Table,
  TableCell,
  TableRow,
  Tooltip,
  Dialog,
  DialogTitle,
  DialogContent,
  TextField,
  FormControl,
  Link,
  Chip,
  Select,
  Input,
  MenuItem,
  ListItemText,
  Badge,
} from "@material-ui/core";
import {
  MyPATTextArea,
  MyPATTextField,
  MyPATSelect,
  MyPATExpansionPanel,
  MyPATLink,
  MyPATDialog,
  MyPATCollapse,
  ModalComponent,
  MyPATIconButton,
} from "../../../common";
import {
  InfoOutlined as InfoIcon,
  Done as SelectedIcon,
  NavigateBeforeOutlined as BackIcon,
  ReorderOutlined as ReorderIcon,
  Delete as DeleteIcon,
  SwapHoriz as ReplaceIcon,
  CheckCircle as SuccessIcon,
  UnsubscribeTwoTone,
  ErrorOutline as ErrorIcon,
  Check as SuccessIcon2,
  CloseOutlined as CloseIcon,
  LensTwoTone,
} from "@material-ui/icons";

import courseService from "../../services/courseService";
import subjectsServices from "../../services/subjectsServices";
import templateServices from "../../services/templateServices";

import ContentFormData from "../../types/ContentFormData";
import CourseData from "../../types/CourseData";
import {
  TestTemplateBody,
  section,
  subSection,
} from "../../types/TestTemplateBody";
import languageServices from "../../../common/services/languageServices";
import { LanguageListData } from "../../../common/types/LanguageData";
import WithContent from "../../containers/WithContent";
import ContentData from "../../types/ContentData";
import { showMsg } from "../../actions/testPaperCreateAction";
import { eventFired } from "../../actions/contentInSectionAction";
import { statusType } from "../../types/ContentInSection";
import ContentFormDataError from "../../types/ContentFormDataError";
import LoaderComponent from "../../../common/LoaderComponent";
import AddSyllabusComponent from "./AddSyllabusComponent";
import getDefaultFormData from "../../types/ContentFromDataDefault";
import contentService from "../../services/contentService";
import CustomInfoIcon from "../../../common/CustomInfoIcon";
import CreateTestTemplate from "../../../test-template/components/CreateTestTemplate";
import { CONTENT_SECTION_KEYS, CONTENT_SECTION_TYPES, FORM, MODULE_TO_QUESTION_PERMISSION_MAP, MODULE_TO_TEST_PERMISSION_MAP, QUESTION_TYPES_ARRAY, TESTPAPER_PROPERTY, TEST_TYPES_TEMPLATE, USER_RIGHTS } from "../../../../constants/comman";
import { testTemplateService } from "../../../test-template/services/testTemplateService";
import {
  getMandatoryQuestionCount,
  getNoOfQuestionsToConsiderForMarks,
  toShowJEEMainSpecificFields,
  fiitJeeMasterClientId,
  concepts,
  pattern,
  skill,
  convertSubjectIdFromObjectToString,
  checkForTeacherUser,
  getMasterTestTypeDisplayName,
  getSectionLevelDisplayName,
} from "../../../../utils";
import { SubSection } from "../../../test-template/types/TestTemplateBody";
import Pagination from "../../../common/Pagination";
import TestTemplateTable from "./TestTemplateTable";
import QuestionsSolution from "./QuestionsSolution";
import { element } from "prop-types";
import { fil } from "date-fns/locale";
import AddFeedback from "../../../content-request/components/AddFeedback";
import {
  addNewFeedback,
  resolveFeedback,
  replyFeedback,
} from "../../../content-request/actions/contentRequestActions";
import AddConceptOrChapter from "./AddConceptOrChapter";
import syllabusActions from "../../actions/syllabusActions";
import classNames from "classnames";
import { SectionFocusedContext, SectionFocusedContextValue } from "../../../common/MyPATBaseSection";
// @ts-ignore
import {createRef} from "react"


const styles = (theme: Theme) =>
  createStyles({
    blueColor: {
      color: "#1D7DEA",
    },
    feedbackContainer: {
      position: "relative",
      marginRight: '5px',
      "& .feedbackBlock": {
        top: -16,
        left: "100%",
        position: "absolute",
        marginLeft: 20,
        zIndex: 2,
      },
    },
    primaryColor: {
      color: "#1d7dea",
    },
    selectSection: {
      width: "120px",
      maxWidth: "180px",
      // height: "17px",
    },
    questionTS: {
      // height: "17px",
    },
    filterOkBtn: {
      fontSize: "14px",
      fontWeight: 600,
      lineHeight: "19px",
      color: "#fff",
      backgroundColor: "#1D7DEA",
    },
    greyText: {
      color: "#999",
      fontSize: 14,
      opacity: 1,
    },
    distributionTabs: {
      padding: "5px",
      margin: '0 5px',
      fontSize: "14px",
      lineHeight: "19px",
      textAlign: "center",
      cursor: "pointer",
      borderRadius: 4,
      display: 'inline-block'
    },
    tabsInactive: {
      color: "#999",
      border: "1px solid #999",
    },
    tabsActive: {
      border: "1px solid #1d7dea",
      // fontWeight: 600,
      color: "#1d7dea",
    },
    checkBoxElement: {
      padding: "0px 7px",
      top: 0,
      width: 16,
      height: 16,
      "-moz-appearance": "none",
      opacity: 1,
      color: "rgb(204, 204, 204)",
      border: "1px solid #B2B2B2",
      borderRadius: 2,
      margin: "0px 6px 0px 14px",
      "& svg": {
        fontSize: "1.5rem",
        fontFamily: '"Nunito", sans-serif',
        fill: "#979797",
        opacity: 0,
      },
      '& span:nth-child(1)': {
        width: 24,
        zIndex: 9
      }
    },
    checkedCheckbox: {
      backgroundColor: "#1d7dea",
      border: "1px solid #1d7dea !important",
      borderRadius: 2,
      color: "#99a1a7",
      "&::after": {
        content: "''",
        fontSize: 14,
        position: "absolute",
        top: 0,
        left: 4,
        width: 4,
        height: 8,
        border: "solid #fff",
        borderWidth: "0 2px 2px 0",
        transform: "rotate(45deg)",
      },
      "&:hover": {
        backgroundColor: "#1d7dea",
      },
    },
    width_SM: {
      maxWidth: 700,
      "& p": {
        margin: "0px 0px 10px",
        fontWeight: 600,
        "&>:first-child": {
          display: "inline-block",
          verticalAlign: "middle",
        },
      },
      "& .goalAction": {
        padding: "20px 0px 0px",
        "& select": {
          border: "1px solid #DFDFDF",
          borderRadius: 4,
          height: 34,
          minWidth: 200,
          padding: "0px 6px",
          outline: 0,
        },
      },
    },
    greyContainer: {
      background: "#F8F8F8",
      borderRadius: 4,
      padding: 20,
      marginTop: -4,
      "& div": {
        "& :nth-child(1)": {
          color: "#333",
          fontWeight: 600,
          fontSize: 16,
        },
        "& :nth-child(2)": {
          color: "#666",
          fontWeight: 600,
          fontSize: 16,
        },
      },
    },
    filterInfoContainer: {
      position: "absolute",
    },
    formControlLabel: {
      fontSize: 16,
      color: "#333333",
    },
    checkBoxRoot: {
      "& input": {
        background: "#1d7dea",
        border: "1px solid #DDDDDD",
        borderRadius: 4,
        height: 36,
        width: "100%",
      },
      "&:hover": {
        backgroundColor: "transparent",
      },
      "&>:first-child": {
        background: "#fff",
      },
    },
    checkedIcon: {
      backgroundColor: "rgb(29 125 234)",
      backgroundImage:
        "linear-gradient(180deg,hsla(0,0%,100%,.1),hsla(0,0%,100%,0))",
      "&:before": {
        display: "block",
        width: 16,
        height: 16,
        backgroundImage:
          "url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3E%3Cpath" +
          " fill-rule='evenodd' clip-rule='evenodd' d='M12 5c-.28 0-.53.11-.71.29L7 9.59l-2.29-2.3a1.003 " +
          "1.003 0 00-1.42 1.42l3 3c.18.18.43.29.71.29s.53-.11.71-.29l5-5A1.003 1.003 0 0012 5z' fill='%23fff'/%3E%3C/svg%3E\")",
        content: '""',
      },
      "input:hover ~ &": {
        backgroundColor: "#106ba3",
      },
    },
    goalAction: {
      margin: "14px 0px 0px",
    },
    sliderContainer: {
      padding: "12px 0px",

      "& .percentage": {
        display: "flex",
        alignItems: "center",
        "&>:nth-child(2)": {
          "&>:first-child": {
            margin: "0px 10px",
            "&>:first-child": {
              padding: 0,
              width: 80,
              height: 36,
            },
          },
        },
      },

      "& input": {
        background: "#FBFBFB",
        border: "1px solid #DDDDDD",
        borderRadius: 4,
        height: 36,
        width: "100%",
      },
    },
    showHoverTooltip: {
      "&:hover": {
        "& $plusInfoIcon": {
          opacity: 1,
        },
      },
    },
    selectedTestCard: {
      background: "#F7FBE4",
      border: "1px solid #DCDCDC",
      borderRadius: 4,
      padding: 10,
      cursor: "pointer",
      "& h6": {
        color: "rgb(51 51 51)",
        fontSize: 24,
        fontWeight: 600,
        verticleAlign: "middle",
      },
      "&>:last-child": {
        paddingBottom: 0,
        padding: 10,
      },
    },
    whiteBackground: {
      background: "#fff",
      padding: 0,
      textAlign: 'center',
      '&>div:nth-of-type(1)':{
        marginBottom: 0,
      },
      '&:nth-of-type(1)':{
          padding: '10px !important',
      }
    },
    seperator: {
      width: "100%",
      position: "relative",
      display: "block",
      height: "25px",
      margin: "15px 0",
      float: "left",
      "&:after": {
        content: '"OR"',
        height: "32px",
        width: "32px",
        background: "#e0e0e0",
        fontSize: "14px",
        lineHeight: "16px",
        color: "#4a4a4a",
        position: "absolute",
        left: 0,
        right: 0,
        margin: 'auto',
        zIndex: 9,
        textAlign: "center",
        borderRadius: "50%",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        fontStyle: "italic",
        paddingRight: "1px",
        transform: "translate(-50%, 0)",
      },
      "&:before": {
        content: '""',
        height: "1px",
        background: "#e0e0e0",
        position: "absolute",
        left: 0,
        top: "14px",
        zIndex: 8,
        width: "100%",
      },
    },
    selectedButton: {
      background: "#1D7DEA",
      boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.05)",
      borderRadius: 4,
    },
    outlineTypeButton: {
      background: "#FFFFFF",
      border: "1px solid #1D7DEA",
      borderRadius: 4,
      color: "#1D7DEA",
    },
    editTemplateInfoIcon: {
      "&>:first-child": {
        whiteSpace: "normal",
        width: 250,
        textAlign: "justify",
        padding: "8px 9px 9px",
        zIndex: 2,
      },
    },
    errorCard: {
      maxWidth: 420,
    },
    marginBottom2x: {
      marginBottom: 16,
    },
    fontMD: {
      fontSize: 16,
      lineHeight: "24px",
      textAlign: "center",
      color: "#666666",
    },
    whiteCard: {
      background: "#FFFFFF",
      borderRadius: 4,
      padding: "12px 18px 18px",
      fontSize: 16,
      color: "#666666",
      "& textarea": {
        height: 60,
        width: "96%",
      },
    },
    lightPinkCard: {
      background: "#FCEEEE",
      borderRadius: 4,
      fontSize: 14,
      color: "#666666",
      lineHeight: "16px",
      margin: "12px 0px",
      padding: "20px 24px",
    },
    widthMd: {
      maxWidth: 800,
    },
    plusInfoIcon: {
      zIndex: 1,
      position: "absolute",
      right: 70,
      "&::after": {
        position: "absolute",
        width: 0,
        height: 0,
        bottom: -10,
        left: 34,
        borderLeft: "6px solid rgba(0, 0, 0, 0)",
        borderRight: "6px solid rgba(0, 0, 0, 0)",
        borderBottom: "12px solid rgb(0, 0, 0)",
        content: '""',
      },
      "&:first-child": {
        background: "rgba(0, 0, 0, 0.7)",
        borderRadius: 3,
      },
    },
    swapInfoIcon: {
      position: "absolute",
      marginLeft: -8,
      zIndex: 1,
      "&::after": {
        position: "absolute",
        width: 0,
        height: 0,
        bottom: -10,
        left: 22,
        borderLeft: "6px solid rgba(0, 0, 0, 0)",
        borderRight: "6px solid rgba(0, 0, 0, 0)",
        borderBottom: "12px solid rgb(0, 0, 0)",
        content: '""',
      },
      "&:first-child": {
        background: "rgba(0, 0, 0, 0.7)",
        borderRadius: 3,
      },
    },
    deleteInfoIcon: {
      position: "absolute",
      marginLeft: -8,
      zIndex: 1,
      "&::after": {
        position: "absolute",
        width: 0,
        height: 0,
        bottom: -10,
        left: 22,
        borderLeft: "6px solid rgba(0, 0, 0, 0)",
        borderRight: "6px solid rgba(0, 0, 0, 0)",
        borderBottom: "12px solid rgb(0, 0, 0)",
        content: '""',
      },
      "&:first-child": {
        background: "rgba(0, 0, 0, 0.7)",
        borderRadius: 3,
      },
    },
    graceInfoIcon: {
      position: "absolute",
      marginLeft: -8,
      zIndex: 1,
      "&::after": {
        position: "absolute",
        width: 0,
        height: 0,
        bottom: -10,
        left: 22,
        borderLeft: "6px solid rgba(0, 0, 0, 0)",
        borderRight: "6px solid rgba(0, 0, 0, 0)",
        borderBottom: "12px solid rgb(0, 0, 0)",
        content: '""',
      },
      "&:first-child": {
        background: "rgba(0, 0, 0, 0.7)",
        borderRadius: 3,
      },
    },
    questionParagraph: {
      maxWidth: 380,
      "& >p": {
        textOverflow: "ellipsis",
        whiteSpace: "nowrap",
        overflow: "hidden",
      },
    },
    saveBtn: {
      boxShadow: "0px 0px 6px rgba(0, 0, 0, 0.224892)",
      borderRadius: 2,
      fontFamily: "Nunito",
      fontStyle: "normal",
      fontWeight: 600,
      fontSize: 16,
      lineHeight: "19px",
      letterSpacing: "0.5px",
      color: "#FFFFFF",
      background: "#1D7DEA",
      padding: "4px 22px",
      "&:hover": {
        background: "#1D7DEA",
      },
    },
    opacitySM: {
      opacity: 0.5,
    },

    graceInfoContainer: {
      position: "absolute",
      right: 64,
      width: 240,
      marginTop: -4,
      "&::after": {
        position: "absolute",
        width: 0,
        height: 0,
        bottom: -10,
        left: "90%",
        borderLeft: "6px solid rgba(0, 0, 0, 0)",
        borderRight: "6px solid rgba(0, 0, 0, 0)",
        borderBottom: "12px solid rgb(0, 0, 0)",
        content: '""',
      },
      "& :first-child": {
        maxWidth: 480,
        textAlign: "left",
        whiteSpace: "normal",
      },
    },

    inlineBlock: {
      display: "inline-block",
      padding: "6px 12px",
      textAlign: "center",
      cursor: "pointer",
      "& p": {
        fontSize: 10,
        lineHeight: "12px",
        alignItems: "center",
        letterSpacing: "0.5px",
        color: "#999999",
      },
    },

    perfectScrollbar: {
      ...theme.mixins.gutters(),
      paddingTop: theme.spacing.unit,
      // paddingBottom: theme.spacing.unit,
      maxHeight: "inherit",
      background: "rgb(255, 255, 255)",
      borderRadius: 4,
      "& .ps--active-x > .ps__rail-x, .ps--active-y > .ps__rail-y": {
        opacity: 1,
      },
      paddingBottom: 24,
    },
    tooltipContainer: {
      cursor: "pointer",
      position: "relative",
      marginLeft: '5px',
      "& .tooltip": {
        display: "none",
      },
      "&:hover": {
        "& .tooltip": {
          display: "block",
          position: "absolute",
          background: "#333",
          width: 370,
          zIndex: 999,
          bottom: 50,
          right: 0,
          padding: 12,
          color: "#fff",
          lineHeight: "20px",
          fontWeight: 600,
          borderRadius: 4,
          "&::before": {
            right: "62px",
            width: 0,
            bottom: -8,
            height: 0,
            content: '" "',
            position: "absolute",
            marginLeft: -6,
            borderLeft: "5px solid rgb(0 0 0 / 0%)",
            borderRight: "5px solid rgb(0 0 0 / 0%)",
            borderTop: "8px solid #333",
          },
          "&>:nth-child(2)": {
            fontSize: "12px",
            color: "#fff",
            textAlign: "left",
            marginLeft: "20px",
            fontWeight: "normal",
            "&>span": {
              fontWeight: "bold",
            },
          },
          "&>:first-child": {
            "&>svg": {
              fill: "#fff",
            },
          },
          "& .noteTxt": {
            textAlign: "left",
            "&>:nth-child(2)": {
              fontSize: "14px",
              fontWeight: "bold",
              color: "#fff",
              marginLeft: "8px",
              verticalAlign: "middle",
              marginBottom: 8,
            },
          },
        },
      },
    },
    dialogContent: {
      padding: 0,
      maxHeight: "100%",
      marginTop: 74,
    },
    dialogTitle: {
      ...theme.mixins.gutters(),
      paddingTop: theme.spacing.unit,
      paddingBottom: theme.spacing.unit,
      backgroundColor: "white",
      "& > h6 > div": {
        minHeight: theme.spacing.unit * 7,
      },
      textTransform: "capitalize",
      borderBottom: "1px solid rgb(226 226 226)",
      position: "fixed",
      zIndex: 1001,
      top: 0,
      left: 0,
      right: 0,
    },
    ml1x: {
      marginLeft: `${theme.spacing.unit}px !important`,
    },
    mb1x: {
      marginBottom: theme.spacing.unit,
    },
    mb2x: {
      marginBottom: theme.spacing.unit * 2,
    },
    paddingFixed: {
      marginBottom: theme.spacing.unit / 2,
      padding: "5px 20px 5px 5px",
    },
    p0: {
      padding: `0 !important`,
    },
    textAlignRight: {
      textAlign: "right",
      '& button':{
        color: '#1D7DEA',
        border: 'solid 1px #1D7DEA',
        borderRadius: 4,
        padding: '10px 12px',
      },
    },
    textAlignCenter: {
      textAlign: "center",
    },

    cardHeading: {
      fontWeight: theme.typography.fontWeightRegular,
    },
    requiredHeading: {
      color: theme.palette.secondary.main,
    },
    borderBox: {
      background: "#FFFFFF",
      border: "1px solid #E1E1E1",
      boxSizing: "border-box",
      padding: theme.spacing.unit,
      borderRadius: 5,
    },
    checkboxChecked: {
      color: "#59CA1C !important",
    },
    testRadioRoot: {
      padding: `${theme.spacing.unit}px ${theme.spacing.unit * 1.5}px`,
    },
    testRadioGroup: {
      "& label": {
        flex: "1 1 auto",
      },
    },
    testCheckboxRoot: {
      padding: `${theme.spacing.unit}px ${theme.spacing.unit * 1.5}px`,
    },
    testCheckboxGroup: {
      "& label": {
        flex: "1 1 auto",
      },
    },
    noOfAttemptsSelect: {
      display: "flex",
      alignItems: "center",
      "& > div": {
        width: theme.spacing.unit * 10,
        marginRight: theme.spacing.unit,
      },
    },

    subQuestionBox: {
    //   ...theme.mixins.gutters(),
      marginTop: theme.spacing.unit,
      paddingTop: theme.spacing.unit * 2,
      paddingBottom: theme.spacing.unit * 2,
    },
    borderFieldBox: {
      border: `1px solid ${theme.palette.grey[300]}`,
      borderRadius: theme.shape.borderRadius,
    },
    boxHeading: {
      padding: `${theme.spacing.unit}px ${theme.spacing.unit * 2}px`,
      borderBottom: `1px solid ${theme.palette.grey[300]}`,
      "& h6": {
        fontWeight: theme.typography.fontWeightRegular,
      },
    },
    boxField: {
      padding: theme.spacing.unit * 2,
      borderBottom: `1px solid ${theme.palette.grey[300]}`,
      "&:last-child": {
        borderBottom: 0,
      },
    },

    collapseBody: {
      background: theme.palette.grey[100],
    },
    collapseRoot: {
      marginBottom: theme.spacing.unit * 2,
    },

    optionColumn1: {
      paddingRight: theme.spacing.unit,
      marginBottom: theme.spacing.unit,
    },
    adornedReorder: {
      cursor: "move",
      height: theme.spacing.unit * 4.5,
      padding: `0 ${theme.spacing.unit}px`,
      maxHeight: "unset",
      borderRight: `1px solid ${theme.palette.grey[300]}`,
      "& svg": {
        fontSize: theme.spacing.unit * 3,
        color: theme.palette.grey[500],
      },
    },
    deleteBtn: {
      border: `1px solid ${theme.palette.grey[300]}`,
      "& svg": {
        color: theme.palette.grey[600],
      },
    },
    addOptionButton: {
      marginLeft: theme.spacing.unit * 4,
      marginBottom: theme.spacing.unit * 2,
    },

    answerTable: {
      width: "auto",
      "& tbody": {
        "& tr": {
          height: "auto",
          "& td": {
            padding: `${theme.spacing.unit / 2}px 0`,
            border: 0,
            textAlign: "center",
            minWidth: theme.spacing.unit * 10,
            "&:last-child": {
              paddingRight: 0,
            },
          },
          "&:first-child": {
            "& td": {
              borderRight: `1px solid ${theme.palette.grey[300]}`,
              "&:last-child": {
                borderRight: 0,
              },
            },
          },
        },
      },
    },

    addMoreQuestionWrapper: {
      textAlign: "right",
      marginBottom: theme.spacing.unit * 2,
    },

    testPaperHeading: {
      borderBottom: `1px solid ${theme.palette.grey[300]}`,
      marginBottom: theme.spacing.unit * 2,
      paddingBottom: theme.spacing.unit,
    },
    emptyPlaceholderBox: {
      backgroundColor: theme.palette.grey[200],
      border: `1px solid ${theme.palette.grey[300]}`,
      borderRadius: theme.shape.borderRadius,
      textAlign: "center",
      padding: "15px 8px 10px 8px",
      "& > span": {
        ...theme.typography.body2,
        fontSize: theme.typography.fontSize,
        color: theme.palette.text.secondary,
      },
    },

    // tabs
    selectedTab: {
      background: "#1D7DEA",
      "&::after": {
        content: "''",
        fontSize: 14,
        position: "absolute",
        top: 0,
        left: 4,
        width: 4,
        height: 8,
        border: "solid #fff",
        borderWidth: "0 2px 2px 0",
        transform: "rotate(45deg)",
      },
    },
    tabContainer: {
      // border: "solid 1px rgba(153, 153, 153, 0.4)",
      marginLeft: '-20px',
      marginRight: '-20px',
      borderRadius: 4,
      "& button:not(:last-child)": {
        borderRight: "solid 1px rgba(153, 153, 153, 0.4)",
      },
      "& .MuiTabs-flexContainer":{
        // width: 'initial'
        border: "solid 1px rgba(153, 153, 153, 0.4)",
      }
    },
    tabRoot: {
      textAlign: "left",
      minWidth: "auto",
      fontSize: theme.typography.fontSize,
      fontWeight: theme.typography.fontWeightMedium,
      padding: "0px 8px",
      minHeight: "auto",
      paddingRight: theme.spacing.unit + 4,
      border: "1px solid #dfdfdf",    
    },
    tabLabelContainer: {
      padding: theme.spacing.unit,
    },
    tabRootIcon: {
      //   position: "absolute",
      //   right: 0,
      marginLeft: "3px",
    },
    scrollButtonsRoot:{
      width: 'initial',
    },

    cardContentRoot: {
      background: "#FFFFFF",
      border: "1px solid #DCDCDC",
      borderRadius: 4,
      padding: 10,
      boxShadow: '0 0 4px 0 #00000026',
      "& h6": {
        color: "rgb(51 51 51)",
        fontSize: 24,
        fontWeight: 600,
        verticleAlign: "middle",
        maxWidth: "100%",
        whiteSpace: "nowrap",
        overflow: "hidden",
        textOverflow: "ellipsis",
        display: "inline-block",
      },
      "&:last-child": {
        padding: 0,
      },
    },
    testPaperName:{
      maxWidth: 500,
      display: 'flex',
      '& p':{
        fontWeight: 500,
      }
    },
    spacing: {
      ...theme.mixins.gutters(),
      paddingTop: theme.spacing.unit * 1.5,
      paddingBottom: theme.spacing.unit * 1.5,
      "& p ": {
        fontSize: 14,
      },
    },
    spacing16:{
      paddingLeft: 16,
      paddingRight: 16
    },

    detailsTable: {
      "& tbody": {
        "&>:nth-child(1)": {
          background: "#F8F8F8",
          border: "1px solid #DCDCDC",
          "& td": {
            fontWeight: 600,
            // paddingLeft: 20,
          },
        },
        "&>:last-child": {
          'td':{
            textAlign: 'center',
          }
        },

        "& tr": {
          height: "auto",
          background: "#F7FBE4",
          border: "1px solid #DCDCDC",
          borderRadius: "0px 0px 4px 0px",
          fontSize: 14,
          textAlign: "left",
          width: 30,
          "& td": {
            // textAlign: "left",
            "& .actionLink": {
              color: "#1D7DEA",
              cursor: "pointer",
              display: "flex",
              fontSize:15,
              paddingLeft:15,
              textDecoration: "none",
              alignItems: "center",
            },
            "& input": {
              outline: 0,
              border: 0,
              width: "100%",
              textAlign: "left",
              paddingLeft: 10,
              height: 25,
              paddingRight: 10,
              // paddingLeft: 10,
            },
            "& input[type=number]::-webkit-inner-spin-button, & input[type='number'].mod::-moz-inner-spin-button, & input[type=number]::-webkit-outer-spin-button, & input[type='number'].mod::-moz-outer-spin-button": {
              opacity: 0,
            },
            "& input[type=number]:hover::-webkit-inner-spin-button": {
              "-moz-appearance": "textfield",
              appearance: "none",
            },
            "& input[type=number]::-webkit-inner-spin-button": {
              "-moz-appearance": "textfield",
              appearance: "none",
            },
            "& select": {
              outline: 0,
              border: "#fff",
              background: "#fff",
              paddingRight: 0,
              paddingLeft: 10,
            },
            // padding: 0,
            border: `1px solid ${theme.palette.grey[400]}`,
            color: "rgb(51 51 51)",
            fontSize: 14,
            padding: 0,
            // paddingLeft:20,
            // paddingRight:15,
            '&>div:nth-of-type(1)':{
              '&>div:nth-of-type(1)':{
                height: 44,
                padding: '0 10px',
              }
            }
          },
        },
      },
    },
    highlightedRow: {
      backgroundColor: theme.palette.grey[200],
    },
    wrapperInner: {
      overflow: "auto",
      borderBottomLeftRadius: theme.shape.borderRadius,
      borderBottomRightRadius: theme.shape.borderRadius,
      padding: 18,
      borderTop: "1px solid rgb(255 255 255)",
    },

    backIconRoot: {
      fill: theme.palette.text.secondary,
      fontSize: 24,
      opacity: 0.5,
      marginBottom: 3,
    },

    questionActionBtn: {
      padding: 10,
      minWidth: "auto",
      border: "1px solid #DFDFDF",
      color: theme.palette.text.secondary,
      borderRadius: 4,
    },
    questionInfo: {
      border: `1px solid ${theme.palette.grey[300]}`,
      "& > div": {
        padding: `0 ${theme.spacing.unit}px`,
      },
      "& > div:first-child": {
        paddingTop: theme.spacing.unit,
        paddingBottom: theme.spacing.unit,
        borderRight: `1px solid ${theme.palette.grey[300]}`,
      },
    },

    difficultyScoreTable: {
      "& tbody": {
        "& tr": {
          height: theme.spacing.unit * 11,
          "& td": {
            padding: theme.spacing.unit,
            border: 0,
            "&:last-child": {
              padding: theme.spacing.unit,
            },
          },
        },
      },
    },

    scoreWrapper: {
      display: "inline-flex",
      height: theme.spacing.unit * 3,
      width: theme.spacing.unit * 3,
      borderRadius: "100%",
      alignItems: "center",
      backgroundColor: theme.palette.grey[500],
      color: theme.palette.common.white,
      overflow: "hidden",
    },
    scoreSizeLarge: {
      height: theme.spacing.unit * 7,
      width: theme.spacing.unit * 7,
    },
    scoreSizeMedium: {
      height: theme.spacing.unit * 5,
      width: theme.spacing.unit * 5,
    },
    scoreWrapperGreen: {
      backgroundColor: "#9FD44A",
    },
    scoreWrapperYellow: {
      backgroundColor: "#F6C943",
    },
    scoreWrapperRed: {
      backgroundColor: "#FF7575",
    },
    score: {
      flex: "1",
      fontFamily: theme.typography.fontFamily,
      fontSize: theme.typography.fontSize,
      textOverflow: "ellipsis",
      overflow: "hidden",
    },
    scoreCell: {
      width: "20%",
      textAlign: "center",
    },
    progressCell: {
      width: "auto",
      textAlign: "right",
    },
    progressRow: {
      height: "auto !important",
    },
    verticalProgressCell: {
      width: theme.spacing.unit * 3,
    },
    verticalProgressLabelCell: {
      width: "auto",
      "& > span": {
        transform: "rotate(90deg)",
        display: "inline-block",
        marginLeft: `-${theme.spacing.unit + 10}px`,
        width: "90px",
        marginTop: "50px",
      },
    },

    scoreProgressWrapper: {
      width: "100%",
      height: theme.spacing.unit,
      borderRadius: theme.shape.borderRadius,
      backgroundColor: theme.palette.grey[500],
      display: "flex",
      overflow: "hidden",
      "& > div": {
        transition: "all 0.2s ease",
        "&:first-child": {
          borderRadius: `${theme.shape.borderRadius}px 0 0 ${
            theme.shape.borderRadius
          }px`,
        },
        "&:last-child": {
          borderRadius: `0 ${theme.shape.borderRadius}px ${
            theme.shape.borderRadius
          }px 0`,
        },
      },
    },
    progressConceptual: {
      backgroundColor: "#F6C943",
    },
    progressAnalytical: {
      backgroundColor: "#8B7FFF",
    },
    progressIntutive: {
      backgroundColor: "#50B7BA",
    },

    verticalProgressWrapper: {
      height: theme.spacing.unit * 11 * 3,
      width: theme.spacing.unit,
      borderRadius: theme.shape.borderRadius,
      backgroundColor: theme.palette.grey[500],
      display: "flex",
      overflow: "hidden",
      flexDirection: "column",
      "& > div": {
        transition: "all 0.2s ease",
        "&:first-child": {
          borderRadius: `${theme.shape.borderRadius}px 0 0 ${
            theme.shape.borderRadius
          }px`,
        },
        "&:last-child": {
          borderRadius: `0 ${theme.shape.borderRadius}px ${
            theme.shape.borderRadius
          }px 0`,
        },
      },
    },
    progressDifficult: {
      backgroundColor: "#FF7575",
    },
    progressMedium: {
      backgroundColor: "#F6C943",
    },
    progressEasy: {
      backgroundColor: "#9FD44A",
    },

    successIcon: {
      color: "#9FD44A",
      fontSize: theme.spacing.unit * 4,
    },
    subSectionPaper: {
      "&:nth-child(2)": {
        background: "#FBFBFB",
        border: "1px solid #DCDCDC",
        borderRadius: 4,
      },
      boxShadow: "unset",
      border: "unset",
      "& svg": {
        display: "none",
      },
    },
    optionContent: {
      "& .btn-delete": {
        visibility: "visible",
      },
      "& p>img": {
        maxWidth: "100%",
      },
    },
    pageSection: {
      float: "right",
      margin: "20px",
    },
    buttonBlock: {
      width: "130",
      height: "30px",
      textAlign: "center",
      margin: "10px 10px",
    },
    scrollSection: {
      overflow: "auto",
      minHeight: "150px",
      maxHeight: "350px",
    },
    paddingSet: {
      padding: "0 15px 0 0",
    },
    popupBlock: {
      width: "450px",
      textAlign: "center",
      "& p": {
        fontSize: "16px",
        "font-weight": "normal",
        lineHeight: "16px",
        textAlign: "center",
        letterSpacing: "0.144385px",
        color: "#000000",
        display: "block",
        paddingTop: "20px",
      },
    },
    attentionTitle: {
      fontSize: "16px",
      "font-weight": "500",
      lineHeight: "15px",
      textAlign: "center",
      letterSpacing: "0.144385px",
      color: "#000000",
      display: "block",
      paddingBottom: "18px",
    },
    customTextarea: {
      paddingTop: "16px",
    },
    viewDetail: {
      color: "#1d7dea",
      textDecoration: "underline",
      padding: 0,
      "&:hover": {
        backgroundColor: "initial",
        textDecoration: "underline",
      },
    },
    overFlow: {
      overflow: "auto",
    },
    addQueue: {
      marginBottom: "10px",
      "& p": {
        padding: "15px",
        height: "initial",
      },
    },

    infoContainer: {
      padding: "6px 10px 0px 0px",
      marginLeft: -10,
      marginRight: 16,
      "&>:first-child": {
        "&>button": {
          height: 25,
        },
      },
    },
    okButton: {
      fontFamily: "Nunito",
      fontStyle: "normal",
      fontWeight: 600,
      fontSize: 14,
      lineHeight: "19px",
      letterSpacing: "0.5px",
      color: "#FFFFFF",
      background: "#1D7DEA",
      padding: "4px 22px",
      width: 150,
      borderRadius: 4,
      "&:hover": {
        background: "#1D7DEA",
      },
    },
    widthSM: {
      maxWidth: 496,
      padding: "0px 54px 0px 40px",
    },
    marginTopSM: {
      marginTop: 12,
    },
    fontSizeSM: {
      fontSize: 12,
    },
    graceCard: {
      padding: "34px 18px 33px",
      background: "#fff",
      borderRadius: 4,
    },
    fontSM: {
      fontStyle: "normal",
      fontWeight: "normal",
      fontSize: 14,
      lineHeight: "16px",
      color: "rgb(51 51 51)",
      padding: 12,
    },
    graceTextField: {
      margin: "-4px 0px",
      "& input": {
        padding: "3px 0px 2px 6px",
        width: 80,
        height: 28,
        background: "rgb(255 255 255)",
        border: "1px solid rgb(223 223 223)",
        borderRadius: 4,
      },
      "& input::-webkit-clear-button, & input::-webkit-outer-spin-button, & input::-webkit-inner-spin-button": {
        display: "block",
        height: 35,
        width: 18,
        padding: "0px 4px",
      },
    },
    labelText: {
      "& :nth-child(2)": {
        fontStyle: "normal",
        fontWeight: "normal",
        fontSize: 16,
        lineHeight: "19px",
        color: "#333333",
        marginTop: 20,
      },
    },
    marginTopMD: {
      margin: "8px 0px 0px",
    },
    whiteBox: {
      height: 65,
      background: "rgb(255 255 255)",
      padding: "13px 12px",
    },
    viewDetailsBtn: {
      padding: "0 0 0 15px",
      color: "#1d7dea",
      backgroundColor: "transparent !important",
      overFlow: {
        overflow: "auto",
      },
      addQueue: {
        marginBottom: "20px",
        "& p": {
          padding: "15px",
          height: "initial",
        },
      },
      tableActions: {
        paddingTop: "10px",
      },
    },
    chip: {
      margin: theme.spacing.unit,
      color: "#60768C",
      backgroundColor: "#fff",
      border: "1px solid #60768C",
      height: "25px",
    },
    filterContainer: {
      display: "flex",
      justifyContent: "flex-end",
      // paddingRight: '25px',
      alignItems: "center",
      paddingTop: "10px",
      "& a": {
        cursor: "pointer",
        textDecoration: "none",
      },
    },
    rowDelete: {
      cursor: "pointer",
      height: "18px",
      width: "18px",
      margin: "0 4px",
    },
    textField: {
      border: "none",
      // borderRadius: "4px",
      fontSize: "14px",
    },
    overflowAuto: {
      overflow: "auto",
      width: "100%",
      padding: "5px 0",
      margin: "4px 0",
      "&::-webkit-scrollbar": {
        width: "5px",
        height: "5px",
      },
      "&::-webkit-scrollbar-track": {
        boxShadow: "inset 0 0 6px rgba(0,0,0,0.00)",
        webkitBoxShadow: "inset 0 0 6px rgba(0,0,0,0.00)",
        backgroundColor: "#787878",
        borderRadius: "50px",
      },
      "&::-webkit-scrollbar-thumb": {
        backgroundColor: "rgba(0,0,0,.1)",
        outline: "1px solid #787878",
      },
    },
    customTableW: {
      minWidth: "140px",
    },
    disabled: {
      opacity: 0.5,
    },
    filterSelect: {
      "& .searchContainer": {
        "& .textElipse": {
          width: "200px",
        },
        "& .optionItem": {
          // '& span:nth-of-type(2)':{
          width: "200px",
          // }
        },
      },
    },
    feedbackHighlight: {
      cursor: "pointer",
      marginRight:5,
      display: "inline-block",
      "&:hover": {
        color: "#1d7dea",
      },
    },
    mb30:{
      marginBottom: 45,
    },
    dFlex:{
      display: 'flex',
    },
    borderTransparent:{
      backgroundColor: 'transparent',
    },
    buttonHeading:{
      fontSize: 16,
      fontWeight: 600,
      color: '#333',
      marginBottom: 10,
    },
    marginb30:{
      marginBottom: 30,
    },
    verticalBorder:{
      borderRight: '1px solid #c2c1c1'
    },
    marginL15:{
      marginLeft: 15,
    },
    editRow:{
      '& td':{
        padding: 0,
      }
    },
    centerImg:{
      textAlign: 'center',
      display: 'block',
    },
    whiteBackgroundLink:{
      padding: '5px 0 !important',
      backgroundColor: '#fff',
    },
    viewMode:{
      padding: '0 10px',
      textAlign: "center",
      paddingTop: "7px !important",
      paddingBottom: "7px !important",
    },

    thViewMode:{
      // paddingLeft: 10,
      paddingLeft: '25px !important',
      textAlign: "center",
      paddingRight: '25px !important',
      paddingTop: "5px !important",
      paddingBottom: "5px !important", 
      '& strong':{
        whiteSpace: 'nowrap',
        '& span':{
          fontSize: 10,
          color: '#999',
        }
      }
    },
    thEditMode:{ 
      paddingLeft: "20px !important",
      paddingRight: "50px !important",
      paddingTop: "5px !important",
      paddingBottom: "5px !important", 
      '& strong':{
        whiteSpace: 'nowrap',
        '& span':{
          fontSize: 10,
          color: '#999',
        }
      }
    },
    whiteBackgroundTotal:{
      backgroundColor: '#fff',
      textAlign: "center",
      padding: '5px 0 !important',
    },
    viewBackground:{
      textAlign: "center",
      padding: '5px 0 !important',
    },
    whiteBackgroundLeft:{
      backgroundColor: '#fff',
      textAlign: 'left',
      '&>div:nth-of-type(1)':{
        marginBottom: 0,
        width: '100%',
      }
    },
    searchContainer: {
      margin: "12px 0px",
      position: "relative",
      width: "394px !important",
      "& img": {
        position: "absolute",
        top:12,
        left:10,
        width:20,
        marginRight: "10px",
      },
      "& input": {
        padding: "8px 10px 8px 40px",
        fontSize:16,
        borderRadius:30,
        border: "0.5px solid rgb(223 223 223)",
        height:44,
        width: "100%",
        "&:focus":{
          outline: "none"
        }
      }
    },
    templateCourseName: {
      marginLeft: theme.spacing.unit,
      marginTop: 9,
      fontSize: 12,
      height: '21px',
      lineHeight: '21px',
      paddingTop: 3,
      "& span:nth-child(1)": {
        maxWidth:250,
        overflow: "hidden",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap",
        display: "inline-block",
        padding: "0 10px",
      }
    },
    tempSummary:{
      display: 'flex',
      alignItems: 'center',
      flexWrap: 'wrap',
      padding: "0 16px 15px",
    },
    summary: {      
      fontWeight: 400,
      fontSize: 16,
      color: '#666',
	  '&:not(:last-child)':{
		  paddingLeft: theme.spacing.unit,
	  },
      "& span": {
        display: "inline-block",
        paddingLeft: "5px",
        fontSize: 16,
		    fontWeight: theme.typography.fontWeightLight,
      },
	  "& strong":{
		  fontWeight: 600,
      color: '#333'
	  },
	  '&:not(:last-child)::after':{
			content: "''",
			width: 4,
			height: 4,
			background: '#DDDDDD',
			borderRadius: '50%',
			display: 'inline-block',
			margin: '0 10px',
			verticalAlign: 2,
		}
    },
    durationTime:{
      '&::before':{
        content: "''",
        width: 4,
        height: 4,
        margin: "0 8px",
        background: "#DDDDDD",
        display: "inline-block",
        borderRadius: "50%",
        verticalAlign: "middle",
      }
    },
    testPaperContainer: {
      width: '100%',
      borderRadius: 4,
      padding: 10,
      border: 1,
      borderStyle: 'solid',
      borderColor: '#DCDCDC',
    },
    testPaperHead: {
      paddingTop: 5,
      paddingBottom: 5,
      borderTop: 0,
      borderLeft: 0,
      borderRight: 0,
      borderBottomWidth: 1,
      borderStyle: 'solid',
      borderColor: '#DCDCDC',
      fontSize: 16,
      color: '#333333',
      marginBottom: 10,
    },
    testPaperField: {
      display: 'flex',
      justifyContent: 'space-between',
      gap: '10px',
    },
    selectedTestType: {
      width: '380px !important',
    },
    disabledTestType: {
      pointerEvents: 'none',
      backgroundColor: '#f8f8f8'
    }
  });

let LIMIT = 10;
let SKIP = 0;
let MAXIMUM_LIMIT_REACHED = false;

interface TestPaperCreateProps extends WithStyles<typeof styles> {
  formData: ContentFormData;
  setSectionCurrentlyEditing: (sectionName: string) => void;
  formDataError: ContentFormDataError;
  handleFormChange: (formData: ContentFormData, sectionName?: string) => void;
  subTypeId: string;
  subType: string;
  contentSubtypeList: Function;
  contentSubtype: any;
  contentsubType: ContentSubType[];
  getContentSubType: Function;
  showMsg: Function;
  history: any;
  eventFired: Function;
  match: any;
  questionData: any;
  backFromQuestion: any;
  updateTestId: (payload: any) => void;
  content: any;
  componentCleanup: Function;
  setModalFunction: Function;
  modalTrigger: Function;
  updateContent: Function;
  isTestAttampted: boolean;
  testAttemptData: any;
  hasMyLibraryQueue: boolean;
  setHasMylibraryQueue: Function;
  templateChanged: Function;
  resetBenchMarkInfo: Function;
  activeTSetting: any;
  getAutoQuestions: Function;
  selectedTempQuestions: ContentData[];
  subjects: any[];
  fetchSubjects: (payload: any) => void;
  updateSubjects: (payload: any) => void;
  fetchGoalLevels: any;
  goalLevels: any;
  sectionAdd: boolean;
  getAutoQuesCount: Function;
  contentCount: any;
  testPaperContentSubtype: any[];
  questionContentSubtype: any[];
  openFeedback: boolean;
  closeFeedback: Function;
  authorType: string;
  contentRequestId: string;
  contentRequestItemId: string;
  addNewFeedback: Function;
  resolveFeedback: Function;
  replyFeedback: Function;
  clickedfeedbackData: any;
  emptyClickedData: Function;
  handleFeedbackResolve: Function;
  feedbackData: any;
  sectionsTouched: Set<string>;
  editRights: string[];
  loadingCount: boolean;
  contentSubtypeByContentTypeCode: (code: string) => void;
  alreadyAddedQuestions: any;
  location: any;
}

enum Distribution {
  QUESTION = 'question',
  SUBJECT = 'subject'
}

interface TestPaperCreateStates {
  isOtherOptionsOpen: boolean;
  isFixedAttempts: boolean;
  courses: CourseData[];
  loadingTemplates: boolean;
  totalTemplatesCount: number;
  templates: TestTemplateBody[];
  newtemplate: TestTemplateBody;
  languages: LanguageListData[];
  viewDetailId: string;
  selectedTemplateId: string;
  selectedSectionId: string;
  courseName: string;
  selectedCourseId: string;
  selectQuestionDialogOpen: boolean;
  selectQuestionDialogData: {
    sectionId: string;
    subSectionId: string;
    quesCodeAllowed: number;
    noOfQuestions: number;
    replaceIndex: number;
    replaceIndexJ: number;
    content_Id: string;
    addedQuestions: ContentData[];
  };
  selectedTempQuestions: ContentData[];
  selectedTrackedQuestionIds: any;
  data: any;
  subjectList: any;
  testQuestionData: any;
  isCollaspableAllowed: any;
  isEdit: boolean;
  preSelectedFilterContent: any;
  isOpen: boolean;
  timerValue: number;
  showDialog: boolean;
  isGraceStudents: boolean;
  isGraceOnlyForAttemptedStudents: boolean;
  showTooltip: any;
  showErrorTooltip: boolean;
  showGraceTooltip: null | string;
  isAddToQueue: boolean;
  disbaleContentList: any;
  isEditTemplateOpen: boolean;
  isNotEditingTemplatetable: boolean;
  isChangeMarkingShemeOpen: boolean;
  graceMraks: number;
  isGraceMarksOverrideActive: boolean;
  isEditMarkingActive: boolean;
  isEditMarkingActive423: boolean;
  disableEditTemplate: boolean;
  markingShemeOverwriteMsg: string;
  ruleId: string;
  isDialogFilter: boolean;
  republishQueue: string;
  isEditMode: boolean;
  templateCurrentlyEditing: TestTemplateBody;
  isQuestioneExceedLimit: boolean;
  courseSyllabusList: any[];
  testTemplateReq: any;
  tesTemplatereqB: TestTemplateBody;
  difficultyLevels: string[];
  difficultyTypes: string[];
  goalLevelId: string;
  selectedConcepts: string[];
  patternType: string;
  selectedPattern: string[];
  standardTemplate: any;
  prevStateTemplate: TestTemplateBody[];
  prevTemplate: TestTemplateBody[];
  isDelete: boolean;
  selectedSubSectionId: string;
  filters: any;
  isMannualSwap: boolean;
  isCreatetabel: boolean;
  toShow: boolean;
  showTemplateNamePopup: boolean;
  generateAutomatic: any;
  subSectionAddedQuestions: any;
  isSelectConceptOpen: boolean;
  isSelectPatternOpen: boolean;
  selectedskill: string[];
  showContentTagFilter: boolean;
  tag: string;
  updatedTestName: string;
  isTestNameChanged: boolean;
  showEditButton: boolean;
  UpdateNameOfTable: boolean;
  activeTypeOfDistribution: Distribution;
  searchQueryTemplate:string;
  expandPanels: {
    [panelName: string]: boolean;
  },
  readlyOnlyPrevYearTest:any,
  showPrevQuesDialog:boolean,
  showYearDropDown:boolean,
  testPaperSpecialPurpose: string,
  bucketsToBeShown: any[],
  populateQuestionSyllabusRef: any,
  autoPopulateConceptsRef: any,
}


let timer: any;
class TestPaperCreate extends Component<
  TestPaperCreateProps,
  TestPaperCreateStates
> {
  templateSubSection: any = {
    name: "",
    negativeMarks: 0,
    positiveMarks: 0,
    partialMarksAllowed: false,
    noOfQuestions: 1,
    quesCodeAllowed: -1,
    partialMarks: 0,
    instruction: "",
  };

  templateSection: any = {
    courseSyllabusId: "",
    name: "",
    autoPickSelection: false,
    totalMarks: 0,
    subSection: [JSON.parse(JSON.stringify(this.templateSubSection))],
  };

  templateRequestB: TestTemplateBody = {
    testTemplateTypeId: "",
    _id: "",
    name: "",
    testTemplateId: "",
    testTemplateName: "",
    courseId: "",
    totalMarks: 0,
    questionsCount: 0,
    noOfSections: 1,
    subSectionsCount: 0,
    testDurationType: "",
    testDurationNumber: 1,
    testSectionLevel: "",
    groupId: "",
    sections: [JSON.parse(JSON.stringify(this.templateSection))],
    isMaster: false,
  };
  newSectionCount: number = 1;
  draggedQustion: any = {};
  currentGraceMarkQuestion: any = null;
  updatedFilterTemplateData: any = null;
  constructor(props: TestPaperCreateProps) {
    super(props);
    this.state = {
      loadingTemplates: false,
      totalTemplatesCount: 0,
      isOtherOptionsOpen: false,
      isFixedAttempts: false,
      courses: [],
      templates: [],
      newtemplate: JSON.parse(JSON.stringify(this.templateRequestB)),
      prevStateTemplate: [],
      prevTemplate: [],
      languages: [],
      viewDetailId: "",
      selectedTemplateId: "",
      selectedSectionId: "",
      courseName: "",
      selectedCourseId: "",
      activeTypeOfDistribution: Distribution.QUESTION,
      selectQuestionDialogOpen: false,
      selectQuestionDialogData: {
        sectionId: "",
        subSectionId: "",
        quesCodeAllowed: -1,
        noOfQuestions: 0,
        replaceIndex: -1,
        replaceIndexJ: -1,
        content_Id: "",
        addedQuestions: [],
      },
      selectedTempQuestions: [],
      selectedTrackedQuestionIds: {},
      data: [],
      subjectList: [],
      testQuestionData: {},
      isCollaspableAllowed: { balance: true },
      isEdit: false,
      preSelectedFilterContent: {},
      testTemplateReq: {},
      tesTemplatereqB: this.templateRequestB,
      isOpen: false,
      timerValue: 0,
      showDialog: false,
      isGraceStudents: true,
      isGraceOnlyForAttemptedStudents: false,
      showTooltip: null,
      showErrorTooltip: false,
      showGraceTooltip: null,
      isAddToQueue: false,
      disbaleContentList: new Set([]),
      isEditTemplateOpen: false,
      isChangeMarkingShemeOpen: false,
      graceMraks: 1,
      isGraceMarksOverrideActive: false,
      isEditMarkingActive: false,
      isEditMarkingActive423: false,
      disableEditTemplate: false,
      markingShemeOverwriteMsg: "",
      ruleId: "",
      isEditMode: false,
      templateCurrentlyEditing: JSON.parse(
        JSON.stringify(this.templateRequestB)
      ),
      isDelete: false,
      republishQueue: "",
      isDialogFilter: false,
      isQuestioneExceedLimit: false,
      courseSyllabusList: [],
      difficultyLevels: [],
      difficultyTypes: [],
      goalLevelId: "",
      selectedConcepts: [],
      patternType: "",
      selectedPattern: [],
      selectedskill: [],
      standardTemplate: {},
      isNotEditingTemplatetable: false,
      selectedSubSectionId: "",
      filters: {},
      isMannualSwap: false,
      isCreatetabel: false,
      toShow: true,
      showTemplateNamePopup: false,
      generateAutomatic: {},
      subSectionAddedQuestions: [],
      isSelectConceptOpen: false,
      isSelectPatternOpen: false,
      showContentTagFilter: false,
      tag: "testName",
      updatedTestName: "",
      isTestNameChanged: false,
      showEditButton: false,
      UpdateNameOfTable: false,
      searchQueryTemplate:'',
      expandPanels: {
        testSyllabus: true,
        testFormat: true,
        testQuestions: true,
        testBalance: true
      },
      readlyOnlyPrevYearTest:{},
      showPrevQuesDialog:false,
      showYearDropDown:false,
      testPaperSpecialPurpose: '',
      bucketsToBeShown: [],
      populateQuestionSyllabusRef: createRef(),
      autoPopulateConceptsRef: createRef()
    };

    this.handleFilter = this.handleFilter.bind(this);
    this.handleNameChange = this.handleNameChange.bind(this);
    this.handleTestTypeChange = this.handleTestTypeChange.bind(this);
    this.handleGoalChange = this.handleGoalChange.bind(this);
    this.handleDescriptionChanged = this.handleDescriptionChanged.bind(this);
    this.handleSettingsPauseChanged = this.handleSettingsPauseChanged.bind(
      this
    );
    this.handleSettingsShuffleChanged = this.handleSettingsShuffleChanged.bind(
      this
    );
    this.handleSettingsChanged = this.handleSettingsChanged.bind(this);
    this.handleTemplateSelect = this.handleTemplateSelect.bind(this);
    this.handleToggleDetailClick = this.handleToggleDetailClick.bind(this);
    this.handleOtherOptionsClick = this.handleOtherOptionsClick.bind(this);
    this.handleNoOfAttemptsChange = this.handleNoOfAttemptsChange.bind(this);
    this.handleTrackSelectedQuestionIds = this.handleTrackSelectedQuestionIds.bind(
      this
    );
    this.handleAddConceptChapterFormChange = this.handleAddConceptChapterFormChange.bind(
      this
    );

    this.handleBackToTestpaperClick = this.handleBackToTestpaperClick.bind(
      this
    );
    this.handleContentSelect = this.handleContentSelect.bind(this);
    this.handleContentSelectAll = this.handleContentSelectAll.bind(this);
    this.handleCheckContentExist = this.handleCheckContentExist.bind(this);
    this.handleAddContentClick = this.handleAddContentClick.bind(this);
    this.handleRemoveQuestion = this.handleRemoveQuestion.bind(this);

    this.handleCreateQuestionClick = this.handleCreateQuestionClick.bind(this);
    this.collapsableSave = this.collapsableSave.bind(this);
    this.collapsablePaperBalance = this.collapsablePaperBalance.bind(this);
    this.handleOnClickOfCreateTemplate = this.handleOnClickOfCreateTemplate.bind(
      this
    );
    this.createData = this.createData.bind(this);
    this.handleClose = this.handleClose.bind(this);
    this.handleGraceChanges = this.handleGraceChanges.bind(this);
    this.handleAllStudentsGrace = this.handleAllStudentsGrace.bind(this);
    this.addGraceMarks = this.addGraceMarks.bind(this);
    this.showTooltip = this.showTooltip.bind(this);
    this.handleRefreshBttn = this.handleRefreshBttn.bind(this);
    this.handleFilterChange = this.handleFilterChange.bind(this);
    this.setGoalLevelId = this.setGoalLevelId.bind(this);
    this.handleTestSubSectionClick = this.handleTestSubSectionClick.bind(this);
    this.saveFilters = this.saveFilters.bind(this);
    this.removeFilters = this.removeFilters.bind(this);
    this.getSubSectionFilters = this.getSubSectionFilters.bind(this);
    this.getAddedQuestions = this.getAddedQuestions.bind(this);
    this.getCurrentSubsection = this.getCurrentSubsection.bind(this);
    this.handleSelectClose = this.handleSelectClose.bind(this);
    this.handleSelectOpen = this.handleSelectOpen.bind(this);
    this.getSubSectionFilters = this.getSubSectionFilters.bind(this);
    this.getFilteredContent = this.getFilteredContent.bind(this);
    this.addNewFeedback = this.addNewFeedback.bind(this);
    this.resolveFeedback = this.resolveFeedback.bind(this);
    this.replyFeedback = this.replyFeedback.bind(this);
    this.closeFeedback = this.closeFeedback.bind(this);
    this.addFeedback = this.addFeedback.bind(this);
    this.handleSerachTemplateChange=_.debounce(this.handleSerachTemplateChange,200);
  }

  handlePanelExpansion = (panelName: string) => () => {
    this.setState(prevState => {
      return {
        ...prevState,
        expandPanels: { ...prevState.expandPanels, [panelName]: !prevState.expandPanels[panelName] }
      }
    })
  }

  componentDidMount() {
    const { formData } = this.props;
    const userD = ACLService.getUserDetailsFromStorage();
    // if (userD.authenticatedUser.clientId._id === fiitJeeMasterClientId) {
    //   this.setState({ showContentTagFilter: true });
    // } else {
    //   const isBranchClient = _.get(
    //     userD,
    //     "authenticatedUser.clientId.isBranchClient",
    //     false
    //   );
    //   if (isBranchClient) {
    //     const masterClientID = _.get(
    //       userD,
    //       "authenticatedUser.clientId.masterClient.id",
    //       ""
    //     );
    //     if (masterClientID === fiitJeeMasterClientId) {
    //       this.setState({ showContentTagFilter: true });
    //     }
    //   }
    // }
    this.props.getContentSubType("question");
    this.props.contentSubtypeByContentTypeCode("testpapers");
    this.props.contentSubtypeByContentTypeCode("question");
    _.isEmpty(this.props.contentSubtype) && this.props.contentSubtypeList();
    const goalType: string = (formData.specialPurposes && formData.specialPurposes[0]) || ''
    courseService
      .list(goalType)
      .then((courses: CourseData[]) => this.setState({ courses }));
    languageServices
      .list()
      .then((languages: LanguageListData[]) => this.setState({ languages }));
    subjectsServices
      .listByGrade()
      .then((subjectList: any) => this.setState({ subjectList }));

    if (formData._id) {
      this.loadTemplates({ testId: formData._id });
    }
    delete formData["subjects"];
    contentService.getActiveListOfDisabled(formData._id).then((res: any) => {
      const list: any = [];
      res.responseObject &&
        res.responseObject.forEach((data: any) => {
          if (data.question) {
            list.push(data.question.contentId);
          }
        });
      this.setState({ disbaleContentList: new Set(list) });
    });
    this.setState({
      ruleId: formData.ruleId,
    });
    if (formData.courseId) {
      let courseId = '';
      if(formData.courseId instanceof Array) {
        courseId = formData.courseId[0]
      }
      this.props.fetchGoalLevels({ params: { courseId: courseId } });
    }
    const currentTestId = _.get(this.props.content, "contentId", "");
    if (currentTestId) {
      this.props.fetchSubjects({ testId: currentTestId });
    }
    if(formData.previousExam){
      this.setState({readlyOnlyPrevYearTest:{...formData.previousExam}});
    }
  }

  componentWillReceiveProps(nextProps: any) {
    let {
      backFromQuestion,
      questionData,
      selectedTempQuestions,
      contentCount,
    } = this.props;
    this.onEdit();
  }

  componentDidUpdate(prevProps: any,prevState:TestPaperCreateStates) {
    if (prevProps.selectedTempQuestions !== this.props.selectedTempQuestions) {
      if(this.props.selectedTempQuestions.length==0){
        this.props.showMsg("No Questions found in this section", "error");
      }
      this.setState(
        { selectedTempQuestions: this.props.selectedTempQuestions},
        () => {
          this.handleAddContentClick(true);
        }
      );
    }
    if (prevProps.clickedfeedbackData !== this.props.clickedfeedbackData) {
      if (!_.isEmpty(this.props.clickedfeedbackData)) {
        this.setState({
          tag: this.props.clickedfeedbackData.tag,
        });
      } else {
        this.setState({
          tag: "testName",
        });
      }
    }
    const prevTestId = _.get(prevProps.content, "contentId", "");
    const currentTestId = _.get(this.props.content, "contentId", "");
    if (prevTestId !== currentTestId) {
      this.props.fetchSubjects({ testId: currentTestId });
    }
  }
  addFeedback(tagName: string) {
    if (!_.isEmpty(this.props.clickedfeedbackData)) {
      this.props.emptyClickedData();
    }
    let clickedfeedbackData =
      this.props.feedbackData && this.props.feedbackData.feedbacksData &&
      this.props.feedbackData.feedbacksData.filter(
        (feedback: any) => feedback.tag === tagName && !feedback.isResolved
      );
    if (clickedfeedbackData && clickedfeedbackData.length > 0) {
      this.props.handleFeedbackResolve(clickedfeedbackData[0]);
    }
    setTimeout(() => {
      if (this.props.openFeedback) {
        this.setState({
          tag: tagName,
        });
      }
    }, 200);
  }

  closeFeedback() {
    this.props.closeFeedback();
  }
  addNewFeedback(text: string) {
    let feedbackData = {
      contentRequestId: this.props.contentRequestId,
      contentId: _.get(this.props.content, `content._id`, ""),
      comment: text,
      role: this.props.authorType,
      tag: this.state.tag,
      contentRequestItemId: this.props.contentRequestItemId,
      contentType: "test",
    };
    this.props.addNewFeedback(feedbackData);
    this.props.closeFeedback("resolve");
  }
  resolveFeedback(id: string) {
    let feedbackData = {
      feedbackId: id,
      role: this.props.authorType,
      contentRequestItemId: this.props.contentRequestItemId,
      contentType: "test",
    };
    this.props.resolveFeedback(feedbackData);
    this.props.closeFeedback("resolve");
  }
  replyFeedback(id: string, text: string) {
    let feedbackData = {
      feedbackId: id,
      contentRequestId: this.props.contentRequestId,
      contentId: _.get(this.props.content, `content._id`, ""),
      comment: text,
      role: this.props.authorType,
      tag: this.state.tag,
      contentRequestItemId: this.props.contentRequestItemId,
      contentType: "test",
    };
    this.props.replyFeedback(feedbackData);
    this.props.closeFeedback("resolve");
  }

  componentWillUnmount() {}

  editTemplate = () => {
    this.setState({ isEditTemplateOpen: true });
  };

  onEdit() {
    let { formData } = this.props;
    let {
      data,
      selectQuestionDialogData,
      selectedTempQuestions,
      isEdit,
      selectedSectionId,
      selectedSubSectionId,
      courseName,
      selectedCourseId,
      courses,
      selectedTrackedQuestionIds,
    } = this.state;
    data = [];
    let { sectionId, subSectionId, quesCodeAllowed } = selectQuestionDialogData;
    if (!_.isEmpty(formData._id) && !isEdit) {
      let ruleId = formData.ruleId;
      if (formData.data) {
        _.map(formData.data.sections, (section) => {
          _.map(section.subSection, (subS) => {
            let a: any = {
              sectionId: section._id,
              subSectionId: subS._id,
              quesCodeAllowed: subS.quesCodeAllowed,
            };
            let questions = [];
            if (subS.questions && subS.questions.length > 0) {
              questions = subS.questions.map((q: any) => {
                const key = q.content_Id.content_Id;
                if (!selectedTrackedQuestionIds.hasOwnProperty(key)) {
                  selectedTrackedQuestionIds[key] = {
                    quesCodeAllowed: subS.quesCodeAllowed,
                    subSectionId: subS._id,
                    content_Id: q.content_Id.content_Id,
                  };
                }
                return q.content_Id;
              });
            }
            a["questions"] = questions;
            data.push(a);
          });
        });
        selectedSectionId = _.get(formData, "data.sections[0]._id", "");
        selectedSubSectionId = _.get(
          formData,
          "data.sections[0].subSection[0]._id",
          ""
        );
        this.setState({
          data,
          selectedTrackedQuestionIds,
          isEdit: true,
          selectedTemplateId: ruleId,
          selectedSectionId: selectedSectionId,
          selectedSubSectionId: selectedSubSectionId,
          isFixedAttempts:
            _.get(formData, "settings.noOfAttempts", 0) == 0 ? false : true,
        });
      }
      let isValid =
        formData.name && formData.name.trim().length > 0 ? true : false;
      this.collapsableSave("name", isValid);
      isValid = false;
      isValid =
        formData.courseId && formData.courseId.length > 0 ? true : false;
      this.collapsableSave("goal", isValid);
      this.collapsableSave("selectedTemplateId", !_.isEmpty(formData.ruleId));

      //set coursename

      if (_.get(formData, "courseId[0]", "")) {
        let c = courses.filter(
          (c) => c._id == _.get(this.props.formData, "courseId[0]", "")
        );
        if (c.length > 0) {
          courseName = c[0].courseType.name;
          selectedCourseId = c[0]._id;
        }
        this.setState({ courseName, selectedCourseId: _.get(formData, "courseId[0]", "") });
      }
    }
  }

  loadTemplates(apiParams: any, skip: number = 0) {
    const { testId, courseId } = apiParams;
    const {content} = this.props;
    this.setState({ loadingTemplates: true });
    const{searchQueryTemplate}=this.state;
    const params: any = {
      limit: LIMIT,
      skip,
      searchQuery:searchQueryTemplate
    };
    if (testId) {
      params["testId"] = testId;
    } else if (courseId) {
      params["courseId"] = courseId;
    }
    params['typeId'] = (content.content || {}).testTemplateTypeId;
    params['type'] = content.contentSubTypeCode;

    templateServices.list(params).then((response: any[]) => {
      let nonStandardTemplates = response.filter(({ isMaster }) => !isMaster);
      let standardTemplate = _.head(
        response.filter(({ isMaster }) => isMaster)
      );
      const recordCountIndex = nonStandardTemplates.findIndex(
        ({ recordCount }) => recordCount !== undefined
      );

      if (recordCountIndex !== -1) {
        this.setState({
          totalTemplatesCount:
            nonStandardTemplates[recordCountIndex].recordCount,
        });
        nonStandardTemplates = nonStandardTemplates.filter(
          (_, i) => i !== recordCountIndex
        );
      }

      this.setState((prevState) => {
        const newStandardTemplate =
          skip === 0 && !standardTemplate
            ? {}
            : standardTemplate || prevState.standardTemplate;
        return {
          templates: nonStandardTemplates,
          loadingTemplates: false,
          standardTemplate: newStandardTemplate,
        };
      }, () => {
        this.prepareTestQuestionData();

      });
      // setTimeout(()=>{
      // },000)
    });
  }

  handleNameChange = (evt: any) => {
    let { formData } = this.props;
    let { name, value } = evt.target;
    formData.name = value;
    formData.displayName = value;
    formData.testDisplayName = {
      ...formData.testDisplayName,
      name: value,
    };
    formData.settings = {
      ...formData.settings,
      testType: this.props.subType,
    };
    /* TODO: uncomment later when data loss issue fix for all functions */
    // this.props.updateContent(formData)
    this.props.handleFormChange(formData, "basicInfo");
    this.collapsableSave(name, value && value.trim().length > 0 ? true : false);
    // this.props.eventFired("basicInfo", statusType.edit);
  };

  handleTestTypeChange = (evt: any) => {
    let { formData } = this.props;
    let { prefix, value } = evt.target;
    formData.testDisplayName = {
      ...formData.testDisplayName,
      prefix: value,
    };
    this.props.handleFormChange(formData, "basicInfo");
    const valueLength = value && value.trim().length;
    this.collapsableSave(prefix, valueLength);
  };

  handleGoalChange = (evt: any) => {
    let { formData } = this.props;
    let { courses } = this.state;
    let { name, value } = evt.target;
    formData.courseId = [value];
    formData.groupId = value;
    formData.data = {};
    formData.ruleId = null;
    const courseName = evt.target[evt.target.selectedIndex].getAttribute(
      "data-optionname"
    );
    if(_.get(formData,"previousExam.year",'')){
      const courseObj=courses.find((c)=>c._id===value);
    if(courseObj){  
      formData.previousExam={...formData.previousExam,id:courseObj.courseType.id,name:courseName}; 
     }
    }
    this.setState({
      courseName: courseName,
      selectedCourseId: value,
      selectedSectionId: "",
      selectedSubSectionId: "",
      selectedTemplateId: "",
      data: [],
      newtemplate: JSON.parse(JSON.stringify(this.templateRequestB)),
      isCreatetabel: false,
      toShow: true,
    });
    // this.props.updateContent(formData)
    this.props.handleFormChange(formData, "basicInfo");
    this.collapsableSave(name, value && value.length > 0 ? true : false);
    // setTimeout(() => {
    // 	this.props.eventFired("basicInfo", statusType.edit);
    // }, 3000);
    // Load templates on goal change
    this.loadTemplates({ courseId: value });

    this.props.fetchGoalLevels({
      params: { courseId: value },
    });
  };

  handleDescriptionChanged = (evt: any) => {
    let { formData } = this.props;
    formData["description"] = evt.target.value;
    // this.props.updateContent(formData)
    this.props.handleFormChange(formData, "basicInfo");
  };

  handleLanguageChange = (evt: any) => {
    let { formData } = this.props;
    if (_.isEmpty(formData.settings.language)) {
      formData.settings.language.push(evt.target.value);
    } else {
      formData.settings.language[0] = evt.target.value;
    }

    this.props.handleFormChange(formData, "basicInfo");
  };

  handleOtherOptionsClick = (e: any) =>
    this.setState({ isOtherOptionsOpen: !this.state.isOtherOptionsOpen });

  handleNoOfAttemptsChange = (e: any, value: string) => {
    this.setState({ isFixedAttempts: _.isEqual("fixed", value) });
    this.handleSettingsChanged("noOfAttempts", { target: { value: 0 } });
  };

  handleAddConceptChapterFormChange(updateFormData: any) {
    let { formData } = this.props;
    formData.subjects = updateFormData;
    // this.props.updateContent(formData)
    this.props.handleFormChange(formData);
    // this.props.eventFired("conceptCode", statusType.edit);
  }

  handleToggleDetailClick = (viewDetailId: string) => {
    this.setState({
      viewDetailId,
      isNotEditingTemplatetable: true,
    });
    if (this.state.isEditMode) {
      this.handleEditDetail();
    }
  };

  handleCancleClick = (viewDetailId: string) => {
    this.setState({
      isEditMode: false,
      viewDetailId: "",
      templateCurrentlyEditing: JSON.parse(
        JSON.stringify(this.templateRequestB)
      ),
    });
    // this.setState({viewDetailId,
    //  templates: this.state.prevStateTemplate
    // });
    // if(this.state.isEditMode){
    // this.handleEditDetail();
    // }
  };
  handleTemplateSelect = (selectedTemplateId: string, _template?: any) => {
    let { templates, data } = this.state;
    let { formData } = this.props;
    // check if section name is empty
    let isEmptyAnySctionName = false;
    if (_template.sections) {
      _template.sections.forEach((element: any) => {
        if (element.name.trim() == "") {
          isEmptyAnySctionName = true;
        }
      });
    }
    if (isEmptyAnySctionName) {
      alert("Please fill all section name's in template setting.");
      return;
    }
    let filterTemplate: any = _.filter(templates, (template) =>
      _.isEqual(template._id, selectedTemplateId)
    );
    if (filterTemplate && filterTemplate.length > 0) {
      filterTemplate = filterTemplate[0];
      formData.ruleId = filterTemplate._id;
      formData.settings.duration = filterTemplate.testDurationNumber;
      formData.data = filterTemplate;
      _.map(formData.data.sections, (section, i) => {
        if (
          section.hasOwnProperty("courseSyllabusId") &&
          section.courseSyllabusId &&
          section.courseSyllabusId.hasOwnProperty("name")
        ) {
          section.name = section.courseSyllabusId.name;
        }
      });
      if (
        formData.status == "PUBLISHED" &&
        this.state.ruleId != formData.ruleId
      ) {
        this.props.resetBenchMarkInfo();
        this.props.templateChanged(true);
      }
    } else {
      //Reset template setting
      formData.ruleId = null;
      data = [];
      formData.data = [];
      const selectedTemplate = templates.filter((template: any) => template._id === this.state.selectedTemplateId);
      if (selectedTemplate.length > 0) {
        selectedTemplate[0].sections.forEach((section: any) => {
          (section.subSection || []).forEach((subSection: any) => {
            delete subSection.questions;
          })
        })
      }
      this.props.templateChanged(false);
    }
    // this.props.updateContent(formData)
    this.props.handleFormChange(formData, "testFormat");
    if (!_template || !_template._id) {
      this.setState((prevState) => {
        const newTemplates = prevState.templates.filter(
          ({ isMaster }) => !isMaster
        );
        return {
          ...prevState,
          templates: newTemplates,
        };
      });
    }
    this.setState({
      selectedTemplateId,
      selectedSectionId: "",
      selectedSubSectionId: "",
      data,
      selectedTrackedQuestionIds: {},
    });
    if (filterTemplate && (filterTemplate._id || filterTemplate.length > 0)) {
      this.handleTestSubSectionClick(
        filterTemplate.sections[0],
        filterTemplate.sections[0].subSection[0],
        this
      );
    }
    this.collapsableSave("selectedTemplateId", true);
    // this.props.eventFired("testFormat", statusType.edit);
  };

  handleSettingsChanged = (setKey: string, evt: any) => {
    let { formData } = this.props;
    formData = {
      ...formData,
      settings: {
        ...formData.settings,
        [setKey]: evt.target.value,
      },
    };
    // this.props.updateContent(formData)
    this.props.handleFormChange(formData, "basicInfo");
  };

  handleSettingsShuffleChanged = (
    setKey: string,
    evt: any,
    checked: boolean
  ) => {
    let { formData } = this.props;
    formData = {
      ...formData,
      settings: {
        ...formData.settings,
        shuffle: {
          ...formData.settings.shuffle,
          [setKey]: checked,
        },
      },
    };
    // this.props.updateContent(formData)
    this.props.handleFormChange(formData, "basicInfo");
  };

  handleSettingsPauseChanged = (evt: any, value: string) => {
    let { formData } = this.props;
    formData.settings.pause = _.isEqual(value, "yes");
    // this.props.updateContent(formData)
    this.props.handleFormChange(formData, "basicInfo");
  };

  handleSettingsTestVariationsChanged = (evt: any, value: string) => {
    let { formData } = this.props;
    formData.settings.variation = _.isEqual(value, "yes");
    this.props.handleFormChange(formData, "basicInfo");
  };

  handleSettingsAutoProtoringChanged = (evt: any, value: string) => {
    const { formData } = this.props;
    formData.settings.isProctoringOff = !_.isEqual(value, FORM.YES.VALUE);
    this.props.handleFormChange(formData, TESTPAPER_PROPERTY.BASIC_INFO);
  };

  handleTestSectionClick = (value: any, evt: any) =>
    this.setState({ selectedSectionId: value });
  handleTestSubSectionClick = (section: any, subSection: any, evt: any) => {
    const sectionId = _.get(section, "_id", "");
    const subSectionId = _.get(subSection, "_id", "");
    const courseSyllabusId = _.get(
      section,
      "courseSyllabusId._id",
      section.courseSyllabusId
    );
    const questionCode = _.get(subSection, "quesCodeAllowed");
    const filters = this.getSubSectionFilters(subSectionId);
    const {
      difficultyLevels,
      difficultyTypes,
      goalLevelId,
      contentTags,
    } = filters;
    let skill: string[] = [],
      patternType: string = "",
      patterns: string[] = [],
      concepts: string[] = [];
    if (this.state.showContentTagFilter && contentTags.length > 0) {
      contentTags.forEach((element: any) => {
        if (element.name == "Concept Categorization") {
          concepts = element.values;
        } else if (element.name == "Objective Pattern Type") {
          patternType = "Objective";
          patterns = element.values;
        } else if (element.name == "Subjective Pattern Type") {
          patternType = "Subjective";
          patterns = element.values;
        } else {
          skill = element.values;
        }
      });
    }

    const groupId = this.props.formData.groupId;
    const { formData } = this.props;
    let reqBody = {
      questionCode,
      courseSyllabusIds: [courseSyllabusId],
      groupId,
      difficultyLevels,
      difficultyTypes,
      goalLevelId,
      bucketType: (formData.specialPurposes && formData.specialPurposes[0]) || CONTENT_SECTION_KEYS.GLORIFIRE,
    };
    this.props.getAutoQuesCount(reqBody);
    this.setState({
      selectedSubSectionId: subSectionId,
      selectedSectionId: sectionId,
      difficultyLevels,
      difficultyTypes,
      goalLevelId,
      selectedskill: [...skill],
      selectedConcepts: [...concepts],
      selectedPattern: [...patterns],
      patternType: patternType,
    });
  };

  handleChooseLibraryClick = (
    selectedQuestion: any = {},
    quesCodeAllowed: number,
    subSectionId: string,
    sectionId: string,
    noOfQuestions: number,
    replaceIndex: number,
    replaceIndexJ: number,
    evt: any,
    isMannualSwap: boolean,
    question?: any,
    addedQuestions: any = []
  ) => {
    let { data, generateAutomatic, subSectionAddedQuestions } = this.state;
    let s =
      data && data.length > 0
        ? data.filter(
            (ob: any) =>
              ob.subSectionId == subSectionId && ob.sectionId == sectionId
          )
        : [];

    let {
      courseName,
      templates,
      selectedSectionId,
      selectedTemplateId,
    } = this.state;
    let { formData } = this.props;
    let filteredTemplate = templates.filter((t) => t._id == selectedTemplateId);
    let sections = _.get(filteredTemplate, "[0].sections", []).filter(
      (s: any) => s._id == sectionId
    );
    let testSectionLevel = _.get(
      filteredTemplate,
      "[0].testSectionLevel",
      "course"
    );
    let autoPickSection = _.get(sections, "[0].autoPickSelection", false);
    let courseSyllabusId = _.get(sections, "[0].courseSyllabusId", "");
    let nextLevel = "subject";

    if (testSectionLevel == "subject") {
      nextLevel = "sub-subject";
    } else if (testSectionLevel == "sub-subject") {
      nextLevel = "chapter";
    } else if (testSectionLevel == "chapter" || testSectionLevel == "concept") {
      nextLevel = "concept";
    }

    let goalsDriller: any = {};
    if (testSectionLevel != "none" && !autoPickSection) {
      goalsDriller = {
        level: nextLevel,
        course: {
          _id: _.get(formData, "courseId[0]", ""),
          name: courseName,
        },
      };

      goalsDriller[testSectionLevel] = {
        _id: _.get(courseSyllabusId, "_id", courseSyllabusId),
        name: _.get(courseSyllabusId, "name", ""),
      };
      _.get(courseSyllabusId, "ancestors", []).forEach((a: any) => {
        goalsDriller[a.type == "sub-subject" ? "subSubject" : a.type] = {
          _id: _.get(a, "_id", ""),
          name: _.get(a, "name", ""),
        };
      });
    } else if (autoPickSection) {
      goalsDriller = {
        level: "subject",
        course: {
          _id: _.get(formData, "courseId[0]", ""),
          name: courseName,
        },
      };
    }
    let bucketsToBeShown: any = [];
    const userDetails = ACLService.getUserDetailsFromStorage();
    const permissions = ((userDetails.authenticatedUser || {}).role || {}).permissions || [];
    const testPaperType = (formData.specialPurposes || [])[0] || CONTENT_SECTION_KEYS.GLORIFIRE;
    const testPermissionSecions = (permissions.find((permission: any) => permission.module === MODULE_TO_TEST_PERMISSION_MAP[testPaperType]) || {}).sections || [];
    bucketsToBeShown.push(testPaperType);
    testPermissionSecions.forEach((section: any) => {
      if (Object.values(CONTENT_SECTION_KEYS).includes(section.module) && !bucketsToBeShown.includes(section.module)) {
        bucketsToBeShown.push(section.module);
      }
    })
    let preSelectedFilterContent = {
      contentMenu: "all",
      goalsDriller: goalsDriller,
      getLastTestDetails: true,
      contentFilterData: [
        {
          filterValue: "contentType",
          isSelected: true,
          filters: [
            {
              filterValue: "question",
              isSelected: true,
              filters: [
                {
                  filterValue: quesCodeAllowed,
                  isSelected: true,
                  filters: [],
                },
              ],
            },
          ],
        },
        {
          filterValue: 'status',
          isSelected: true,
          filters: [
            {
            filterValue: 'PUBLISHED',
            isSelected: true,
            filters: [],
            }
          ]
        }
      ],
    };
    let content_Id = "";
    if (replaceIndex !== -1) {
      content_Id = selectedQuestion[0] && selectedQuestion[0].content_Id;
    }
    if (isMannualSwap) {
      noOfQuestions = 1;
      subSectionAddedQuestions = s[0].questions;
    } else {
      if (this.getAddedQuestions(data, sectionId, subSectionId) == 0) {
        generateAutomatic[subSectionId] = false;
      }
    }

    this.setState({
      preSelectedFilterContent,
      selectQuestionDialogOpen: true,
      selectQuestionDialogData: {
        sectionId,
        subSectionId,
        quesCodeAllowed,
        noOfQuestions,
        replaceIndex,
        replaceIndexJ,
        content_Id,
        addedQuestions,
      },
      isMannualSwap,
      selectedTempQuestions: isMannualSwap
        ? []
        : Object.keys(selectedQuestion).length > 0
        ? selectedQuestion
        : [],
      subSectionAddedQuestions,
      bucketsToBeShown: CONTENT_SECTION_TYPES.filter(bucket => bucketsToBeShown.includes(bucket.value)),
      testPaperSpecialPurpose: testPaperType,

    });
  };
  handleCreateQuestion=(
    selectedQuestion: any = {},
    quesCodeAllowed: number,
    subSectionId: string,
    sectionId: string,
    noOfQuestions: number,
    replaceIndex: number,
    replaceIndexJ: number,
    evt: any,
    isMannualSwap: boolean,
    question?: any,
    addedQuestions: any = []
  )=>{
   
  }
  handleBackToTestpaperClick = (evt: any) =>
    this.setState({ selectQuestionDialogOpen: false });

  handleCheckContentExist = (content_Id: string) => {
    const { selectedTrackedQuestionIds, selectQuestionDialogData } = this.state;
    const {
      subSectionId: selectedSubSectionId,
      content_Id: selectedContentId,
      addedQuestions,
      quesCodeAllowed: selectedQuestCode,
      replaceIndex,
    } = selectQuestionDialogData;
    const addedContent_Ids: any = new Set(
      addedQuestions.map((content: ContentData) =>
        content.content_Id ? content.content_Id : content._id
      )
    );
    addedContent_Ids.delete(selectedContentId);
    const key = content_Id;

    let isContentExist = false;

    if (selectedTrackedQuestionIds.hasOwnProperty(key)) {
      const quesCodeAllowed = selectedTrackedQuestionIds[key].quesCodeAllowed;
      const subSectionId = selectedTrackedQuestionIds[key].subSectionId;
      if (replaceIndex !== -1) {
        if (
          content_Id !== selectedContentId &&
          addedContent_Ids.has(content_Id)
        ) {
          isContentExist = true;
        }
      } else {
        if (selectedQuestCode == quesCodeAllowed) {
          if (selectedSubSectionId !== subSectionId) {
            isContentExist = true;
          }
        }
      }
    }
    return isContentExist;
  };

  handleTrackSelectedQuestionIds(selectedQuestions: any) {
    const { selectedTrackedQuestionIds, selectQuestionDialogData } = this.state;
    const { quesCodeAllowed, subSectionId } = selectQuestionDialogData;

    selectedQuestions.forEach((question: any) => {
      const key = question.content_Id || question._id;
      if (!selectedTrackedQuestionIds.hasOwnProperty(key)) {
        selectedTrackedQuestionIds[key] = {
          quesCodeAllowed,
          subSectionId,
          content_Id: key,
        };
      }
    });
    this.setState({ selectedTrackedQuestionIds });
  }

  //when select question
  handleContentSelect = (selectedQuestions: any) => {
    this.handleTrackSelectedQuestionIds(selectedQuestions);
    this.setState({ selectedTempQuestions: selectedQuestions });
    this.props.setSectionCurrentlyEditing("testQuestions");
  };

  handleContentSelectAll = (selectedQuestions: any) => {
    this.handleTrackSelectedQuestionIds(selectedQuestions);
    this.setState({ selectedTempQuestions: selectedQuestions });
    this.props.setSectionCurrentlyEditing("testQuestions");
  };

  handleAddContentClick = (selectedTemp: any = false) => {
    let {
      selectQuestionDialogData,
      selectedTempQuestions,
      data,
      isCollaspableAllowed,
      isMannualSwap,
      subSectionAddedQuestions,
    } = this.state;

    let {
      sectionId,
      subSectionId,
      quesCodeAllowed,
      noOfQuestions,
      replaceIndex,
      replaceIndexJ,
      content_Id,
    } = selectQuestionDialogData;

    if (isMannualSwap) {
      selectedTemp = false;
      if (selectedTempQuestions.length > 0) {
        for (let indx = 0; indx < subSectionAddedQuestions.length; indx++) {
          if (
            subSectionAddedQuestions[indx]._id == selectedTempQuestions[0]._id
          ) {
            this.setState(
              {
                selectQuestionDialogOpen: true,
              },
              () => {
                this.props.showMsg("Content Already Added in list", "error");
              }
            );
            return;
          }
        }
      }
    }
    let selectedTempQuestionsCopy: any = [];
    selectedTempQuestions = selectedTempQuestions.sort((a, b) =>
      a.contentId.localeCompare(b.contentId)
    );
    const content_Ids: any = new Set(
      selectedTempQuestions.map((content: ContentData) =>
        content.content_Id ? content.content_Id : content._id
      )
    );

    const passageDataSet = new Set();
    selectedTempQuestions.forEach((questions) => {
      if (
        questions.masterVariationQuestionId &&
        !questions.hasOwnProperty("content_Id")
      ) {
        questions.content_Id = questions._id + "";
        if (!questions._id.includes("question")) {
          questions._id = questions._id + "question";
        }
      }
      if (questions.passageData) {
        questions.passageData.forEach(({ id, content_Id }: any) => {
          const identifier = id || content_Id;
          passageDataSet.add(identifier);
        });
      }
      // else{

      // }
    });

    selectedTempQuestions.forEach((content, index) => {
      if (content_Ids.has(content.content_Id)) {
        if (content.passageData && content.passageData.length > 0) {
          content.passageData.forEach((data: any) => {
            const identifier = data.id || data.content_Id;
            if (!passageDataSet.has(identifier)) {
              return;
            }

            data._id = identifier;
            if (!data._id.includes("question")) {
              data._id = data._id + "question";
            }

            data.content_Id = identifier;
            delete data["id"];
            selectedTempQuestionsCopy.push({ ...content, ...data });
            passageDataSet.delete(identifier);
          });
        } else {
          selectedTempQuestionsCopy.push({ ...content });
        }
        content_Ids.delete(content.content_Id);
      }
    });

    if (
      selectedTempQuestionsCopy &&
      noOfQuestions &&
      noOfQuestions >= selectedTempQuestionsCopy.length
    ) {
      let tempData = data.filter(
        (ob: any) =>
          ob.subSectionId == subSectionId && ob.sectionId == sectionId
      );
      if (tempData && tempData.length == 0 && replaceIndex == -1) {
        data.push({
          sectionId,
          subSectionId,
          quesCodeAllowed: quesCodeAllowed,
          questions: selectedTempQuestionsCopy.sort((a: any, b: any) =>
            a.contentId.localeCompare(b.contentId)
          ),
        });
      } else {
        if (replaceIndex == -1) {
          data.map((ob: any) => {
            if (ob.subSectionId == subSectionId && ob.sectionId == sectionId) {
              ob.questions = selectedTempQuestionsCopy.sort((a: any, b: any) =>
                a.contentId.localeCompare(b.contentId)
              );
              return ob;
            }
          });
        } else {
          if (
            replaceIndex != -1 &&
            replaceIndexJ != -1 &&
            selectedTempQuestionsCopy.length > 0
          ) {
            if (quesCodeAllowed == 5) {
              let questions = data[replaceIndex]["questions"];
              const groupedQuestions = questions.filter(
                (content: ContentData) => content.content_Id == content_Id
              );
              questions = _.differenceBy(
                questions,
                groupedQuestions,
                "content_Id"
              );
              data[replaceIndex]["questions"] = [
                ...questions,
                ...selectedTempQuestionsCopy,
              ];
            } else {
              // data[replaceIndex]["questions"].splice(
              // 	replaceIndexJ,
              // 	1,
              // 	selectedTempQuestionsCopy[0]
              // );
              data.map((ob: any) => {
                if (
                  ob.subSectionId == subSectionId &&
                  ob.sectionId == sectionId
                ) {
                  ob.questions.splice(
                    replaceIndexJ,
                    1,
                    selectedTempQuestionsCopy[0]
                  );
                }
              });
            }
          }
        }
      }
      //Expand balance if any question is added
      !isCollaspableAllowed["balance"] && this.collapsableSave("balance", true);

      this.setState({
        data: data,
        selectQuestionDialogOpen: false,
        selectedTempQuestions: [],
        isMannualSwap: false,
      });
      // selectedTemp?this.state.selectedTempQuestions
    } else {
      if (selectedTemp) this.props.showMsg("No Questions Found ", "error");
      else
        this.props.showMsg(`Kindly select ${noOfQuestions} Questions`, "error");
    }
    this.prepareTestQuestionData();
  };

  orderBySerialNo(sections: any) {
    let qSerialNo = 0;
    const _sections =
      (sections &&
        sections.map((section: any) => {
          section && section.subSection && section.subSection.map((subSec: any) => {
            subSec.questions &&
              subSec.questions.map((quest: any, i: number) => {
                qSerialNo = qSerialNo + 1;
                quest.questionSerialNo = qSerialNo;
                if (typeof quest.content_Id !== "string") {
                  quest.content_Id.questionSerialNo = qSerialNo;
                }
              });
            return subSec;
          });
          return section;
        })) ||
      [];

    return _sections;
  }

  prepareTestQuestionData() {
    let { formData } = this.props;
    let {
      selectedTemplateId,
      templates,
      selectQuestionDialogData,
      data,
    } = this.state;
    const { sectionId, subSectionId } = selectQuestionDialogData;
    let filterTemplate: any = _.filter(templates, (template) =>
      _.isEqual(template._id, selectedTemplateId)
    );

    if (filterTemplate && filterTemplate.length > 0) {
      filterTemplate = filterTemplate[0];

      let sections = _.map(filterTemplate.sections, (section: any) => {
        if (section._id == sectionId) {
          _.map(section.subSection, (subSec: any, j: number) => {
            if (subSec._id == subSectionId) {
              let tempData = data.filter(
                (ob: any) =>
                  ob.subSectionId == subSectionId && ob.sectionId == sectionId
              );
              if (tempData && tempData.length > 0) {
                subSec["questions"] = _.map(
                  tempData[0].questions,
                  (ob, k: number) => {
                    return {
                      qId: ob.content_Id,
                      // questionSerialNo: k+1,
                      content_Id: ob,
                    };
                  }
                );
              }

              return subSec;
            } else {
              let tempData = data.filter(
                (ob: any) =>
                  ob.subSectionId == subSec._id && ob.sectionId == section._id
              );
              if (tempData && tempData.length > 0) {
                subSec["questions"] = _.map(
                  tempData[0].questions,
                  (ob, k: number) => {
                    return {
                      qId: ob.content_Id,
                      // questionSerialNo: k+1,
                      content_Id: ob,
                    };
                  }
                );
              }
            }
          });
          return section;
        } else {
          let _section = formData.data.sections.find(
            (o: any) => o._id == section._id
          );

          if (_section) {
            if (section.courseSyllabusId) {
              // adding for edit template usecase
              _section.courseSyllabusId = _.get(
                section,
                "courseSyllabusId._id",
                section.courseSyllabusId
              );
              // _section.courseSyllabusId = section.courseSyllabusId._id
            }
            section = _section;
          }
          return section;
        }
      });
      filterTemplate.sections = this.orderBySerialNo(sections);
      formData.data = filterTemplate;
    }
    this.state.autoPopulateConceptsRef.current();
    // this.props.updateContent(formData)
    this.props.handleFormChange(formData, "testQuestions");
    // setTimeout(() => {
    // 	this.props.eventFired("testQuestions", statusType.edit);
    // }, 3000);
  }

  handleRemoveQuestion = (
    removeContentId: string,
    i: any,
    j: any,
    sectionId: string,
    subSectionId: string,
    passageData: any[],
    quesCodeAllowed: any
  ) => {
    let { data, selectedTrackedQuestionIds } = this.state;
    let { formData } = this.props;
    if (data && data.length > 0) {
      let indexD = data.findIndex(
        (ob: any) =>
          ob.sectionId == sectionId && ob.subSectionId == subSectionId
      );

      if (indexD != -1) {
        let passageQuestion: string[] = [];
        if (quesCodeAllowed == 5) {
          let indexToDelete: any[] = [];
          let questions = data[indexD]["questions"];
          // const groupedQuestions = questions.filter((content: ContentData) => content.content_Id == removeContentId)
          // questions = _.differenceBy(questions, groupedQuestions, 'content_Id')

          let selectedQuestion = questions[j];
          const contentIds: string[] = [];
          selectedQuestion.passageData.forEach((item: any, index: number) => {
            let id = item._id || item.id;
            if (id.includes("question")) {
              id = id.substring(0, id.length - 8);
            }
            contentIds.push(id);
          });

          const newData = [...data];
          newData[indexD] = {
            ...newData[indexD],
            questions: questions.filter((content: ContentData) => {
              let contentId = content._id;
              if (contentId.includes("question")) {
                contentId = contentId.substring(0, contentId.length - 8);
              }
              return !contentIds.includes(contentId);
            }),
          };
          passageQuestion = contentIds;
          this.setState({ data: newData, selectedTempQuestions: [] });
        } else {
          data[indexD]["questions"].splice(j, 1);
          this.setState({
            data: data,
            selectedTempQuestions: [],
          });
        }
        if (
          formData.data &&
          formData.data.sections &&
          formData.data.sections.length > 0
        ) {
          let indexD = formData.data.sections.findIndex(
            (ob: any) => ob._id == sectionId
          );
          if (indexD != -1) {
            if (quesCodeAllowed == 5) {
              let formQuestion =
                formData.data.sections[indexD]["subSection"][i]["questions"];
              const filteredQuestions = formQuestion.filter((item: any) => {
                const qId = _.get(item, "qId._id", item.qId);
                return !passageQuestion.includes(qId);
              });
              formData.data.sections[indexD]["subSection"][i][
                "questions"
              ] = filteredQuestions;
            } else {
              formData.data.sections[indexD]["subSection"][i][
                "questions"
              ].splice(j, 1);
            }
            formData.data.sections = this.orderBySerialNo(
              formData.data.sections
            );

            // this.props.updateContent(formData)
            // this.props.handleFormChange(formData);
            // setTimeout(() => {
            // 	this.props.eventFired("testQuestions", statusType.edit);
            // }, 3000);
          }
        }
      }
      const key = removeContentId;
      if (selectedTrackedQuestionIds.hasOwnProperty(key)) {
        delete selectedTrackedQuestionIds[key];
      }
    }
    this.props.setSectionCurrentlyEditing("testQuestions");
  };

  removeQuestionSyllabus = (questionId: string) => {
    let { formData } = this.props;
    formData.subjects = formData.subjects.filter(
      (syllabus: { qId: any }) => syllabus.qId !== questionId
    );
    // this.props.updateContent(formData)
    this.props.handleFormChange(formData);
  };

  getQuestionTypeName = (quesCodeAllowed: number) =>
    _.get(
      _.find(
        this.props.contentSubtype,

        ["code", quesCodeAllowed.toString()]
      ),
      "name",
      ""
    );

  getSubSectionMarks = (subSection: SubSection) => {
    const noOfQuestionsToConsiderForMarks = getNoOfQuestionsToConsiderForMarks(
      subSection
    );
    return noOfQuestionsToConsiderForMarks * subSection.positiveMarks;
  };

  mandatoryQuestionCount = (template: TestTemplateBody) => {
    const MandatoryQuestionCount = getMandatoryQuestionCount(template);
    return MandatoryQuestionCount;
  };
  jeeMainsFields = (template: TestTemplateBody) => {
    const jeeMainsField = toShowJEEMainSpecificFields(template);
    return jeeMainsField;
  };
  handleNewTemplateChange = (sections: section[]) => {
    this.setState((prevState) => {
      const newTemplate = { ...prevState.newtemplate };
      newTemplate.sections = sections;

      return {
        ...prevState,
        newtemplate: newTemplate,
      };
    });
  };
  handleCurrentlyEditingTemplateChange = (sections: section[]) => {
    this.setState((prevState) => {
      const templateCurrentlyEditing = {
        ...prevState.templateCurrentlyEditing,
      };
      templateCurrentlyEditing.sections = sections;
      return {
        ...prevState,
        templateCurrentlyEditing,
      };
    });
  };
  getSubSectionName = (section: any = {}) => {
    /* if (section.autoPickSelection) {
			return "Any Topic";
		}
		else */

    if (section.courseSyllabusId && section.courseSyllabusId.name) {
      return section.courseSyllabusId.name;
    } else if (section.name) {
      return section.name;
    }

    return "";
  };

  getSectionIcon(templateSubSection: any, isTouched: boolean) {
    let { data } = this.state;
    let { classes } = this.props;
    let status = 0;

    if (
      templateSubSection.questions &&
      templateSubSection.noOfQuestions == templateSubSection.questions.length
    )
      status = 1;

    if (status == 0 && isTouched) {
      return (
        <ErrorIcon
          className={classes.tabRootIcon}
          style={{ color: "#FF4A4A" }}
        />
      );
    } else if (status == 1) {
      return (
        <SuccessIcon2
          className={classes.tabRootIcon}
          style={{ color: "#379D0B" }}
        />
      );
    }

    return "";
  }

  showChooseFromLibraryButton(subSection: any) {
    let { data } = this.state;

    //count subsection question count
    let qnc = subSection.noOfQuestions;
    let qc = 0;
    data.forEach((ss: any) => {
      if (subSection._id != ss.subSectionId) {
        return;
      }
      qc += ss.questions.length;
    });

    if (qc != 0 && qc == qnc) {
      // && qc == qnc
      return false;
    }

    return true;
  }

  getCurrentUrl(_id: string) {
    let { match } = this.props;
    let url = `/content/edit/${match.params.type}/${
      match.params.subType
    }/${_id}${match.params.type}`;
    return url;
  }

  // handleCreateTemplateClick = () => {
  // 	this.props.componentCleanup().then((res: any) => {
  // 		let url = this.getCurrentUrl(res && res._id);
  // 		window.location.href = `/test-template?refUrl=${url}`;
  // 	})
  // }
  handleOnClickOfCreateTemplate = () => {
    // setTimeout(() => {
    // 	this.handleCreateTemplateClick();
    // }, 3000);
    const courseId = this.state.selectedCourseId;
    this.getCourseSyllabus(courseId);
    this.setState((prevState) => {
      const newtemplate = { ...prevState.newtemplate };
      newtemplate.courseId = courseId;
      return {
        ...prevState,
        isCreatetabel: !prevState.isCreatetabel,
        toShow: !prevState.toShow,
        newtemplate,
        viewDetailId: "",
      };
    });
  };
  handleCancelButton = () => {
    this.setState({
      newtemplate: JSON.parse(JSON.stringify(this.templateRequestB)),
      isCreatetabel: false,
      toShow: true,
      showEditButton: false,
      UpdateNameOfTable: false,
    });
  };
  handleStandardTemplateEditCancel = () => {
    this.setState({
      templateCurrentlyEditing: JSON.parse(
        JSON.stringify(this.templateRequestB)
      ),
    });
  };
  handleStandardTemplateCreateCopy = () => {
    // Save standard template
    let template: TestTemplateBody = JSON.parse(
      JSON.stringify(this.state.templateCurrentlyEditing)
    );

    template = this.patchTemplateForSaving(template);

    saveTestTemplate(template).then((createdTemplate: TestTemplateBody) => {
      this.setTemplateAsSelected(createdTemplate);
      this.setState({
        templateCurrentlyEditing: JSON.parse(
          JSON.stringify(this.templateRequestB)
        ),
      });
    });
  };
  onStandardTemplateSelect = () => {
    const { standardTemplate } = this.state;
    const courseId = this.state.standardTemplate.courseId;
    this.getCourseSyllabus(courseId);

    this.setTemplateAsSelected(standardTemplate);
  };
  handleEditingStandardTemplate = () => {
    const courseId = this.state.standardTemplate.courseId;
    this.getCourseSyllabus(courseId);

    this.setState((prevState) => {
      const templateCurrentlyEditing = JSON.parse(
        JSON.stringify(prevState.standardTemplate)
      );
      templateCurrentlyEditing.name = '';
      return {
        ...prevState,
        templateCurrentlyEditing,
        viewDetailId: "",
      };
    });
  };

  toggleTemplateNamePopup = () => {
    this.setState((prevState) => {
      return {
        ...prevState,
        showTemplateNamePopup: !prevState.showTemplateNamePopup,
      };
    });
  };
  toggleEditTemplateButton = () => {
    this.setState((prevState) => {
      return {
        ...prevState,
        showEditButton: false,
      };
    });
  };

  checkQuestionCreationPermission = () => {
    const {content} = this.props;
    const specialPurposes = Object.values(CONTENT_SECTION_KEYS).filter(value => (content.specialPurposes || []).includes(value));
    const testSpecialPurpose = specialPurposes.length ? specialPurposes[0] : CONTENT_SECTION_KEYS.GLORIFIRE;
    const creationNotPermitted = !ACLService.checkModulePermission(MODULE_TO_QUESTION_PERMISSION_MAP[testSpecialPurpose], USER_RIGHTS.CREATE)
    return creationNotPermitted;
  }

  handleCreateQuestionClick = (
    quesCodeAllowed: number,
    sectionIndex: any,
    subSectionIndex: any
  ) => {
    this.props.componentCleanup().then((res: any) => {
      const defaultFromData = getDefaultFormData(quesCodeAllowed.toString());
      let url = this.getCurrentUrl(res && res._id);
      defaultFromData.questionCode = quesCodeAllowed;
      const {content} = this.props;
      defaultFromData.specialPurposes = Object.values(CONTENT_SECTION_KEYS).filter(value => (content.specialPurposes || []).includes(value));
      
      (this.props.questionContentSubtype || []).forEach((st: any) => {
        if (quesCodeAllowed == parseInt(st.code)) {
          defaultFromData.questionType = st.name;
        }
      });
      const currUrl = new URL(window.location.href);
      const autoFillConceptToggleValue = (currUrl.searchParams.get('autoFillConcepts') === 'true');
      let params = `refUrl=${url}&sectionIndex=${sectionIndex}&subSectionIndex=${subSectionIndex}`;
      const isTeacherUser = checkForTeacherUser(null, true);
      if (isTeacherUser) {
        params += '&publishDirectly=true';
      }
      params += `&autoFillConcepts=${autoFillConceptToggleValue}`;
      contentService
        .save("", "question", defaultFromData, false)
        .then((res: any) => {
          window.open(
            `/content/edit/question/${quesCodeAllowed}
											/${res.responseObject._id}question?${params}`,
            "_self"
          );
        });
    });
  };
  getCourseSyllabus(value: any) {
    testTemplateService.getAllSyllabus(value, "subject").then((res) => {
      this.setState({ courseSyllabusList: res });
    });
  }
  collapsablePaperBalance(name: string) {
    let { isCollaspableAllowed } = this.state;
    isCollaspableAllowed[name] = _.isUndefined(isCollaspableAllowed[name])
      ? true
      : !isCollaspableAllowed[name];
    this.setState({ isCollaspableAllowed });
  }

  collapsableSave(name: string, isActive: boolean) {
    let { isCollaspableAllowed } = this.state;
    isCollaspableAllowed[name] = isActive;
    this.setState({ isCollaspableAllowed });
  }

  collapsableEvent(name: string) {
    const { isCollaspableAllowed, courses } = this.state;
    const { formData } = this.props;

    if (name == "goal") {
      if (_.isEmpty(_.find(courses, ["_id", _.get(formData, "courseId[0]")]))) {
        return true;
      }
    }

    if (!["goal", "name"].includes(name))
      return isCollaspableAllowed[name] ? false : true;
    else
      return isCollaspableAllowed["goal"] && isCollaspableAllowed["name"]
        ? false
        : true;
  }

  expandPanel(name: string) {
    const { isCollaspableAllowed } = this.state;
    if (!["goal", "name"].includes(name))
      return isCollaspableAllowed[name] ? true : false;
    else
      return isCollaspableAllowed["goal"] && isCollaspableAllowed["name"]
        ? true
        : false;
  }

  calcChartPercentage = (data: any, value: any) => {
    const sum = (a: number, b: number) => a + b;
    return Math.round((value / data.series.reduce(sum)) * 100) + "%";
  };

  drawPieChart(
    selector: any,
    data: any,
    options: any,
    responsiveOptions: any,
    chartLabels: string[],
    chartPercent: string[] = [],
    type: string = "other"
  ) {
    try {
      let chartArray: any = [["name", "value"]];
      data.series.map((data: any) => {
        data["name"] = data.name + " Questions";
        let seriesValue: any = Object.values(data);
        chartArray.push(seriesValue);
      });
      if (type == "question") {
        return (
          <>
            <Chart
              width={"500px"}
              height={"300px"}
              chartType="PieChart"
              loader={<div>Loading Chart...</div>}
              data={chartArray}
              options={{
                title: "",
                legend: "none",
                backgroundColor: "transparent",
                //colors: ['#9FD44A', '#F6C943', '#FF7575', '#1D7DEA', '#50B7BA'],
                fontName: "Nunito",
                fontSize: 16,
                chartArea: {
                  left: 0,
                  top: 10,
                  width: "100%",
                  height: "90%",
                },
              }}
              rootProps={{ "data-testid": "1" }}
            />
          </>
        );
      } else if (type == "section") {
        return (
          <>
            <Chart
              width={"500px"}
              height={"300px"}
              chartType="PieChart"
              loader={<div>Loading Chart...</div>}
              data={chartArray}
              options={{
                title: "",
                legend: "none",
                backgroundColor: "transparent",
                colors: ["#9FD44A", "#F6C943", "#FF7575", "#1D7DEA", "#50B7BA"],
                fontName: "Nunito",
                fontSize: 16,
                chartArea: {
                  left: 0,
                  top: 10,
                  width: "100%",
                  height: "90%",
                },
              }}
              rootProps={{ "data-testid": "1" }}
            />
          </>
        );
      } else {
        // 				return chartLabels[index] + " " + value + " "; // Need to fix this.
      }
    } catch (e) {}
  }

  getDifficultyAbilityDistribution = () => {
    const { data } = this.state;
    let count: any = {};

    _.forEach(data, ({ questions }) =>
      _.forEach(questions, (question) => {
        const tempLevel = _.get(question, "difficultyLevel", []);
        const tempType = _.get(question, "difficultyType", []);

        tempLevel.forEach((l: string) => {
          //single
          if (!count[l]) {
            count[l] = 0;
          }
          count[l]++;

          //combine
          tempType.forEach((t: string) => {
            if (!count[`${l}-${t}`]) {
              count[`${l}-${t}`] = 0;
            }
            count[`${l}-${t}`]++;

            if (!count[`total-${l}`]) {
              count[`total-${l}`] = 0;
            }
          });
        });

        tempType.forEach((t: string) => {
          //single
          if (!count[t]) {
            count[t] = 0;
          }
          count[t]++;

          //combine
          tempType.forEach((l: string) => {
            if (!count[`${l}-${t}`]) {
              count[`${l}-${t}`] = 0;
            }
            count[`${l}-${t}`]++;
          });
        });
      })
    );

    //total type
    count["total-type"] =
      _.get(count, "hard-conceptual", 0) +
      _.get(count, "medium-conceptual", 0) +
      _.get(count, "easy-conceptual", 0) +
      _.get(count, "hard-analytical", 0) +
      _.get(count, "medium-analytical", 0) +
      _.get(count, "easy-analytical", 0) +
      _.get(count, "hard-intuitive", 0) +
      _.get(count, "medium-intuitive", 0) +
      _.get(count, "easy-intuitive", 0);

    //total level
    count["total-level"] = count["total-type"];

    count["total-hard"] =
      _.get(count, "hard-conceptual", 0) +
      _.get(count, "hard-analytical", 0) +
      _.get(count, "hard-intuitive", 0);

    count["total-medium"] =
      _.get(count, "medium-conceptual", 0) +
      _.get(count, "medium-analytical", 0) +
      _.get(count, "medium-intuitive", 0);

    count["total-easy"] =
      _.get(count, "easy-conceptual", 0) +
      _.get(count, "easy-analytical", 0) +
      _.get(count, "easy-intuitive", 0);

    count["total-conceptual"] =
      _.get(count, "hard-conceptual", 0) +
      _.get(count, "medium-conceptual", 0) +
      _.get(count, "easy-conceptual", 0);

    count["total-analytical"] =
      _.get(count, "hard-analytical", 0) +
      _.get(count, "medium-analytical", 0) +
      _.get(count, "easy-analytical", 0);

    count["total-intuitive"] =
      _.get(count, "hard-intuitive", 0) +
      _.get(count, "medium-intuitive", 0) +
      _.get(count, "easy-intuitive", 0);

    //type
    count["p-hard"] = this.getDistributionPercentage(
      count,
      count["total-hard"],
      count["total-type"]
    );
    count["p-medium"] = this.getDistributionPercentage(
      count,
      count["total-medium"],
      count["total-type"]
    );
    count["p-easy"] = this.getDistributionPercentage(
      count,
      count["total-easy"],
      count["total-type"]
    );

    count["p-conceptual"] = this.getDistributionPercentage(
      count,
      count["total-conceptual"],
      count["total-level"]
    );
    count["p-analytical"] = this.getDistributionPercentage(
      count,
      count["total-analytical"],
      count["total-level"]
    );
    count["p-intuitive"] = this.getDistributionPercentage(
      count,
      count["total-intuitive"],
      count["total-level"]
    );
    return count;
  };

  getDistributionPercentage1(
    difficultyAbilityDistribution: any,
    key1: string,
    key2: string
  ) {
    let p = 0;
    p =
      (_.get(difficultyAbilityDistribution, key1, 0) /
        _.get(difficultyAbilityDistribution, key2, 1)) *
      100;
    p = !isNaN(p) ? Math.round(p) : 0;
    return p;
  }

  getDistributionPercentage(
    difficultyAbilityDistribution: any,
    val1: number,
    val2: number
  ) {
    let p = 0;
    p = (val1 / val2) * 100;
    p = !isNaN(p) ? Math.round(p) : 0;
    return p;
  }

  generateQuestionTypeChartData = () => {
    const { data } = this.state;
    let chartData: any[] = [];
    let chartPercent: any[] = [];
    let chartLabels: any[] = [];
    let returnChartData: any[] = [];
    let dataHolder: any = {};

    let total = 0;
    _.forEach(data, (dataItem) => {
      const questionName = this.getQuestionTypeName(dataItem.quesCodeAllowed);
      const questionsCount = _.get(dataItem, "questions", []).length;
      chartData.push({ name: questionName, value: questionsCount });
      chartLabels.push(questionName);
      total += questionsCount;
    });

    if (!_.isEmpty(chartData)) {
      chartLabels = [];
      _.forEach(chartData, (dataItem) => {
        if (dataHolder.hasOwnProperty(dataItem.name)) {
          dataHolder[dataItem.name] =
            dataHolder[dataItem.name] + dataItem.value;
        } else {
          dataHolder[dataItem.name] = dataItem.value;
        }
      });

      for (let key in dataHolder) {
        returnChartData.push({ name: key, value: dataHolder[key] });
        chartLabels.push(key);
      }

      returnChartData.forEach((d: any) => {
        chartPercent.push(((d.value / total) * 100).toFixed(0));
      });

      return { returnChartData, chartLabels, chartPercent };
    }
    return { chartData, chartLabels, chartPercent };
  };

  generateSubjectWiseChartData = (templates: any) => {
    const { data } = this.state;
    let chartData: any[] = [];
    let chartPercent: any[] = [];
    let chartLabels: any[] = [];
    let returnChartData: any[] = [];
    let dataHolder: any = {};
    let subjectName: string = "";

    if (!_.isEmpty(templates)) {
      _.map(data, (dataItem) => {
        const section = _.find(templates[0].sections, [
          "_id",
          dataItem.sectionId,
        ]);
        subjectName = this.getSubSectionName(section);
        if (subjectName.length > 20) {
          subjectName = subjectName.substr(0, 17) + "...";
        }
        const questionsCount = _.get(dataItem, "questions", []).length;
        chartData.push({ name: subjectName, value: questionsCount });
      });
    }

    let total = 0;
    if (!_.isEmpty(chartData)) {
      _.map(chartData, (dataItem, index) => {
        if (dataHolder.hasOwnProperty(dataItem.name)) {
          dataHolder[dataItem.name] =
            dataHolder[dataItem.name] + dataItem.value;
        } else {
          dataHolder[dataItem.name] = dataItem.value;
        }
        total += dataItem.value;
      });

      for (let key in dataHolder) {
        returnChartData.push({ name: key, value: dataHolder[key] });
        chartLabels.push(key);
      }

      //calculate percent
      returnChartData.forEach((d: any) => {
        chartPercent.push(((d.value / total) * 100).toFixed(0));
      });

      return { returnChartData, chartLabels, chartPercent };
    }
    chartLabels.push(subjectName);

    return { chartData, chartLabels, chartPercent };
  };

  testPaperQuestionSuccess = (templates: any) => {
    const { data } = this.state;
    const templateQuestionsCount = _.get(templates[0], "questionsCount", 0);
    let addedQuestionsCount = 0;

    _.map(data, (dataItem) => {
      if (dataItem.questions.length)
        addedQuestionsCount += dataItem.questions.length;
    });

    if (
      addedQuestionsCount > 0 &&
      addedQuestionsCount === templateQuestionsCount
    )
      return true;
    return false;
  };
 
  handlePreviousTestChange=(e:any)=>{
    const {name,value}=e.target;
    const {formData}=this.props;
    const {courses,readlyOnlyPrevYearTest}=this.state;
    
    if(name=="previousTest"){
      if(value=='yes'){
        let id=_.get(formData,"groupId","");
        let name='';
        if(id){
          let selectedCourse=courses.find((c)=>c.groupId===id);
          if(selectedCourse){
            name=selectedCourse.courseType.name;
            id=selectedCourse.courseType.id||'';
          }
        }
       const temp=_.get(formData,"previousExam",{}); 
        formData.previousExam={...temp,id:id,name:name};
        formData.updateQuestionsPreviousExam=true;
        this.setState({showYearDropDown:true})
      }else{
          delete formData.previousExam;
          let showPrevQuesDialog=false;
          if(readlyOnlyPrevYearTest && readlyOnlyPrevYearTest.id){
            showPrevQuesDialog=true;
          }
        this.setState({showPrevQuesDialog,showYearDropDown:false});  
      } 
    }
    else if(name=="year"){
       formData.previousExam={...formData.previousExam,year:value};
    }
    else if(name=="updateQuesPrevYear"){
      if(value=='yes'){
        formData.updateQuestionsPreviousExam=true;
        delete formData.previousExam;
      }
      this.setState({showPrevQuesDialog:false});
    }
    this.props.handleFormChange(formData,"basicInfo");  
  }
  renderPreviousTest=()=>{
    const{classes,formData}=this.props;
    const{showPrevQuesDialog,showYearDropDown}=this.state;
    const currentYear=new Date().getFullYear() 
    const yearsArray= Array(14).fill(undefined).map((_, idx) => currentYear-(idx));
    return (
     <> 
      <Grid item sm={6}>
      <div className={classes.borderFieldBox}>
        <div className={classes.boxHeading}>
          <Typography variant="subtitle2">Is this is a previous year test?</Typography>
        </div>
        <div className={classes.boxField}>
          <RadioGroup
            name="previousTest"
            value={
              (showYearDropDown||_.get(formData,"previousExam.year"))? "yes" : "no"
            }
            onChange={this.handlePreviousTestChange.bind(this)}
            classes={{
              root: classes.testRadioGroup,
            }}
            row
          >
            <FormControlLabel
              control={
                <Radio
                  color="primary"
                  classes={{ root: classes.testRadioRoot }}
                />
              }
              label="Yes"
              value="yes"
            />
            <FormControlLabel
              control={
                <Radio
                  color="primary"
                  classes={{ root: classes.testRadioRoot }}
                />
              }
              label="No"
              value="no"
            />
          </RadioGroup>
        </div>
        {(showYearDropDown||_.get(formData,"previousExam.year",'')) && <div className={classes.boxField}>
                  <MyPATSelect
                    inputId="language"
                    name="year"
                    value={
                      _.get(formData, "previousExam.year","")
                    }
                    onChange={this.handlePreviousTestChange.bind(this)}
                    fullWidthControl
                  >
                    <option value="">Select Year</option>
                    {_.map(yearsArray, (y, index) => (
                      <option key={index} value={""+y}>
                        {y}
                      </option>
                    ))}
                  </MyPATSelect>
                </div>}
      </div>
    </Grid>
     {showPrevQuesDialog && <MyPATDialog
         dialogOpen={showPrevQuesDialog}
         otherDialogProps={{
           fullWidth: true,
           maxWidth: 'sm',
         }}
         customDialogActions={
           <>
             <RadioGroup
            name="updateQuesPrevYear"
            onChange={this.handlePreviousTestChange.bind(this)}
            classes={{
              root: classes.testRadioGroup,
            }}
            row
          >
            <FormControlLabel
              control={
                <Radio
                  color="primary"
                  classes={{ root: classes.testRadioRoot }}
                />
              }
              label="Yes"
              value="yes"
            />
            <FormControlLabel
              control={
                <Radio
                  color="primary"
                  classes={{ root: classes.testRadioRoot }}
                />
              }
              label="No"
              value="no"
            />
          </RadioGroup>
           </>
         }
       >
         <Typography variant="body1">
           <strong>Do you want to remove previous year marking from the questions too?</strong>
         </Typography>
      </MyPATDialog>
     } 
    </> 
    );
  }
  onDragStart(
    evt: any,
    index: number,
    section: any,
    subSection: any,
    question: any
  ) {
    this.draggedQustion = {
      index,
      section,
      subSection,
      question,
    };
    const { selectQuestionDialogData } = this.state;
    selectQuestionDialogData["sectionId"] = section._id;
    selectQuestionDialogData["subSectionId"] = subSection._id;
    this.setState({
      selectQuestionDialogData,
    });
    evt.dataTransfer.effectAllowed = "move";
    evt.dataTransfer.setData("text/html", evt.target.parentNode);
    evt.dataTransfer.setDragImage(evt.target.parentNode, 20, 20);
  }

  onDragOver(e: any, index: number, subSection: any) {
    e.preventDefault();
  }

  onDropOver(e: any, index: number, subSection: any) {
    e.preventDefault();
    const { data } = this.state;
    let formSubSection = data.filter(
      (d: any) => d.subSectionId == subSection._id
    );

    //if on same div return
    // if (this.draggedQustion.subSection._id != subSection._id || this.draggedQustion.index == index) {
    // 	return;
    // }
    // if (this.draggedQustion.question._id == formSubSection[0].questions[index]._id) {
    // 	this.draggedQustion.index = index;
    // 	return;
    // }

    let questions: any = formSubSection[0].questions;
    // let draggingQuestion = questions[this.draggedQustion.index];
    // questions = questions.filter((q: any, i: number) => this.draggedQustion.index != i);
    const draggedQuestion = questions[this.draggedQustion.index];
    questions[this.draggedQustion.index] = questions[index];
    questions[index] = draggedQuestion;
    // questions.splice(index, 0, draggingQuestion);

    //assign altered object
    formSubSection[0].questions = questions;

    this.prepareTestQuestionData();
  }

  onDragEnd = () => {
    this.draggedQustion = {};
  };

  changeQuestionIndex = (
    e: any,
    index: number,
    section: any,
    subSection: any
  ) => {
    const { data } = this.state;
    let toIndex = parseInt(e.target.value);
    let formSubSection = data.filter(
      (d: any) => d.subSectionId == subSection._id
    );
    let questions: any = formSubSection[0].questions;
    let draggingQuestion = questions[index];
    let replacingQuestion = questions[toIndex];
    questions = questions.filter(
      (q: any, i: number) => index != i && toIndex != i
    );
    if (toIndex > index) {
      questions.splice(index, 0, replacingQuestion);
      questions.splice(toIndex, 0, draggingQuestion);
    } else {
      questions.splice(toIndex, 0, draggingQuestion);
      questions.splice(index, 0, replacingQuestion);
    }

    //assign altered object
    formSubSection[0].questions = questions;
    const { selectQuestionDialogData } = this.state;
    selectQuestionDialogData["sectionId"] = section._id;
    selectQuestionDialogData["subSectionId"] = subSection._id;
    this.setState({
      selectQuestionDialogData,
    });
    this.prepareTestQuestionData();
  };

  getSelectedTemplateList() {
    let { formData } = this.props;
    let { templates, selectedTemplateId } = this.state;
    let filteredTemplates: TestTemplateBody[] = [];

    if (_.isUndefined(_.get(formData, "courseId[0]"))) {
      filteredTemplates = templates;
    } else {
      filteredTemplates = templates;
    }

    if (!_.isEmpty(selectedTemplateId)) {
      filteredTemplates = _.filter(filteredTemplates, [
        "_id",
        selectedTemplateId,
      ]);
    }

    return filteredTemplates;
  }

  getBasicInformation = () => {
    const {
      classes,
      formData,
      formDataError,
      clickedfeedbackData,
      sectionsTouched
    } = this.props;
    const {
      isOtherOptionsOpen,
      courses,
      isFixedAttempts,
      showErrorTooltip,
      languages,
    } = this.state;
    return (
      <div className={`${classes.borderBox} ${classes.subQuestionBox}`}>
        <Grid
          container
          spacing={16}
          className={isOtherOptionsOpen ? classes.mb2x : ""}
        >
          <Grid item sm={12}>
            <div className={classes.testPaperContainer}>
              <div className={classes.testPaperHead}>Test Paper Name</div>
              <div className={classes.testPaperField}>
                <div className={classes.selectedTestType}>
                  <MyPATTextField
                      label={formData && formData.testTemplate && formData.testTemplate.type === TEST_TYPES_TEMPLATE.DEFAULT ? TEST_TYPES_TEMPLATE.SELECTED_TEST_TYPE : TEST_TYPES_TEMPLATE.TEST_TYPE}
                      inputId="testType"
                      name="testType"
                      value={formData && formData.testDisplayName && formData.testDisplayName.prefix || '-'}
                      onChange={this.handleTestTypeChange.bind(this)}
                      className={formData && formData.testTemplate && formData.testTemplate.type === TEST_TYPES_TEMPLATE.DEFAULT ? classes.disabledTestType : ''}
                      fullWidthControl={true}
                    />
                  </div>
                  <MyPATTextField
                    label="Test Name"
                    inputId="name"
                    name="name"
                    value={formData && formData.testDisplayName && formData.testDisplayName.name}
                    onChange={this.handleNameChange.bind(this)}
                    required
                    fullWidthControl
                    error={formDataError["title"].error && sectionsTouched.has("basicInfo")}
                    errorText={formDataError["title"].errorText}
                    placeholder="Enter the name of the test"
                  />
              </div>
            </div>
          </Grid>
          <Grid item sm={12}>
            <MyPATSelect
              label="Goal"
              inputId="goal"
              name="goal"
              disabled={
                (this.props.formData &&
                  this.props.formData.status === "PUBLISHED") ||
                false
              }
              value={formData.groupId ? formData.groupId : ""}
              onChange={this.handleGoalChange.bind(this)}
              required
              fullWidthControl
              error={formDataError["content"].error && sectionsTouched.has("basicInfo")}
              errorText={formDataError["content"].errorText}
            >
              <option value="">Select</option>
              {_.map(courses, (course, index) => (
                <option
                  value={course.groupId}
                  data-optionname={course.courseType.name}
                  key={index}
                >
                  {course.courseType.name}
                </option>
              ))}
            </MyPATSelect>
          </Grid>
          <Grid item xs={12}>
            <MyPATTextArea
              label="Description"
              inputId="description"
              name="description"
              placeholder="Describe the test and its purpose..."
              value={formData.description || ""}
              onChange={this.handleDescriptionChanged}
              rows="5"
              multiline
              fullWidthControl
            />
          </Grid>
          <Grid item xs={12}>
            <Button
              color="primary"
              size="small"
              onClick={this.handleOtherOptionsClick.bind(this)}
            >
              {isOtherOptionsOpen
                ? "- HIDE OTHER OPTIONS"
                : "+ SHOW OTHER OPTIONS"}
            </Button>
          </Grid>
        </Grid>

        <Collapse in={isOtherOptionsOpen}>
          <Grid container spacing={16}>
            <Grid item sm={6}>
              <div className={classes.borderFieldBox}>
                <div className={classes.boxHeading}>
                  <Typography variant="subtitle2">
                    Number of Attempts
                  </Typography>
                </div>
                <div className={classes.boxField}>
                  <RadioGroup
                    name="numberOfAttempts"
                    value={!isFixedAttempts ? "unlimited" : "fixed"}
                    classes={{
                      root: classes.testRadioGroup,
                    }}
                    onChange={this.handleNoOfAttemptsChange.bind(this)}
                    row
                  >
                    <FormControlLabel
                      control={
                        <Radio
                          color="primary"
                          classes={{ root: classes.testRadioRoot }}
                        />
                      }
                      label="Unlimited"
                      value="unlimited"
                    />
                    <FormControlLabel
                      control={
                        <Radio
                          color="primary"
                          classes={{ root: classes.testRadioRoot }}
                        />
                      }
                      label="Fixed Attempts"
                      value="fixed"
                    />
                  </RadioGroup>
                </div>
                {isFixedAttempts ? (
                  <div
                    className={`${classes.boxField} ${
                      classes.noOfAttemptsSelect
                    }`}
                  >
                    <MyPATTextField
                      type="number"
                      inputProps={{ min: "0" }}
                      value={_.get(formData, "settings.noOfAttempts", 0)}
                      onChange={this.handleSettingsChanged.bind(
                        this,
                        "noOfAttempts"
                      )}
                    />
                    <Typography variant="caption" color="textSecondary">
                      No. of attempts
                    </Typography>
                  </div>
                ) : (
                  ""
                )}
              </div>
            </Grid>

            <Grid item sm={6}>
              <div className={classes.borderFieldBox}>
                <div className={classes.boxHeading}>
                  <Typography variant="subtitle2">Shuffle</Typography>
                </div>
                <div className={classes.boxField}>
                  <FormGroup
                    row
                    classes={{
                      root: classes.testCheckboxGroup,
                    }}
                  >
                    {/* <FormControlLabel
                      control={
                        <Checkbox
                          color="primary"
                          classes={{ root: classes.testCheckboxRoot }}
                          checked={
                            !_.isUndefined(
                              _.get(formData, "settings.shuffle.sections")
                            )
                              ? formData.settings.shuffle.sections
                              : false
                          }
                          onChange={this.handleSettingsShuffleChanged.bind(
                            this,
                            "sections"
                          )}
                          value="sections"
                        />
                      }
                      label="Sections"
                    /> */}
                    <FormControlLabel
                      control={
                        <Checkbox
                          color="primary"
                          classes={{ root: classes.testCheckboxRoot }}
                          checked={
                            !_.isUndefined(
                              _.get(formData, "settings.shuffle.questions")
                            )
                              ? formData.settings.shuffle.questions
                              : false
                          }
                          onChange={this.handleSettingsShuffleChanged.bind(
                            this,
                            "questions"
                          )}
                          value="questions"
                        />
                      }
                      label="Questions"
                    />
                    <FormControlLabel
                      control={
                        <Checkbox
                          color="primary"
                          classes={{ root: classes.testCheckboxRoot }}
                          checked={
                            !_.isUndefined(
                              _.get(formData, "settings.shuffle.answer")
                            )
                              ? formData.settings.shuffle.answer
                              : false
                          }
                          onChange={this.handleSettingsShuffleChanged.bind(
                            this,
                            "answer"
                          )}
                          value="answer"
                        />
                      }
                      label="Options"
                      value="options"
                    />
                  </FormGroup>
                </div>
              </div>
            </Grid>

            <Grid item sm={6}>
              <div className={classes.borderFieldBox}>
                <div className={classes.boxHeading}>
                  <Typography variant="subtitle2">Test Pause</Typography>
                </div>
                <div className={classes.boxField}>
                  <RadioGroup
                    name="testPause"
                    value={
                      formData.settings && formData.settings.pause
                        ? "yes"
                        : "no"
                    }
                    onChange={this.handleSettingsPauseChanged.bind(this)}
                    classes={{
                      root: classes.testRadioGroup,
                    }}
                    row
                  >
                    <FormControlLabel
                      control={
                        <Radio
                          color="primary"
                          classes={{ root: classes.testRadioRoot }}
                        />
                      }
                      label="Yes"
                      value="yes"
                    />
                    <FormControlLabel
                      control={
                        <Radio
                          color="primary"
                          classes={{ root: classes.testRadioRoot }}
                        />
                      }
                      label="No"
                      value="no"
                    />
                  </RadioGroup>
                </div>
              </div>
            </Grid>

            <Grid item sm={6}>
              <div className={classes.borderFieldBox}>
                <div className={classes.boxHeading}>
                  <Typography variant="subtitle2">Language</Typography>
                </div>
                <div className={classes.boxField}>
                  <MyPATSelect
                    inputId="language"
                    name="language"
                    value={
                      _.isUndefined(_.get(formData, "settings.language[0]"))
                        ? ""
                        : formData.settings.language[0]
                    }
                    onChange={this.handleLanguageChange.bind(this)}
                    fullWidthControl
                  >
                    <option value="">Select</option>
                    {_.map(languages, (language, index) => (
                      <option key={language._id + index} value={language.name}>
                        {language.name}
                      </option>
                    ))}
                  </MyPATSelect>
                </div>
              </div>
            </Grid>
           {this.renderPreviousTest()}
           <Grid item sm={6}>
              <div className={classes.borderFieldBox}>
                <div className={classes.boxHeading}>
                  <Typography variant="subtitle2">Test Variations</Typography>
                </div>
                <div className={classes.boxField}>
                  <RadioGroup
                    name="testVariations"
                    value={
                      formData.settings && formData.settings.variation
                        ? "yes"
                        : "no"
                    }
                    onChange={this.handleSettingsTestVariationsChanged.bind(this)}
                    classes={{
                      root: classes.testRadioGroup,
                    }}
                    row
                  >
                    <FormControlLabel
                      control={
                        <Radio
                          color="primary"
                          classes={{ root: classes.testRadioRoot }}
                        />
                      }
                      label="Yes"
                      value="yes"
                    />
                    <FormControlLabel
                      control={
                        <Radio
                          color="primary"
                          classes={{ root: classes.testRadioRoot }}
                        />
                      }
                      label="No"
                      value="no"
                    />
                  </RadioGroup>
                </div>
              </div>
            </Grid>
            <Grid item sm={6}>
              <div className={classes.borderFieldBox}>
                <div className={classes.boxHeading}>
                  <Typography variant='subtitle2'>Auto Proctoring</Typography>
                </div>
                <div className={classes.boxField}>
                  <RadioGroup
                    name='testVariations'
                    value={
                      formData.settings && !formData.settings.isProctoringOff
                        ? FORM.YES.VALUE
                        : FORM.NO.VALUE
                    }
                    onChange={this.handleSettingsAutoProtoringChanged}
                    classes={{
                      root: classes.testRadioGroup,
                    }}
                    row
                  >
                    <FormControlLabel
                      control={
                        <Radio
                          color='primary'
                          classes={{ root: classes.testRadioRoot }}
                        />
                      }
                      label={FORM.YES.LABEL}
                      value={FORM.YES.VALUE}
                    />
                    <FormControlLabel
                      control={
                        <Radio
                          color='primary'
                          classes={{ root: classes.testRadioRoot }}
                        />
                      }
                      label={FORM.NO.LABEL}
                      value={FORM.NO.VALUE}
                    />
                  </RadioGroup>
                </div>
              </div>
            </Grid>
          </Grid>
        </Collapse>
      </div>
    );
  };

  editButtonHover = () => {
    this.setState({
      showErrorTooltip: true,
    });
  };

  editButtonOut = () => {
    this.setState({
      showErrorTooltip: false,
    });
  };

  getAccumulatedDataFromSections = (template: TestTemplateBody) => {
    const result = { totalMarks: 0, totalQuestions: 0 };
    if (!template || !template.sections) {
      return result;
    }
    template.sections.forEach(({ subSection }) => {
      subSection.forEach((subSection) => {
        const { positiveMarks, noOfQuestions } = subSection;
        const noOfQuestionsToConsiderForMarks = getNoOfQuestionsToConsiderForMarks(
          subSection
        );
        result.totalMarks += positiveMarks * noOfQuestionsToConsiderForMarks;
        result.totalQuestions += noOfQuestions;
      });
    });
    return result;
  };

  getSelectedTemplate = () => {
    const { selectedTemplateId } = this.state;
    let filteredTemplates: TestTemplateBody[] = [];
    filteredTemplates = this.getSelectedTemplateList();

    return selectedTemplateId ? filteredTemplates.find(({ _id }) => _id === selectedTemplateId) : null;
  }

  getChangeTemplate = () => {
    const { classes } = this.props;
    return (<Grid item xs={12} className={classes.textAlignRight}>
      <Button
        variant="text"
        onClick={this.handleTemplateSelect.bind(this, '')}
      >
        Change Template
      </Button>
    </Grid>);
  }

  getTemplates = () => {
    let { classes, formData, hasMyLibraryQueue } = this.props;
    let {
      templates,
      selectedTemplateId,
      courseName,
      viewDetailId,
      showErrorTooltip,
      disbaleContentList,
      disableEditTemplate,
      isEditMode,
      isQuestioneExceedLimit,
      standardTemplate,
      isCreatetabel,
      toShow,
      totalTemplatesCount,
      newtemplate,
      templateCurrentlyEditing,
      isNotEditingTemplatetable,
      searchQueryTemplate
    } = this.state;
    let filteredTemplates: TestTemplateBody[] = [];
    filteredTemplates = this.getSelectedTemplateList();

    const isCurrentlyViewingStandardTemplate =
      filteredTemplates &&
      filteredTemplates[0] &&
      filteredTemplates[0].isMaster;
    const isTemplateListDisabled =
      _.get(templateCurrentlyEditing, "_id") ===
        _.get(standardTemplate, "_id") || isCreatetabel;
    const createOrEditTemplateDisabled =
      !_.isEmpty(selectedTemplateId) || isEditMode;

    const selectedTemplate = this.getSelectedTemplate();

    const isEditModeForStandardTemplate = standardTemplate && this.state.templateCurrentlyEditing._id === standardTemplate._id;
    return (
      <>
        <Grid
          container
          alignItems="flex-end"
          justify="space-between"
          className={classes.testPaperHeading}
        >
          <Grid
            container
            // justify="center"
            // alignItems="center"
            // direction="column"
          >
            {selectedTemplate && (
              <Grid container>
                <Grid item xs={12}>
                  <TestTemplateTable
                    initialData={selectedTemplate.sections}
                    contentSubType={this.props.contentsubType}
                    courseSyllabusList={this.state.courseSyllabusList}
                    classes={classes}
                    showJEEMainSpecificFields={toShowJEEMainSpecificFields(
                      selectedTemplate
                    )}
                    isEditMode={false}
                    isTemplateFromList
                    showMsg={this.props.showMsg}
                    tableName={selectedTemplate.name}
                    templateDetails={selectedTemplate}
                    templateChange={this.getChangeTemplate()}
                  />
                </Grid>
              </Grid>
            )}
            {!selectedTemplate && standardTemplate && !_.isEmpty(standardTemplate) ? (
              <TestTemplateTable
                initialData={standardTemplate.sections}
                contentSubType={this.props.contentsubType}
                courseSyllabusList={this.state.courseSyllabusList}
                classes={classes}
                showJEEMainSpecificFields={toShowJEEMainSpecificFields(
                  standardTemplate
                )}
                isEditMode={
                  isEditModeForStandardTemplate
                }
                isStandardTemplate
                onEdit={this.handleEditingStandardTemplate}
                onDone={this.handleStandardTemplateCreateCopy}
                onCancel={this.handleStandardTemplateEditCancel}
                onChange={this.handleCurrentlyEditingTemplateChange}
                onStandardTemplateSelect={this.onStandardTemplateSelect}
                onSaveAsTemplate={this.toggleTemplateNamePopup}
                showMsg={this.props.showMsg}
                disabledCTAs={createOrEditTemplateDisabled}
                tableName={isEditModeForStandardTemplate ? this.state.templateCurrentlyEditing.name : standardTemplate.name}
                valid={!!this.state.templateCurrentlyEditing.name}
                templateDetails={selectedTemplate}
              />
            ) : !selectedTemplate && (
              <Grid container justify="center">
              {/* <Grid item>
                {toShow && (
                  <>
                    <Button
                      onClick={() => {
                        this.handleOnClickOfCreateTemplate();
                      }}
                      variant="contained"
                      color="primary"
                      disabled={
                        createOrEditTemplateDisabled ||
                        !ACLService.checkModulePermission("rule", "create")
                      }
                    >
                      Create New Format
                    </Button>
                  </>
                )}
              </Grid> */}
              </Grid>
            )}
            <Grid
              container
              justify="center"
              alignItems="center"
              direction="column"
            >
              {/* {	_.map(newTemplate, (template, index)=> */}
              <Grid
                container
                justify="center"
                alignItems="center"
                direction="column"
              >
                {isCreatetabel && (
                  <>
                    <TestTemplateTable
                      contentSubType={this.props.contentsubType}
                      courseSyllabusList={this.state.courseSyllabusList}
                      onChange={this.handleNewTemplateChange}
                      classes={classes}
                      showJEEMainSpecificFields={toShowJEEMainSpecificFields(
                        this.state.newtemplate
                      )}
                      isEditMode
                      onSaveAsTemplate={this.toggleTemplateNamePopup}
                      onEditAsTemplate={this.toggleEditTemplateButton}
                      onDone={this.saveTemplate}
                      valid={!!this.state.newtemplate.name}
                      onCancel={this.handleCancelButton}
                      showMsg={this.props.showMsg}
                      updatedTestName={this.state.updatedTestName}
                      showTestNameChanged={this.state.showEditButton}
                      UpdateNameOfTable={this.state.UpdateNameOfTable}
                      templateDetails={selectedTemplate}
                    />
                  </>
                )}
              </Grid>
            </Grid>
          </Grid>
          
          {!selectedTemplate && (
              <>
                
                {/* <Grid className={classes.seperator} /> */}

                <Grid container justify="center" alignItems="center">
                  <Grid item>
                    <Typography variant="body1">
                      Select from Saved Templates
                    </Typography>
                  </Grid>
                </Grid>
                {/* <Grid item xs style={{ textAlign: "right" }}>
                  {this.props.isTestAttampted ? (
                    <Link
                      underline="none"
                      onMouseOver={this.editButtonHover.bind(this)}
                      onMouseOut={this.editButtonOut.bind(this)}
                    >
                      <Button
                        variant="outlined"
                        onClick={this.editTemplate}
                        disabled={
                          disbaleContentList.size > 0 ||
                          (disbaleContentList.size == 0 && hasMyLibraryQueue) ||
                          disableEditTemplate
                        }
                      >
                        Edit Template
                        {showErrorTooltip &&
                        (disbaleContentList.size > 0 ||
                          (hasMyLibraryQueue && disbaleContentList.size == 0) ||
                          disableEditTemplate) ? (
                          <>
                            <Grid className={classes.editTemplateInfoIcon}>
                              <CustomInfoIcon
                                isInfoIcon={false}
                                isCenterArrow={true}
                                isRightArrow={false}
                                details="Some content related to grace marks for one or more questions is already in Queue. Please republish it or remove it from the queue to make changes."
                                toolTipDirection="center"
                              />
                            </Grid>
                          </>
                        ) : (
                          ""
                        )}
                      </Button>
                    </Link>
                  ) : null}
                </Grid>*/}
              </>
          )}
        </Grid>
        
        {!selectedTemplate && (
          <>
            <Grid container>
              <Grid item xs={12} className={classes.searchContainer}>
                  <img src="/assets/svg/contentRequest/search-icon.svg" />
                  <input type="text"
                      value={searchQueryTemplate}
                      onChange={(event:any) => {
                          this.setState({searchQueryTemplate:event.target.value},()=>{this.handleSerachTemplateChange()});
                        }
                      }
                      // onKeyPress={(event: any) => {this.handleEnterSearch(event) }}
                      placeholder='Search'
                  />
              </Grid>
              {_.isEmpty(filteredTemplates) ? (
                <Grid item xs={12} className={classes.emptyPlaceholderBox}>
                  <span>
                    Choose Goal in the Basic information to get the relevant test
                    format templates
                  </span>
                </Grid>
              ) : (
                <>
                  <Grid item xs={12} className={classes.scrollSection}>
                    {_.map(filteredTemplates, (template, index) => (
                      <div
                        key={template._id + index}
                        className={classes.paddingFixed}
                      >
                        <Card elevation={0}>
                          <CardContent
                            className={
                              _.isEqual(template._id, selectedTemplateId)
                                ? classes.selectedTestCard
                                : classes.cardContentRoot
                            }
                          >
                            <Grid
                              container
                              alignItems="center"
                              className={classes.spacing}
                            >
                              <Grid item xs>
                                <Grid className={classes.testPaperName}>
                                  <Typography variant="h6" inline noWrap>
                                    {template.name}
                                  </Typography>
                                  &nbsp;&nbsp;
                                  {!_.isEmpty(courseName) && (
                                    <Button
                                      variant="outlined"
                                      color="primary"
                                      size="small"
                                      className={classes.templateCourseName}
                                    >
                                      {courseName}
                                    </Button>
                                  )}
                                </Grid>
                              </Grid>
                              <Grid item>
                                {_.isEqual(template._id, viewDetailId) ? (
                                  <>
                                    <Link
                                      href="javascript:void(0)"
                                      onClick={this.handleToggleDetailClick.bind(
                                        this,
                                        ""
                                      )}
                                    >
                                      Hide Detail
                                    </Link>
                                    {/* &nbsp;&nbsp;
                                    {isNotEditingTemplatetable &&
                                      !isCurrentlyViewingStandardTemplate &&
                                      _.isEmpty(selectedTemplateId) && (
                                        <Button
                                          variant="outlined"
                                          color="primary"
                                          disabled={
                                            !ACLService.checkModulePermission(
                                              "rule",
                                              "edit"
                                            )
                                          }
                                          onClick={() =>
                                            this.handleEditTable(template)
                                          }
                                          classes={{
                                            root: classes.outlineTypeButton,
                                          }}
                                        >
                                          Edit
                                        </Button>
                                      )} */}
                                    &nbsp;&nbsp;
                                    </>) :
                                  <Button
                                  className={classes.viewDetailsBtn}
                                  variant="text"
                                  onClick={this.handleToggleDetailClick.bind(
                                    this,
                                    template._id
                                  )}
                                    disabled={isTemplateListDisabled}
                                  >
                                    View Detail
                                    </Button>
                                }
                                {_.isEmpty(selectedTemplateId) && (
                                  <>
                                    &nbsp;&nbsp;
                                    <Button
                                      variant="outlined"
                                      classes={{ root: classes.outlineTypeButton }}
                                      onClick={this.handleTemplateSelect.bind(
                                        this,
                                        template._id,
                                        template
                                      )}
                                      disabled={isTemplateListDisabled}
                                    >
                                      Select
                                    </Button>
                                  </>
                                )}
                                {_.isEqual(template._id, selectedTemplateId) && (
                                  <Button
                                    variant="contained"
                                    color="primary"
                                    classes={{ root: classes.selectedButton }}
                                  >
                                    <SelectedIcon /> Selected
                                  </Button>
                                )}
                              </Grid>
                            </Grid>

                            {!_.isEqual(template._id, viewDetailId) && (
                              <Grid
                                container
                                alignItems="center"
                                className={classes.tempSummary}
                              >
                                  <Typography className={classes.summary} inline variant="body1">
                                    <strong>Summary: </strong>
                                    {template.noOfSections} Sections,{" "}
                                    {template.subSectionsCount} Sub-sections
                                  </Typography>
                                  <Typography className={classes.summary} inline variant="body1">
                                    <strong>Test Duration: </strong>
                                    {template.testDurationNumber} {template.testDurationType}
                                  </Typography>
                                  <Typography className={classes.summary} inline variant="body1">
                                    <strong>Marks: </strong>
                                    {template.totalMarks}
                                  </Typography>
                                  <Typography className={classes.summary} inline variant="body1">
                                    <strong>No of questions: </strong>
                                    {template.questionsCount}
                                  </Typography>
                                  <Typography className={classes.summary} inline variant="body1">
                                    <strong>Mandatory Questions: </strong>
                                    {getMandatoryQuestionCount(template)}
                                  </Typography>
                                  <Typography className={classes.summary} inline variant="body1">
                                    <strong>Master Test Type: </strong>
                                    {getMasterTestTypeDisplayName(template.testTypeCode || '')}
                                  </Typography> 
                                  <Typography className={classes.summary} inline variant="body1">
                                    <strong>Sections Level: </strong>
                                    {getSectionLevelDisplayName(template.testSectionLevel)}
                                  </Typography>                  
                              </Grid>
                            )}

                            <Collapse
                              in={_.isEqual(template._id, viewDetailId)}
                              classes={{ wrapperInner: classes.wrapperInner }}
                            >
                              <TestTemplateTable
                                initialData={template.sections}
                                contentSubType={this.props.contentsubType}
                                courseSyllabusList={this.state.courseSyllabusList}
                                classes={classes}
                                showJEEMainSpecificFields={toShowJEEMainSpecificFields(
                                  template
                                )}
                                isEditMode={
                                  template._id === viewDetailId && isEditMode
                                }
                                onCancel={() =>
                                  this.handleCancleClick(viewDetailId)
                                }
                                onDone={() => this.editTestTemplate(index)}
                                onChange={this.handleCurrentlyEditingTemplateChange}
                                isTemplateFromList
                                showMsg={this.props.showMsg}
                                tableName=""
                                templateDetails={selectedTemplate}
                              />
                            </Collapse>
                          </CardContent>
                        </Card>
                      </div>
                    ))}
                  </Grid>
                  {_.isEmpty(selectedTemplateId) && (
                    <Grid item xs justify="center">
                      <Pagination
                        onPageChange={this.onTemplatePageChange}
                        key={this.state.selectedCourseId} // force related this component when courseId is changed
                        totalPages={
                          totalTemplatesCount
                            ? Math.floor(totalTemplatesCount / LIMIT)
                            : totalTemplatesCount
                        }
                      />
                    </Grid>
                  )}
                </>
              )}
            </Grid>
          </>
        )}
      </>
    );
  };

  onTemplatePageChange = (currentPage: number, totalPages: number) => {
    const { formData } = this.props;
    const skip = (currentPage - 1) * LIMIT;
    this.loadTemplates({ courseId: formData.courseId[0] }, skip);
    // if (formData._id) {
    // 	this.loadTemplates({ testId: formData._id }, skip)
    // } else {
    // 	this.loadTemplates({ courseId: formData.courseId[0] }, skip)
    // }
  };
  handleSerachTemplateChange=()=>{
    const { formData } = this.props;
    this.loadTemplates({ courseId: formData.courseId[0]});
  }

  blankTestQuestions = () => {
    const { classes } = this.props;

    return (
      <Grid container>
        <Grid item xs={12} className={classes.emptyPlaceholderBox}>
          <span>Choose template to activate this section</span>
        </Grid>
      </Grid>
    );
  };

  getSelectedQuestions = (data: any, section: any, subSection: any) => {
    const selectedQuestions = _.get(
      _.find(data, {
        sectionId: section._id,
        subSectionId: subSection._id,
      }),
      "questions",
      []
    );

    return selectedQuestions;
  };

  getNoOfQuestions(quesCodeAllowed: number, question: ContentData) {
    if (quesCodeAllowed == 5) {
      if (question.passageData) {
        return question.passageData.length;
      }
    }
    return 1;
  }

  addGraceMarks(question: any, subSection: any, section: any) {
    this.setState({
      showDialog: true,
      isAddToQueue: true,
      isGraceOnlyForAttemptedStudents: !!subSection.optionalQuestions,
    });
    this.currentGraceMarkQuestion = JSON.parse(JSON.stringify(question));
    this.currentGraceMarkQuestion.positiveMarks = subSection.positiveMarks;
    this.currentGraceMarkQuestion.subSectionId = subSection._id;
    this.currentGraceMarkQuestion.sectionId = section._id;
  }

  showTooltip(questionId: any) {
    if (this.state.disbaleContentList.has(questionId))
      this.setState({ showTooltip: questionId + "question" });
  }

  hideTooltip(e: any) {
    this.setState({ showTooltip: null });
  }

  displayGraceTooltip = (value: string) => {
    this.setState({ showGraceTooltip: value });
  };

  removeGraceTooltip = () => {
    this.setState({ showGraceTooltip: null });
  };

  getTestQuestions = (
    selectedSectionId: string,
    selectedSubSectionId: string,
    filteredTemplates: TestTemplateBody[]
  ) => {
    const { classes, sectionsTouched, loadingCount } = this.props;
    const {
      data,
      showTooltip,
      showGraceTooltip,
      isAddToQueue,
      isEditTemplateOpen,
      disbaleContentList,
      isGraceMarksOverrideActive,
      generateAutomatic,
    } = this.state;
    var infoTooltipData =
      "This question is already in Queue. Re-Publish or remove it from the queue in order to edit this question.";

    if (
      filteredTemplates.length > 0 &&
      (_.isEmpty(selectedSectionId) ||
        (filteredTemplates.length > 0 &&
          !filteredTemplates[0].sections
            .map((s: any) => s._id)
            .includes(selectedSectionId)))
    ) {
      selectedSectionId = filteredTemplates[0].sections[0]._id;
    }
    const appliedFiltersCount = this.getAppliedFiltersCount(selectedSubSectionId);
    return (
      <SectionFocusedContext.Consumer>
        {({ setSectionFocus, sectionId }: SectionFocusedContextValue) => {
          const isSectionTouched = sectionsTouched.has(sectionId || '');

          return (
            <Grid container>
              <Grid
                container
                justify="space-between"
                alignContent="center"
                spacing={8}
              >
                <Grid item xs className={classes.mb2x}>
                  <Tabs
                    value={selectedSubSectionId}
                    indicatorColor="primary"
                    classes={{ root: classes.tabContainer }}
                    variant="scrollable"
                    scrollButtons="auto"
                  >
                    {_.map(filteredTemplates[0].sections, (section: any, index) =>
                      _.map(section.subSection, (subSection: any, innerSindx) => (
                        <Tab
                          onClick={this.handleTestSubSectionClick.bind(
                            this,
                            section,
                            subSection
                          )}
                          key={subSection._id}
                          classes={{
                            root: classes.tabRoot,
                            labelContainer: classes.tabLabelContainer,
                          }}
                          label={
                            <>
                              {!_.isUndefined(section)
                                ? this.getSubSectionName(section) +
                                  "-" +
                                  subSection.name
                                : "Auto Pick"}
                              {this.getSectionIcon(subSection, isSectionTouched)}
                            </>
                          }
                          value={subSection._id}
                          disableRipple
                        />
                      ))
                    )}
                  </Tabs>
                </Grid>
                {/*  May be will need later this code
                <Grid item className={classes.mb2x}> 		
                  <span className={classes.inlineBlock}>
                    <img src="/assets/svg/myLibrary/delete.svg" />
                    <Typography variant="body1">Delete</Typography>
                  </span>
                  <span className={classes.inlineBlock}>
                    <img src="/assets/svg/myLibrary/swap.svg" />
                    <Typography variant="body1">Swap</Typography>
                  </span>
                  <span className={classes.inlineBlock}
                    onMouseOver={(event) => this.toggleGraceTooltip(event)}
                    onMouseOut={(event) => this.toggleGraceTooltip(event)}
                    >
                    <img src="/assets/svg/myLibrary/plus.svg" />
                    <Typography variant="body1">Grace Marks</Typography>
      
                    {
                    showGraceTooltip ?
                      <span className={classes.graceInfoContainer}>
                        <CustomInfoIcon
                          isInfoIcon={false}
                          isRightArrow={false}
                          isCenterArrow={true}
                          details="Add Grace marks by clicking on this button.
                           These marks will be swarded to the students irrespective of any answer is selected."
                          toolTipDirection="center" /></span> : ''
                    }
                  </span>
                
              </Grid> */}
      
                {_.map(
                  filteredTemplates[0].sections,
                  (section, index) =>
                    _.isEqual(section._id, selectedSectionId) && (
                      <Grid item xs={12} key={index}>
                        {_.map(
                          section.subSection,
                          (subSection, indexSub) =>
                            _.isEqual(subSection._id, selectedSubSectionId) && (
                              <MyPATCollapse
                                hasExpandIcon={false}
                                isShow={true}
                                // defaultExpanded={defaultExpanded}
                                classes={{
                                  root: classes.subSectionPaper,
                                  body: classes.subSectionPaper,
                                }}
                                key={`${index}-${indexSub}`}
                                customTitle={
                                  <>
                                    <Grid container justify="center">
                                      <Grid item xs={6}>
                                        <Typography style={{fontSize: '15px'}} variant="body1">
                                          {` ${section.name} 
                              (${this.getAddedQuestions(data, section._id, subSection._id)}/${
                                            subSection.noOfQuestions
                                          } Questions)`}
                                          <Chip
                                            label={this.getQuestionTypeName(
                                              subSection.quesCodeAllowed
                                            )}
                                            className={classes.chip}
                                          />
                                          &nbsp;Marks: {subSection.positiveMarks},{" "}
                                          {subSection.negativeMarks === 0
                                            ? 0
                                            : `-${subSection.negativeMarks}`}
                                          ,{subSection.partialMarks}
                                        </Typography>
                                        {/* <Typography variant="caption">
                                  Marks: {subSection.positiveMarks}, {subSection.negativeMarks === 0
                                    ? 0
                                    : `-${subSection.negativeMarks}`},
                                  {subSection.partialMarks}
                                </Typography> */}
                                      </Grid>
      
                                      <Grid item xs={6}>
                                        {_.get(
                                          _.find(data, {
                                            sectionId: section._id,
                                            subSectionId: subSection._id,
                                          }),
                                          "questions",
                                          []
                                        ).length > 0 &&
                                          generateAutomatic[`${subSection._id}`] && (
                                            <Grid className={classes.filterContainer}>
                                              <Grid>
                                                <span>
                                                  {appliedFiltersCount > 0 ? 'Filtered' : 'Total'} Content :{" "}
                                                  {
                                                    loadingCount ? 'Loading...' : (
                                                      appliedFiltersCount > 0 ? (
                                                        this.props.contentCount
                                                        .questionCount
                                                      ) : (
                                                        this.props.contentCount.totalQuestionCount
                                                      )
                                                    )
                                                  }{" "}
                                                </span>
                                                &nbsp;&nbsp;
                                                <Badge color="secondary" badgeContent={appliedFiltersCount}>
                                                  <Link onClick={this.handleFilter}>
                                                    
                                                    <span>
                                                      <img
                                                        src="/assets/svg/myLibrary/test/filter.svg"
                                                        alt="filter"
                                                      />
                                                    </span>
                                                    &nbsp;Filter
                                                  </Link>
                                                </Badge>
                                                &nbsp;&nbsp;&nbsp;
                                                <Link
                                                  onClick={() =>
                                                    this.handleRefreshBttn(
                                                      section._id,
                                                      subSection.noOfQuestions,
                                                      subSection.quesCodeAllowed,
                                                      subSection._id,
                                                      -1,
                                                      -1
                                                    )
                                                  }
                                                >
                                                  <span>
                                                    <img
                                                      src="/assets/svg/myLibrary/test/swap.svg"
                                                      alt="swap"
                                                    />
                                                  </span>
                                                  &nbsp;Refresh
                                                </Link>
                                              </Grid>
                                            </Grid>
                                          )}
                                      </Grid>
                                    </Grid>
      
                                    {/* <Typography variant="caption">
                                  {this.getQuestionTypeName(subSection.quesCodeAllowed)}{" "}
                                  type, Marks: {subSection.positiveMarks}, {subSection.negativeMarks === 0
                                    ? 0
                                    : `-${subSection.negativeMarks}`},
                                  {subSection.partialMarks}
                                </Typography> */}
                                  </>
                                }
                              >
                                <Grid container>
                                  <Grid item xs={12}>
                                    {_.get(
                                      _.find(data, {
                                        sectionId: section._id,
                                        subSectionId: subSection._id,
                                      }),
                                      "questions",
                                      []
                                    ).map((question: any, quesIndex: any) => {
                                      if (!question.disabled) {
                                        return (
                                          <>
                                            <Grid
                                              key={quesIndex}
                                              container
                                              alignItems="center"
                                              justify="space-between"
                                              //Todo - add code for disable question hear (classes.opacitySM)
                                              className={[
                                                classes.mb1x,
                                                classes.optionContent,
                                                disbaleContentList.has(
                                                  question.contentId
                                                )
                                                  ? classes.opacitySM
                                                  : " ",
                                              ].join(" ")}
                                              spacing={8}
                                              wrap="nowrap"
                                              onDragOver={(e: any) =>
                                                this.onDragOver(
                                                  e,
                                                  quesIndex,
                                                  subSection
                                                )
                                              }
                                              onDrop={(e: any) =>
                                                this.onDropOver(
                                                  e,
                                                  quesIndex,
                                                  subSection
                                                )
                                              }
                                              // onDragLeave={(e: any) => this.onDragLeave(e, index, subSection)}
                                            >
                                              <Grid item xs="auto">
                                                <MyPATSelect
                                                  value={quesIndex}
                                                  selectMinWidth={false}
                                                  onChange={(e: any) => {
                                                    this.changeQuestionIndex(
                                                      e,
                                                      quesIndex,
                                                      section,
                                                      subSection
                                                    );
                                                  }}
                                                >
                                                  {_.get(
                                                    _.find(data, {
                                                      sectionId: section._id,
                                                      subSectionId: subSection._id,
                                                    }),
                                                    "questions",
                                                    []
                                                  ).map((v: any, i: number) => {
                                                    return (
                                                      <option key={i} value={i}>
                                                        Q{i + 1}
                                                      </option>
                                                    );
                                                  })}
                                                </MyPATSelect>
                                              </Grid>
                                              <Grid
                                                item
                                                xs
                                                style={{ maxWidth: "80%" }}
                                                draggable
                                                onDragStart={(e) =>
                                                  this.onDragStart(
                                                    e,
                                                    quesIndex,
                                                    section,
                                                    subSection,
                                                    question
                                                  )
                                                }
                                                onDragEnd={this.onDragEnd}
                                              >
                                                <Grid
                                                  container
                                                  alignItems="center"
                                                  wrap="nowrap"
                                                  className={classes.questionInfo}
                                                  onMouseOver={(e) =>
                                                    this.state.disbaleContentList.has(
                                                      _.get(question, "contentId", "")
                                                    )
                                                      ? this.showTooltip(
                                                          _.get(
                                                            question,
                                                            "contentId",
                                                            ""
                                                          )
                                                        )
                                                      : this.hideTooltip.bind(this)
                                                  }
                                                  onMouseOut={this.hideTooltip.bind(
                                                    this
                                                  )}
                                                >
                                                  <Grid item xs="auto">
                                                    <img src="/assets/svg/reorder-icon.svg" />
                                                  </Grid>
                                                  <Grid item xs={9}>
                                                    <Typography
                                                      variant="body1"
                                                      classes={{
                                                        root:
                                                          classes.questionParagraph,
                                                      }}
                                                      dangerouslySetInnerHTML={{
                                                        __html:
                                                          question.title ||
                                                          _.get(
                                                            question,
                                                            "content[0].questionContent",
                                                            ""
                                                          ),
                                                      }}
                                                      noWrap
                                                    />
                                                  </Grid>
                                                  <Grid
                                                    item
                                                    xs
                                                    className={classes.textAlignRight}
                                                  >
                                                    <Typography
                                                      variant="body1"
                                                      noWrap
                                                      className={classes.dFlex}
                                                    >
                                                      ID:{" "}
                                                      <span>
                                                        <MyPATLink
                                                          to={`/content/preview/${
                                                            question._id
                                                          }`}
                                                          target="_blank"
                                                        >
                                                          {_.get(
                                                            question,
                                                            "contentId",
                                                            ""
                                                          )}
                                                        </MyPATLink>
                                                      </span>
                                                    </Typography>
                                                  </Grid>
                                                </Grid>
                                              </Grid>
                                              <Grid item xs="auto">
                                                <Button
                                                  variant="text"
                                                  className={
                                                    classes.questionActionBtn +
                                                    "  btn-delete "
                                                  }
                                                  onMouseOver={() => {
                                                    this.displayGraceTooltip(
                                                      _.get(
                                                        question,
                                                        "contentId",
                                                        ""
                                                      ) + "delete"
                                                    );
                                                  }}
                                                  onMouseOut={this.removeGraceTooltip}
                                                  onClick={() => {
                                                    this.handleRemoveQuestion(
                                                      question.content_Id,
                                                      indexSub,
                                                      quesIndex,
                                                      section._id,
                                                      subSection._id,
                                                      question.passageData,
                                                      subSection.quesCodeAllowed
                                                    )
                                                    setSectionFocus(true)
                                                  }}
                                                  // Add this later
                                                  disabled={
                                                    this.state.disbaleContentList.has(
                                                      _.get(question, "contentId", "")
                                                    ) || question.contentId
                                                      ? false
                                                      : true
                                                  }
                                                >
                                                  <img src="/assets/svg/myLibrary/delete-outline.svg" />
                                                </Button>
                                                {showGraceTooltip ===
                                                  _.get(question, "contentId", "") +
                                                    "delete" && (
                                                  <Grid
                                                    className={classes.deleteInfoIcon}
                                                  >
                                                    <CustomInfoIcon
                                                      isInfoIcon={false}
                                                      isRightArrow={false}
                                                      isCenterArrow={true}
                                                      details="Delete"
                                                      toolTipDirection="center"
                                                    />
                                                  </Grid>
                                                )}
                                              </Grid>
      
                                              <Grid item xs="auto">
                                                {generateAutomatic[
                                                  `${subSection._id}`
                                                ] && (
                                                  <Button
                                                    variant="text"
                                                    onClick={(e) => {
                                                      this.handleRefreshBttn(
                                                        section._id,
                                                        1,
                                                        subSection.quesCodeAllowed,
                                                        subSection._id,
                                                        indexSub,
                                                        quesIndex,
                                                        this.getSelectedQuestions(
                                                          data,
                                                          section,
                                                          subSection
                                                        )
                                                      )
                                                      setSectionFocus(true)
                                                    }}
                                                    onMouseOver={() => {
                                                      this.displayGraceTooltip(
                                                        _.get(
                                                          question,
                                                          "contentId",
                                                          ""
                                                        ) + "replace"
                                                      );
                                                    }}
                                                    onMouseOut={
                                                      this.removeGraceTooltip
                                                    }
                                                    disabled={
                                                      this.state.disbaleContentList.has(
                                                        _.get(
                                                          question,
                                                          "contentId",
                                                          ""
                                                        )
                                                      ) ||
                                                      subSection.quesCodeAllowed == 5
                                                    }
                                                    className={
                                                      classes.questionActionBtn +
                                                      "  btn-delete " +
                                                      `${
                                                        subSection.quesCodeAllowed ==
                                                        5
                                                          ? classes.disabled
                                                          : " "
                                                      }`
                                                    }
                                                  >
                                                    <img src="/assets/svg/myLibrary/test/swap.svg" />
                                                  </Button>
                                                )}
                                                {showGraceTooltip ===
                                                  _.get(question, "contentId", "") +
                                                    "replace" && (
                                                  <Grid
                                                    className={classes.swapInfoIcon}
                                                  >
                                                    <CustomInfoIcon
                                                      isInfoIcon={false}
                                                      isRightArrow={false}
                                                      isCenterArrow={true}
                                                      details="Swap"
                                                      toolTipDirection="center"
                                                    />
                                                  </Grid>
                                                )}
                                              </Grid>
                                              <Grid item xs="auto">
                                                <Button
                                                  variant="text"
                                                  className={
                                                    classes.questionActionBtn +
                                                    "  btn-delete " +
                                                    `${
                                                      subSection.quesCodeAllowed == 5
                                                        ? classes.disabled
                                                        : " "
                                                    }`
                                                  }
                                                  onMouseOver={() => {
                                                    this.displayGraceTooltip(
                                                      _.get(
                                                        question,
                                                        "contentId",
                                                        ""
                                                      ) + "Add"
                                                    );
                                                  }}
                                                  onMouseOut={this.removeGraceTooltip}
                                                  onClick={(e) => {
                                                    this.handleChooseLibraryClick(
                                                      this.getSelectedQuestions(
                                                        data,
                                                        section,
                                                        subSection
                                                      ),
                                                      subSection.quesCodeAllowed,
                                                      subSection._id,
                                                      section._id,
                                                      subSection.noOfQuestions,
                                                      indexSub,
                                                      quesIndex,
                                                      e,
                                                      true,
                                                      question
                                                    )
                                                    setSectionFocus(true)
                                                  }}
                                                  // Add this later
                                                  disabled={
                                                    this.state.disbaleContentList.has(
                                                      _.get(question, "contentId", "")
                                                    ) ||
                                                    subSection.quesCodeAllowed == 5
                                                  }
                                                >
                                                  <img src="/assets/svg/grace-icon.svg" />
                                                </Button>
                                                {showGraceTooltip ===
                                                  _.get(question, "contentId", "") +
                                                    "Add" && (
                                                  <Grid
                                                    className={classes.graceInfoIcon}
                                                  >
                                                    <CustomInfoIcon
                                                      isInfoIcon={false}
                                                      isRightArrow={false}
                                                      isCenterArrow={true}
                                                      details="Add"
                                                      toolTipDirection="center"
                                                    />
                                                  </Grid>
                                                )}
                                              </Grid>
                                              {this.props.isTestAttampted && (
                                                <Grid item xs="auto">
                                                  <span
                                                    className={
                                                      classes.showHoverTooltip
                                                    }
                                                  >
                                                    <Button
                                                      variant="text"
                                                      onMouseOver={() => {
                                                        this.displayGraceTooltip(
                                                          _.get(
                                                            question,
                                                            "contentId",
                                                            ""
                                                          ) + "plus"
                                                        );
                                                      }}
                                                      onMouseOut={
                                                        this.removeGraceTooltip
                                                      }
                                                      className={
                                                        classes.questionActionBtn +
                                                        "  btn-delete " +
                                                        `${
                                                          subSection.quesCodeAllowed ==
                                                          5
                                                            ? classes.disabled
                                                            : " "
                                                        }`
                                                      }
                                                      onClick={(e) =>
                                                        this.addGraceMarks(
                                                          question,
                                                          subSection,
                                                          section
                                                        )
                                                      }
                                                      disabled={this.state.disbaleContentList.has(
                                                        _.get(
                                                          question,
                                                          "contentId",
                                                          ""
                                                        )
                                                      )}
                                                    >
                                                      <img src="/assets/svg/myLibrary/plus.svg" />
                                                    </Button>
                                                  </span>
                                                  {showGraceTooltip ===
                                                    _.get(question, "contentId", "") +
                                                      "plus" && (
                                                    //@TODO - bad way of tooltip need to imrove (Make only using css)
                                                    //@Update - Please add unique className/something else, CSS only can apply only with unique class/ids for a dynamic list rendering
                                                    <Grid
                                                      className={classes.plusInfoIcon}
                                                    >
                                                      <CustomInfoIcon
                                                        isInfoIcon={false}
                                                        isRightArrow={false}
                                                        isCenterArrow={true}
                                                        details="Grace Marks"
                                                        toolTipDirection="center"
                                                      />
                                                    </Grid>
                                                  )}
                                                </Grid>
                                              )}
                                            </Grid>
      
                                            {showTooltip ===
                                            _.get(question, "contentId", "") +
                                              "question" ? (
                                              <span className={classes.infoContainer}>
                                                <CustomInfoIcon
                                                  isInfoIcon={false}
                                                  isRightArrow={false}
                                                  isCenterArrow={false}
                                                  details={infoTooltipData}
                                                  toolTipDirection="center"
                                                />
                                              </span>
                                            ) : (
                                              ""
                                            )}
                                          </>
                                        );
                                      }
                                    })}
                                  </Grid>
      
                                  {this.showChooseFromLibraryButton(subSection) && (
                                    <Grid
                                      item
                                      xs={12}
                                      className={`${classes.emptyPlaceholderBox} ${classes.borderTransparent} ${
                                        classes.textAlignCenter
                                      }`}
                                    >
                                      {(generateAutomatic[`${subSection._id}`] ||
                                        this.getAddedQuestions(
                                          data,
                                          section._id,
                                          subSection._id
                                        ) == 0) && (
                                        <>
                                          {" "}
                                          
                                          <Typography className={classes.buttonHeading}>Add questions automatically</Typography>
                                          <Button
                                            variant="contained"
                                            color="primary"
                                            onClick={(e) =>
                                              this.handleRefreshBttn(
                                                section._id,
                                                subSection.noOfQuestions,
                                                subSection.quesCodeAllowed,
                                                subSection._id,
                                                -1,
                                                -1
                                              )
                                            }
                                            onFocus={() => setSectionFocus(true)}
                                            onBlur={() => setSectionFocus(false)}
                                          >
                                            Generate Automatically
                                          </Button>
                                      <Grid className={[classes.seperator, classes.marginb30].join(' ')} />
                                      </>)}
                                      <Grid container justify="space-around">
                                        <Grid item>
                                          <Typography className={classes.buttonHeading}>Add from My Library</Typography>
                                            <Button
                                              variant="outlined"
                                              color="primary"
                                              className={classes.mb1x}
                                              onFocus={() => setSectionFocus(true)}
                                              onBlur={() => setSectionFocus(false)}
                                              onClick={(e) =>
                                                this.handleChooseLibraryClick(
                                                  this.getSelectedQuestions(
                                                    data,
                                                    section,
                                                    subSection
                                                  ),
                                                  subSection.quesCodeAllowed,
                                                  subSection._id,
                                                  section._id,
                                                  subSection.noOfQuestions,
                                                  -1,
                                                  -1,
                                                  e,
                                                  false
                                                )
                                              }
                                            >
                                              Choose from Library
                                            </Button>
                                        </Grid>
                                        <Grid item className={[classes.verticalBorder, classes.marginL15].join(' ')}/>
                                        <Grid item>
                                          <Typography className={classes.buttonHeading}>Create questions manually</Typography>
                                            <Button
                                              variant="outlined"
                                              color="primary"
                                              className={classes.mb1x}
                                              onFocus={() => setSectionFocus(true)}
                                              onBlur={() => setSectionFocus(false)}
                                              disabled={!!this.checkQuestionCreationPermission()}
                                              onClick={(e) =>
                                                this.handleCreateQuestionClick(
                                                  subSection.quesCodeAllowed,
                                                  index,
                                                  indexSub
                                                )
                                              }
                                            >
                                            Create Question
                                            </Button>
                                        </Grid>
                                      </Grid>
                                    </Grid>
                                  )}
                                </Grid>
                              </MyPATCollapse>
                            )
                        )}
                      </Grid>
                    )
                )}
              </Grid>
              {this.props.isTestAttampted && (
                <>
                  <MyPATDialog
                    dialogOpen={isEditTemplateOpen}
                    onDialogClose={this.closeEditTemplate}
                    onDialogBack={this.closeEditTemplate}
                    dialogHasActions={true}
                    variantHeader="leftHeader"
                    customButtonVariant="withoutBorderCloseIcon"
                    isCustomBackground={true}
                    onDialogCancel={this.closeEditTemplate}
                    otherDialogProps={{
                      fullWidth: true,
                      maxWidth: "md",
                      scroll: "body",
                    }}
                    customDialogTitle={
                      <>
                        <Grid container justify="space-between" alignItems="center">
                          <Grid item xs={5}>
                            <Grid container alignItems="flex-start">
                              <Typography variant="h5" noWrap>
                                Create Test Template
                              </Typography>
                            </Grid>
                          </Grid>
      
                          <Grid item xs="auto">
                            <Button
                              variant="contained"
                              classes={{ root: classes.saveBtn }}
                              onClick={this.addToQueueMarkingChanges}
                              color="primary"
                            >
                              Save
                            </Button>
                            &nbsp;&nbsp;
                            <MyPATIconButton
                              buttonVariant="withoutBorderCloseIcon"
                              onClick={this.closeEditTemplate}
                            >
                              <CloseIcon />
                            </MyPATIconButton>
                          </Grid>
                        </Grid>
                      </>
                    }
                  >
                    <CreateTestTemplate
                      transferToParent={(data: any) => {
                        this.updatedFilterTemplateData = data;
                      }}
                      isDisableForm={this.props.isTestAttampted}
                      activeTSetting={filteredTemplates[0]}
                      updateTemplate={filteredTemplates[0]}
                    />
                  </MyPATDialog>
                  {this.state.isChangeMarkingShemeOpen && (
                    <MyPATDialog
                      dialogOpen={!!this.state.isChangeMarkingShemeOpen}
                      dialogHeading="Add to Queue"
                      onDialogClose={this.closeMarkingSheme}
                      onDialogBack={this.closeMarkingSheme}
                      dialogHasActions={true}
                      isAlignCenter={true}
                      isCustomBackground={true}
                      customButtonVariant="withoutBorderCloseIcon"
                      otherDialogProps={{
                        fullWidth: false,
                        maxWidth: false,
                      }}
                      customDialogActions={
                        <>
                          <Grid container justify="flex-end" alignItems="flex-end">
                            <Grid item>
                              <Button
                                onClick={this.closeMarkingSheme}
                                color="primary"
                              >
                                Cancel
                              </Button>
                            </Grid>
                            <Grid item>
                              <Button
                                variant="contained"
                                classes={{ root: classes.okButton }}
                                onClick={() => {
                                  this.addToQueueMarkingSheme(false);
                                }}
                                color="primary"
                              >
                                Add To Queue
                              </Button>
                            </Grid>
                          </Grid>
                        </>
                      }
                    >
                      <Grid container className={classes.widthSM}>
                        <Grid xs={12}>
                          <Grid className={classes.whiteCard}>
                            <Typography variant="body1" align="left">
                              This change will impact:
                            </Typography>
                            <Grid className={classes.lightPinkCard}>
                              Student attemps:{" "}
                              {this.props.testAttemptData[0] &&
                                this.props.testAttemptData[0].finished +
                                  this.props.testAttemptData[0].ongoing}
                            </Grid>
                          </Grid>
                        </Grid>
                      </Grid>
      
                      <Grid
                        container
                        className={[classes.widthSM, classes.marginTopSM].join(" ")}
                      >
                        <Grid xs={12}>
                          <Typography variant="body1" className={classes.fontSizeSM}>
                            <strong>Add to Queue:</strong> Add this changes to the
                            Re-publish Queue to regenerate results for multiple
                            Questions/Tests at once from MyLibrary Homepage
                          </Typography>
                        </Grid>
                      </Grid>
                    </MyPATDialog>
                  )}
                </>
              )}
            </Grid>    
          )
        }}
      </SectionFocusedContext.Consumer>
    );
  };

  testPaperBalance = (filteredTemplates: TestTemplateBody[]) => {
    const { classes, formData } = this.props;
    const { data } = this.state;

    const getScoreClasses = (score: number, defaultClasses: string) =>
      ` ${defaultClasses}
											${score >= 20 && score < 40 ? classes.scoreSizeMedium : ""}
											${score >= 40 ? classes.scoreSizeLarge : ""}
										`;
    const difficultyAbilityDistribution = this.getDifficultyAbilityDistribution();
    const questionTypeData = this.generateQuestionTypeChartData();
    const questionTypeChartData = {
      series: questionTypeData.chartData || questionTypeData.returnChartData,
    };
    const subjectWiseData = this.generateSubjectWiseChartData(
      filteredTemplates
    );
    const subjectWiseChartData = {
      series: subjectWiseData.chartData || subjectWiseData.returnChartData,
    };

    let isEmptyQuestion = _.some(data, (d: any) => _.isEmpty(d.questions));

    return _.isEmpty(data) || isEmptyQuestion ? (
      <Grid container>
        <Grid item xs={12} className={classes.emptyPlaceholderBox}>
          <span>Add all the test questions to activate this section</span>
        </Grid>
      </Grid>
    ) : (
      <>
        <>
          <Grid container alignItems="center" justify="space-between">
            <Grid item xs={6}>
              <Grid container>
                <Grid item xs={12}>
                  <Typography variant="body1">
                    <strong>Difficulty Ability Distribution</strong>
                  </Typography>
                </Grid>

                {/* <Grid item xs={6}>
                  <Typography>Dropdown</Typography>
                </Grid> */}
              </Grid>
              <Grid container>
                <Grid xs={12}>
                  <Table className={classes.difficultyScoreTable}>
                    <TableBody>
                      <TableRow>
                        <TableCell className={classes.scoreCell}>
                          <span
                            className={getScoreClasses(
                              _.get(
                                difficultyAbilityDistribution,
                                "hard-conceptual",
                                0
                              ),
                              `${classes.scoreWrapper} ${
                                classes.scoreWrapperRed
                              }`
                            )}
                          >
                            <span className={classes.score}>
                              {_.get(
                                difficultyAbilityDistribution,
                                "hard-conceptual",
                                0
                              )}
                            </span>
                          </span>
                        </TableCell>
                        <TableCell className={classes.scoreCell}>
                          <span
                            className={getScoreClasses(
                              _.get(
                                difficultyAbilityDistribution,
                                "hard-analytical",
                                0
                              ),
                              `${classes.scoreWrapper} ${
                                classes.scoreWrapperRed
                              }`
                            )}
                          >
                            <span className={classes.score}>
                              {_.get(
                                difficultyAbilityDistribution,
                                "hard-analytical",
                                0
                              )}
                            </span>
                          </span>
                        </TableCell>
                        <TableCell className={classes.scoreCell}>
                          <span
                            className={getScoreClasses(
                              _.get(
                                difficultyAbilityDistribution,
                                "hard-intuitive",
                                0
                              ),
                              `${classes.scoreWrapper} ${
                                classes.scoreWrapperRed
                              }`
                            )}
                          >
                            <span className={classes.score}>
                              {_.get(
                                difficultyAbilityDistribution,
                                "hard-intuitive",
                                0
                              )}
                            </span>
                          </span>
                        </TableCell>
                        <TableCell
                          className={classes.verticalProgressCell}
                          rowSpan={3}
                        >
                          <div className={classes.verticalProgressWrapper}>
                            <div
                              className={classes.progressDifficult}
                              style={{
                                height:
                                  _.get(
                                    difficultyAbilityDistribution,
                                    "p-hard",
                                    0
                                  ) + "%",
                              }}
                            />
                            <div
                              className={classes.progressMedium}
                              style={{
                                height:
                                  _.get(
                                    difficultyAbilityDistribution,
                                    "p-medium",
                                    0
                                  ) + "%",
                              }}
                            />
                            <div
                              className={classes.progressEasy}
                              style={{
                                height:
                                  _.get(
                                    difficultyAbilityDistribution,
                                    "p-easy",
                                    0
                                  ) + "%",
                              }}
                            />
                          </div>
                        </TableCell>
                        <TableCell
                          className={classes.verticalProgressLabelCell}
                        >
                          <span>
                            {_.get(difficultyAbilityDistribution, "p-hard", 0)}%
                            Difficult
                          </span>
                        </TableCell>
                        <TableCell />
                      </TableRow>

                      <TableRow>
                        <TableCell className={classes.scoreCell}>
                          <span
                            className={getScoreClasses(
                              _.get(
                                difficultyAbilityDistribution,
                                "medium-conceptual",
                                0
                              ),
                              `${classes.scoreWrapper} ${
                                classes.scoreWrapperYellow
                              }`
                            )}
                          >
                            <span className={classes.score}>
                              {_.get(
                                difficultyAbilityDistribution,
                                "medium-conceptual",
                                0
                              )}
                            </span>
                          </span>
                        </TableCell>
                        <TableCell className={classes.scoreCell}>
                          <span
                            className={getScoreClasses(
                              _.get(
                                difficultyAbilityDistribution,
                                "medium-analytical",
                                0
                              ),
                              `${classes.scoreWrapper} ${
                                classes.scoreWrapperYellow
                              }`
                            )}
                          >
                            <span className={classes.score}>
                              {_.get(
                                difficultyAbilityDistribution,
                                "medium-analytical",
                                0
                              )}
                            </span>
                          </span>
                        </TableCell>
                        <TableCell className={classes.scoreCell}>
                          <span
                            className={getScoreClasses(
                              _.get(
                                difficultyAbilityDistribution,
                                "medium-intuitive",
                                0
                              ),
                              `${classes.scoreWrapper} ${
                                classes.scoreWrapperYellow
                              }`
                            )}
                          >
                            <span className={classes.score}>
                              {_.get(
                                difficultyAbilityDistribution,
                                "medium-intuitive",
                                0
                              )}
                            </span>
                          </span>
                        </TableCell>
                        <TableCell
                          className={classes.verticalProgressLabelCell}
                        >
                          <span>
                            {_.get(
                              difficultyAbilityDistribution,
                              "p-medium",
                              0
                            )}
                            % Medium
                          </span>
                        </TableCell>
                        <TableCell />
                      </TableRow>

                      <TableRow>
                        <TableCell className={classes.scoreCell}>
                          <span
                            className={getScoreClasses(
                              _.get(
                                difficultyAbilityDistribution,
                                "easy-conceptual",
                                0
                              ),
                              `${classes.scoreWrapper} ${
                                classes.scoreWrapperGreen
                              }`
                            )}
                          >
                            <span className={classes.score}>
                              {_.get(
                                difficultyAbilityDistribution,
                                "easy-conceptual",
                                0
                              )}
                            </span>
                          </span>
                        </TableCell>
                        <TableCell className={classes.scoreCell}>
                          <span
                            className={getScoreClasses(
                              _.get(
                                difficultyAbilityDistribution,
                                "easy-analytical",
                                0
                              ),
                              `${classes.scoreWrapper} ${
                                classes.scoreWrapperGreen
                              }`
                            )}
                          >
                            <span className={classes.score}>
                              {_.get(
                                difficultyAbilityDistribution,
                                "easy-analytical",
                                0
                              )}
                            </span>
                          </span>
                        </TableCell>
                        <TableCell className={classes.scoreCell}>
                          <span
                            className={getScoreClasses(
                              _.get(
                                difficultyAbilityDistribution,
                                "easy-intuitive",
                                0
                              ),
                              `${classes.scoreWrapper} ${
                                classes.scoreWrapperGreen
                              }`
                            )}
                          >
                            <span className={classes.score}>
                              {_.get(
                                difficultyAbilityDistribution,
                                "easy-intuitive",
                                0
                              )}
                            </span>
                          </span>
                        </TableCell>
                        <TableCell
                          className={classes.verticalProgressLabelCell}
                        >
                          <span>
                            {_.get(difficultyAbilityDistribution, "p-easy", 0)}%
                            Easy
                          </span>
                        </TableCell>
                        <TableCell />
                      </TableRow>

                      <TableRow className={classes.progressRow}>
                        <TableCell colSpan={3}>
                          <div className={classes.scoreProgressWrapper}>
                            <div
                              className={classes.progressConceptual}
                              style={{
                                width:
                                  _.get(
                                    difficultyAbilityDistribution,
                                    "p-conceptual",
                                    0
                                  ) + "%",
                              }}
                            />
                            <div
                              className={classes.progressAnalytical}
                              style={{
                                width:
                                  _.get(
                                    difficultyAbilityDistribution,
                                    "p-analytical",
                                    0
                                  ) + "%",
                              }}
                            />
                            <div
                              className={classes.progressIntutive}
                              style={{
                                width:
                                  _.get(
                                    difficultyAbilityDistribution,
                                    "p-intuitive",
                                    0
                                  ) + "%",
                              }}
                            />
                          </div>
                        </TableCell>
                        <TableCell colSpan={3} />
                      </TableRow>

                      <TableRow className={classes.progressRow}>
                        <TableCell className={classes.scoreCell}>
                          <span>
                            {_.get(
                              difficultyAbilityDistribution,
                              "p-conceptual",
                              0
                            )}
                            % <br />
                            Conceptual
                          </span>
                        </TableCell>
                        <TableCell className={classes.scoreCell}>
                          <span>
                            {_.get(
                              difficultyAbilityDistribution,
                              "p-analytical",
                              0
                            )}
                            % <br />
                            Analytical
                          </span>
                        </TableCell>
                        <TableCell className={classes.scoreCell}>
                          <span>
                            {_.get(
                              difficultyAbilityDistribution,
                              "p-intuitive",
                              0
                            )}
                            % <br />
                            Intutive
                          </span>
                        </TableCell>
                        <TableCell colSpan={3} />
                      </TableRow>
                    </TableBody>
                  </Table>
                </Grid>
              </Grid>
            </Grid>
            <Grid item xs={6}>
              <Grid container className={classes.mb30} alignItems="center">
                <Grid item xs={5}>
                  <Typography
                    variant="body1"
                    align="center"
                  >
                    <strong>Distribution: </strong>
                  </Typography>
                </Grid>

                <Grid item xs={7}>
                    <Grid container justify="space-between" alignItems="center">
                      <Grid item>
                        <span
                          onClick={() =>
                            this.setCurrentlyActiveDistribution(Distribution.QUESTION)
                          }
                          className={classNames(
                            classes.distributionTabs,
                            this.getTabStateClasses(Distribution.QUESTION),
                          )}
                        >
                          Question Type 
                        </span>
                      </Grid>
                      <Grid item>
                        <span
                          onClick={() =>
                            this.setCurrentlyActiveDistribution(Distribution.SUBJECT)
                          }
                          className={[
                            classes.distributionTabs,
                            this.getTabStateClasses(Distribution.SUBJECT),
                          ].join(" ")}
                        >
                          Subject Wise
                        </span>
                      </Grid>
                    </Grid>
                </Grid>
              </Grid>

              <Grid container>
                <Grid item xs={6}>
                  {this.state.activeTypeOfDistribution === Distribution.QUESTION ? (
                    <>
                      <div
                        id="question-type-chart"
                        style={{ display: "flex", maxWidth: 700 }}
                      />
                      {this.drawPieChart(
                        "#question-type-chart",
                        questionTypeChartData,
                        {},
                        {},
                        questionTypeData.chartLabels,
                        questionTypeData.chartPercent,
                        "question"
                      )}
                    </>
                  ) : (
                    <>
                      <div id="subject-wise-chart" />
                      {this.drawPieChart(
                        "#subject-wise-chart",
                        subjectWiseChartData,
                        {},
                        {},
                        subjectWiseData.chartLabels,
                        subjectWiseData.chartPercent,
                        "section"
                      )}
                    </>
                  )}
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </>

        {/* <div className={classes.borderBox}> */}
          {/* <Grid container> */}
            {/* <Grid item sm={6}> */}
              {/* <Typography
                variant="body1"
                align="center"
                className={classes.mb2x}
              >
                <strong>Question Type Distribution</strong>
              </Typography> */}
              {/* <div
                id="question-type-chart"
                style={{ display: "flex", maxWidth: 700 }}
              />
              {this.drawPieChart(
                "#question-type-chart",
                questionTypeChartData,
                {},
                {},
                questionTypeData.chartLabels,
                questionTypeData.chartPercent,
                "question"
              )} */}
            {/* </Grid> */}
            {/* <Grid item sm={6}> */}
              {/* <Typography
                variant="body1"
                align="center"
                className={classes.mb2x}
              >
                <strong>Subject Wise Distribution</strong>
              </Typography>
              <div id="subject-wise-chart" />
              {this.drawPieChart(
                "#subject-wise-chart",
                subjectWiseChartData,
                {},
                {},
                subjectWiseData.chartLabels,
                subjectWiseData.chartPercent,
                "section"
              )} */}
            {/* </Grid>
          </Grid>
        </div> */}
      </>
    );
  };

  handleRepublishQueueChange(event: any) {
    const { value } = event.target;
    this.setState({
      republishQueue: value,
    });
  }

  validateForm(template: any) {
    let disable = false;
    template.sections &&
      template.sections.map((element: any) => {
        element.subSection &&
          element.subSection.map((el: any) => {
            if (
              parseInt(el.positiveMarks) >= 0 &&
              parseInt(el.negativeMarks) >= 0 &&
              parseInt(el.noOfQuestions) >= 0 &&
              parseInt(el.partialMarks) >= 0
            ) {
              disable = false;
            } else {
              disable = true;
            }
          });
      });
    return disable;
  }

  patchTemplateForSaving = (
    template: TestTemplateBody,
    testPaperSubType?: any
  ) => {
    const totalMarks = template.sections.reduce(
      (acc, { totalMarks }) => acc + totalMarks,
      0
    );
    template.totalMarks = totalMarks;
    template.noOfSections = template.sections.length;

    if (template.isMaster) {
      // @ts-ignore
      delete template.isMaster;
      // @ts-ignore
      delete template._id;
    }

    if (template._id === "") {
      // @ts-ignore
      delete template._id;
    }

    const noOfSubSections = template.sections.reduce(
      (acc, { subSection }) => acc + subSection.length,
      0
    );
    template.subSectionsCount = noOfSubSections;
    const totalQuestions = template.sections.reduce((acc, { subSection }) => {
      const noOfQuestionsInSubSection = subSection.reduce((acc, subsection) => {
        let { noOfQuestions } = subsection;
        // set noOfQuestion in subsection to a number if a string
        noOfQuestions = parseInt(noOfQuestions.toString()) || 0;
        subsection.noOfQuestions = noOfQuestions;

        return acc + noOfQuestions;
      }, 0);
      return acc + parseInt(noOfQuestionsInSubSection.toString());
    }, 0);
    template.questionsCount = parseInt(totalQuestions.toString());

    // Remove _id for sections and subSection if they are empty
    template.sections.forEach((section) => {
      if (!section._id) {
        // @ts-ignore
        delete section._id;
      }
      section.subSection.forEach((subSection) => {
        if (!subSection._id) {
          // @ts-ignore
          delete subSection._id;
        }
      });
    });

    if (testPaperSubType) {
      template.testDurationNumber = testPaperSubType.time;
      template.testDurationType = testPaperSubType.timeType;
      template.testSectionLevel = testPaperSubType.sectionLevel;
      template.testTypeCode = testPaperSubType.code;
      template.testTemplateTypeId = testPaperSubType._id;
    }
    return template;
  };
  setTemplateAsSelected = (template: TestTemplateBody) => {
    this.setState(
      (prevState) => {
        const templates = [template, ...prevState.templates];
        return {
          ...prevState,
          templates,
          isCreatetabel: false,
          toShow: true,
        };
      },
      () => this.handleTemplateSelect(template._id, template)
    );
  };
  saveTemplate = () => {
    const { subType, testPaperContentSubtype,formData } = this.props;
    const {testTemplateTypeId}=formData;
    let template = JSON.parse(JSON.stringify(this.state.newtemplate));
    const testPaperSubType = testPaperContentSubtype.find(
      ({ code,_id}) => testTemplateTypeId ?_id===testTemplateTypeId:code === subType
    );
    template = this.patchTemplateForSaving(template, testPaperSubType);

    saveTestTemplate(template).then((createdTemplate: TestTemplateBody) => {
      this.setTemplateAsSelected(createdTemplate);
      this.setState({
        newtemplate: JSON.parse(JSON.stringify(this.templateRequestB)),
      });
      if (this.state.isEditMode) {
        this.handleEditDetail();
      }
    });
  };

  editTestTemplate = (index: number) => {
    const { templateCurrentlyEditing } = this.state;
    let updateTemplate = JSON.parse(JSON.stringify(templateCurrentlyEditing));

    updateTemplate = this.patchTemplateForSaving(updateTemplate);

    updateTestTemplate(updateTemplate).then((res: TestTemplateBody) => {
      this.setState((prevState) => {
        const newtemplates = [...prevState.templates];
        newtemplates[index] = res;
        return {
          ...prevState,
          templates: newtemplates,
          isEditMode: false,
          templateCurrentlyEditing: JSON.parse(
            JSON.stringify(this.templateRequestB)
          ),
        };
      });
    });
  };

  addContentDialog() {
    const { classes } = this.props;
    const {
      selectQuestionDialogOpen,
      selectQuestionDialogData,
      preSelectedFilterContent,
      bucketsToBeShown,
      testPaperSpecialPurpose
    } = this.state;
    let {
      selectedTempQuestions,
      selectedTrackedQuestionIds,
      isMannualSwap,
    } = this.state;
    const { quesCodeAllowed } = selectQuestionDialogData;
    const otherDialogProps = {
      fullScreen: true,
    };
    let selectedQuestionsCount = 0;
    if (quesCodeAllowed == 5) {
      let content_Ids: any = new Set(
        selectedTempQuestions.map((content: ContentData) => content.content_Id)
      );
      const passageDataSet = new Set();
      selectedTempQuestions.forEach(({ passageData }) => {
        if (passageData) {
          passageData.forEach(({ id, content_Id }: any) => {
            const identifier = id || content_Id;
            passageDataSet.add(identifier);
          });
        }
      });
      selectedTempQuestions.forEach((content: ContentData) => {
        if (content_Ids.has(content.content_Id)) {
          if (content.passageData) {
            content.passageData.forEach(({ id, content_Id }: any) => {
              const identifier = id || content_Id;
              if (passageDataSet.has(identifier)) {
                selectedQuestionsCount += 1;
                passageDataSet.delete(identifier);
              }
            });
          }
          content_Ids.delete(content.content_Id);
        }
      });
    } else {
      selectedQuestionsCount = selectedTempQuestions.length;
    }

    return (
      <Dialog {...otherDialogProps} open={selectQuestionDialogOpen}>
        <div style={{ width: "auto" }}>
          <DialogTitle classes={{ root: classes.dialogTitle }}>
            <>
              <Grid container justify="space-between" alignItems="center">
                <Grid item xs="auto">
                  <Typography
                    color="textPrimary"
                    variant="body1"
                    style={{ cursor: "pointer" }}
                    onClick={this.handleBackToTestpaperClick.bind(this)}
                  >
                    <BackIcon classes={{ root: classes.backIconRoot }} />
                    <strong>Back to Test Paper Question</strong>
                  </Typography>
                </Grid>
                <Grid item xs />
                <Grid item xs="auto">
                  <Typography variant="caption" inline>
                    {selectedQuestionsCount}/
                    {selectQuestionDialogData.noOfQuestions} Selected
                  </Typography>
                  <Button
                    variant="contained"
                    color="primary"
                    disabled={
                      selectedQuestionsCount >
                      selectQuestionDialogData.noOfQuestions
                    }
                    className={classes.ml1x}
                    onClick={this.handleAddContentClick.bind(this)}
                  >
                    Add Content
                  </Button>
                </Grid>
              </Grid>
            </>
          </DialogTitle>
          <DialogContent classes={{ root: classes.dialogContent }}>
            <PerfectScrollbar
              className={`dialog-content ${classes.perfectScrollbar}`}
            >
              <WithContent
                isInPopUp={true}
                selectedQuestions={selectedTempQuestions}
                selectedTrackedQuestionIds={selectedTrackedQuestionIds}
                onContentSelect={this.handleContentSelect.bind(this)}
                onContentSelectAll={this.handleContentSelectAll.bind(this)}
                onCheckContentExist={this.handleCheckContentExist.bind(this)}
                selectedFilterContent={preSelectedFilterContent}
                fromTestPaper={true}
                alwaysFetchCoursesInGoalDriller={true}
                fromTestCreate={true}
                preSelectedBucket={testPaperSpecialPurpose}
                bucketsToDisplay={bucketsToBeShown}
              />
            </PerfectScrollbar>
          </DialogContent>
        </div>
      </Dialog>
    );
  }

  createData(filteredTemplates: any, questionData: any) {
    let { data } = this.state;
    let section_id = _.get(filteredTemplates[0], "sections[0]._id", "");
    let subsection_id = _.get(
      filteredTemplates[0],
      "sections[0].subSection[0]._id",
      ""
    );

    let tempdata = {
      quesCodeAllowed: 0,
      questions: [questionData],
      sectionId: section_id,
      subSectionId: subsection_id,
    };
    data.push(tempdata);
    this.setState({ data });
  }

  getCustomHeading = () => {
    const { classes, formData, clickedfeedbackData } = this.props;
    return (
      <Grid
        container
        alignItems="center"
        justify="space-between"
        wrap="nowrap"
        className={classes.p0}
      >
        <Grid item xs="auto">
          <Typography variant="h6" className={classes.cardHeading}>
            Add Test Syllabus -above
            <CustomInfoIcon
              infoDialogContentType="Goal Management"
              isInfoIcon={true}
              isRightArrow={false}
              isCenterArrow={true}
              knowMoreAbout={false}
              dialogTitle="Create Test"
              imageURL="/assets/svg/infoIcon/createQuestion/information.svg"
              dialogPara="Add the syllabus which will be communicated to the students for preparation before the test. Start by adding the chapters or directly select the complete subject."
              details="Click to know more"
              toolTipDirection="top"
            />
          </Typography>
        </Grid>
        {/* {!_.isEmpty(formData) && (
          <Grid item xs="auto">
            <SuccessIcon className={classes.successIcon} />
          </Grid>
        )} */}
      </Grid>
    );
  };

  setModalVisibilityTrigger(triggerFn: Function) {
    const { setModalFunction } = this.props;
    setModalFunction(triggerFn);
  }

  handleClose = () => {
    const { history } = this.props;
    history.push("/");
  };

  handleDialogClose = () => {
    this.setState({
      showDialog: false,
      isGraceMarksOverrideActive: false,
      isAddToQueue: false,
      republishQueue: "",
    });
    this.currentGraceMarkQuestion = [];
  };

  handleEditMarksActiveClose = () => {
    this.setState({
      isEditMarkingActive: false,
      isEditMarkingActive423: false,
    });
  };

  handleAddToQueue = async (addToQueueOverride = false) => {
    const { formData } = this.props;
    const postData = {
      type: "GRACE_MARKS",
      testId: formData._id,
      testName: formData.name,
      sectionId: this.currentGraceMarkQuestion.sectionId,
      subSectionId: this.currentGraceMarkQuestion.subSectionId,
      //@ts-ignore
      testContentId: formData.contentId,
      questionId: this.currentGraceMarkQuestion.content_Id,
      questionSerialNo: this.currentGraceMarkQuestion.questionSerialNo,
      questionContentId: this.currentGraceMarkQuestion.contentId,
      questionType:
        QUESTION_TYPES_ARRAY[
          parseInt(this.currentGraceMarkQuestion.contentSubTypeCode)
        ],
      graceMarks: this.state.graceMraks,
      graceMarksType: this.state.isGraceStudents ? "ATTEMPTED" : "ALL",
      republishReason: this.state.republishQueue
        ? this.state.republishQueue
        : "",
      addToQueueOverride,
    };
    const res = await contentService.addToQueue(postData);
    if (res.statusCode == 422) {
      //set state there jainedra
      //()=>{this.handleAddToQueue(true)}
      this.setState({ isGraceMarksOverrideActive: true });
    } else {
      this.props.setHasMylibraryQueue();
      this.state.disbaleContentList.add(
        this.currentGraceMarkQuestion.contentId
      );
      this.setState({ isGraceMarksOverrideActive: false });
    }
    this.setState({
      showDialog: false,
      isAddToQueue: false,
      disbaleContentList: this.state.disbaleContentList,
      republishQueue: "",
    });
  };

  setGraceMarks = (e: any) => {
    if (e.target.value >= 0) {
      this.setState({ graceMraks: e.target.value });
    } else {
      this.setState({ graceMraks: e.target.value * -0 });
    }
  };

  handleAnswerChange = () => {
    //add your functional code here
  };

  handleAllStudentsGrace = () => {
    this.setState({ isGraceStudents: !this.state.isGraceStudents });
  };

  handleGraceChanges = () => {
    this.setState({ isGraceStudents: !this.state.isGraceStudents });
  };

  addToQueueMarkingChanges = () => {
    this.setState({ isChangeMarkingShemeOpen: true });
    this.closeEditTemplate();
  };

  addToQueueMarkingSheme = async (addToQueueOverride = false) => {
    if (this.updatedFilterTemplateData) {
      const { formData } = this.props;
      const _formData = JSON.parse(
        JSON.stringify(this.updatedFilterTemplateData)
      );
      _formData.type = "MARKING_SCHEME";
      _formData.testName = formData.name; // test
      //@ts-ignore
      _formData.testContentId = formData.contentId; //  test
      _formData.testId = formData._id; // test
      _formData.addToQueueOverride = addToQueueOverride;

      // set courseSyllabusId to null if it is empty as per api requirement
      _formData.sections.forEach((section: any) => {
        if (section.courseSyllabusId !== undefined) {
          section.courseSyllabusId = _.isEmpty(section.courseSyllabusId)
            ? null
            : section.courseSyllabusId;
        }
      });

      const res = await contentService.addToQueue(_formData);
      if (res.statusCode == 424) {
        this.setState({
          markingShemeOverwriteMsg: res.responseMessage,
          isEditMarkingActive: true,
        });
      } else if (res.statusCode == 423) {
        //set state there jainedra
        //()=>{this.handleAddToQueue(true)}
        this.setState({
          isEditMarkingActive423: true,
          markingShemeOverwriteMsg: res.responseMessage,
        });
      } else {
        this.props.setHasMylibraryQueue();
        this.setState({
          disableEditTemplate: true,
          isEditMarkingActive423: false,
          isEditMarkingActive: false,
          markingShemeOverwriteMsg: "",
        });
      }
    }
    this.closeMarkingSheme();
  };

  closeEditTemplate = () => {
    this.setState({ isEditTemplateOpen: false });
  };

  closeMarkingSheme = () => {
    this.setState({ isChangeMarkingShemeOpen: false });
  };

  handleEditDetail = () => {
    this.setState({
      isEditMode: !this.state.isEditMode,
    });
  };
  handleEditTable = (template: TestTemplateBody) => {
    this.getCourseSyllabus(template.courseId);
    this.setState({
      isEditMode: !this.state.isEditMode,
      isNotEditingTemplatetable: false,
      templateCurrentlyEditing: JSON.parse(JSON.stringify(template)),
    });
    this.handleQuestionLimit(template);
  };
  handleQuestionLimit = (data: any) => {
    data.sections &&
      data.sections.map((element: any) => {
        element.subSection &&
          element.subSection.map((el: any) => {
            if (el.questionsCount >= 500) {
              this.setState({
                isQuestioneExceedLimit: !this.state.isQuestioneExceedLimit,
              });
            }
          });
      });
  };
  getSubSectionFilters(subSectionId: string) {
    const selectedFilters = this.state.filters;
    let filters = {
      difficultyTypes: [],
      difficultyLevels: [],
      goalLevelId: "",
      contentTags: [],
    };

    if (selectedFilters.hasOwnProperty(subSectionId)) {
      return selectedFilters[subSectionId];
    }
    return filters;
  }
  handleRefreshBttn = (
    sectionId: string,
    noOfQuestions: number,
    quesCodeAllowed: number,
    subSectionId: string,
    replaceIndex: number,
    replaceIndexJ: number,
    selectedQuestion?: any,
    addedQuestions: any = []
  ) => {
    let { formData } = this.props;
    let {
      courseName,
      templates,
      selectedSectionId,
      selectedTemplateId,
      generateAutomatic,
    } = this.state;

    let filteredTemplate = templates.filter((t) => t._id == selectedTemplateId);
    let sections = _.get(filteredTemplate, "[0].sections", []).filter(
      (s: any) => s._id == sectionId
    );
    let testSectionLevel = _.get(
      filteredTemplate,
      "[0].testSectionLevel",
      "course"
    );
    let autoPickSection = _.get(sections, "[0].autoPickSelection", false);
    let courseSyllabusId = _.get(sections, "[0].courseSyllabusId", "");
    let nextLevel = "subject";
    let { data } = this.state;
    if (testSectionLevel == "subject") {
      nextLevel = "sub-subject";
    } else if (testSectionLevel == "sub-subject") {
      nextLevel = "chapter";
    } else if (testSectionLevel == "chapter" || testSectionLevel == "concept") {
      nextLevel = "concept";
    }

    let goalsDriller: any = {};
    if (testSectionLevel != "none" && !autoPickSection) {
      goalsDriller = {
        level: nextLevel,
        course: {
          _id: _.get(formData, "courseId[0]", ""),
          name: courseName,
        },
      };

      goalsDriller[testSectionLevel] = {
        _id: _.get(courseSyllabusId, "_id", ""),
        name: _.get(courseSyllabusId, "name", ""),
      };
      _.get(courseSyllabusId, "ancestors", []).forEach((a: any) => {
        goalsDriller[a.type == "sub-subject" ? "subSubject" : a.type] = {
          _id: _.get(a, "_id", ""),
          name: _.get(a, "name", ""),
        };
      });
    } else if (autoPickSection) {
      goalsDriller = {
        level: "subject",
        course: {
          _id: _.get(formData, "courseId[0]", ""),
          name: courseName,
        },
      };
    }

    const filters = this.getSubSectionFilters(subSectionId);
    if (this.state.showContentTagFilter) {
      this.removeEmptyValuesTags(filters);
    }
    let {
      difficultyLevels,
      difficultyTypes,
      goalLevelId,
      contentTags,
    } = filters;
    let content_Id = "";
    let { groupId } = formData;
    let courseSyllabusIds = [];
    if (typeof courseSyllabusId === "string") {
      courseSyllabusIds = [courseSyllabusId];
    } else courseSyllabusIds = [courseSyllabusId._id];

    let reqBody = {
      count: noOfQuestions,
      questionCode: quesCodeAllowed,
      courseSyllabusIds,
      groupId,
      difficultyLevels,
      difficultyTypes,
      goalLevelId,
      contentTags,
      bucketType: (formData.specialPurposes && formData.specialPurposes[0]) || CONTENT_SECTION_KEYS.GLORIFIRE,
    };

    generateAutomatic[`${subSectionId}`] = true;
    if (replaceIndex !== -1) {
      content_Id = selectedQuestion[0] && selectedQuestion[0].content_id;
      subjectsServices.getRandomQuestions(reqBody).then((res) => {
        const { selectedTempQuestions } = this.state;
        let newSelectedTempQuestions = res.selectedQuestions;
        this.setState(
          {
            selectedTempQuestions: newSelectedTempQuestions,
            generateAutomatic,
            selectQuestionDialogData: {
              sectionId,
              subSectionId,
              quesCodeAllowed,
              noOfQuestions,
              replaceIndex,
              replaceIndexJ,
              content_Id,
              addedQuestions,
            },
          },
          () => {
            this.handleAddContentClick(false);
          }
        );
      });
    } else {
      this.props.getAutoQuestions(reqBody);

      this.setState({
        selectQuestionDialogOpen: false,
        selectQuestionDialogData: {
          sectionId,
          subSectionId,
          quesCodeAllowed,
          noOfQuestions,
          replaceIndex,
          replaceIndexJ,
          content_Id,
          addedQuestions,
        },
        generateAutomatic,
      }, () => {
      });
    }
    this.getFilteredContent();
    this.props.setSectionCurrentlyEditing("testQuestions");
  };

  handleFilter = () => {
    this.setState({ isDialogFilter: !this.state.isDialogFilter });
  };
  setGoalLevelId = (e: any) => {
    this.setState({ goalLevelId: e.target.value });
    const subSection = this.getCurrentSubsection();
    const { data, groupId } = this.props.formData;
    let sections = _.get(data, "sections", []).filter(
      (s: any) => s._id == this.state.selectedSectionId
    );
    let courseSyllabusId = _.get(
      sections,
      "[0].courseSyllabusId._id",
      sections[0].courseSyllabusId
    );

    let courseSyllabusIds = [courseSyllabusId];
    const { formData } = this.props;
    let reqBody = {
      questionCode: subSection[0].quesCodeAllowed,
      courseSyllabusIds,
      groupId,
      difficultyLevels: this.state.difficultyLevels,
      difficultyTypes: this.state.difficultyTypes,
      goalLevelId: e.target.value,
      bucketType: (formData.specialPurposes && formData.specialPurposes[0]) || CONTENT_SECTION_KEYS.GLORIFIRE,
    };
    this.props.getAutoQuesCount(reqBody);
  };
  getCurrentSubsection() {
    const { data } = this.props.formData;
    const { selectedSectionId, selectedSubSectionId } = this.state;
    let sections = _.get(data, "sections", []).filter(
      (s: any) => s._id == selectedSectionId
    );

    let subSections = sections[0].subSection.filter(
      (subSection: any) => subSection._id == selectedSubSectionId
    );
    return subSections;
  }
  removeEmptyValuesTags(reqBody: any) {
    let tags = reqBody.contentTags;
    reqBody.contentTags = tags.filter((tag: any) => tag.values.length > 0);
  }
  handleFilterChange = (e: any) => {
    let check = false;
    if (e.target.name == "difficultyLvl") check = true;
    const options = check
      ? this.state.difficultyLevels
      : this.state.difficultyTypes;
    let index;
    if (e.target.checked) {
      options.push(e.target.value);
    } else {
      index = options.indexOf(e.target.value);
      options.splice(index, 1);
    }
    const subSection = this.getCurrentSubsection();
    const { data, groupId } = this.props.formData;
    let sections = _.get(data, "sections", []).filter(
      (s: any) => s._id == this.state.selectedSectionId
    );

    let courseSyllabusId = _.get(
      sections,
      "[0].courseSyllabusId._id",
      sections[0].courseSyllabusId
    );

    let courseSyllabusIds = [courseSyllabusId];
    const { formData } =this.props;
    let reqBody = {
      questionCode: subSection[0].quesCodeAllowed,
      courseSyllabusIds,
      groupId,
      difficultyLevels: check ? options : this.state.difficultyLevels,
      difficultyTypes: check ? this.state.difficultyTypes : options,
      goalLevelId: this.state.goalLevelId,
      contentTags: this.state.showContentTagFilter ? this.getContentTags() : [],
      bucketType: (formData.specialPurposes && formData.specialPurposes[0]) || CONTENT_SECTION_KEYS.GLORIFIRE,
    };
    if (this.state.showContentTagFilter) {
      this.removeEmptyValuesTags(reqBody);
    }
    this.props.getAutoQuesCount(reqBody);
    check
      ? this.setState({ difficultyLevels: options })
      : this.setState({ difficultyTypes: options });
  };
  saveFilters() {
    const { selectedSectionId, selectedSubSectionId } = this.state;
    const { formData } = this.props;
    const { data } = formData;
    let contentTags: any[] = [];
    if (this.state.showContentTagFilter) {
      contentTags = this.getContentTags();
    }
    const filterObj = {
      difficultyLevels: [...this.state.difficultyLevels],
      difficultyTypes: [...this.state.difficultyTypes],
      goalLevelId: this.state.goalLevelId,
      contentTags: [...contentTags],
    };

    let tempFilters = this.state.filters;

    tempFilters[`${selectedSubSectionId}`] = filterObj;
    const subSection = this.getCurrentSubsection();
    let { noOfQuestions, quesCodeAllowed } = subSection[0];
    this.handleRefreshBttn(
      selectedSectionId,
      noOfQuestions,
      quesCodeAllowed,
      selectedSubSectionId,
      -1,
      -1
    );
    this.setState({
      filters: tempFilters,
      isDialogFilter: !this.state.isDialogFilter,
    });
  }
  removeFilters() {
    const filters = this.getSubSectionFilters(this.state.selectedSubSectionId);
    const {
      difficultyLevels,
      difficultyTypes,
      goalLevelId,
      contentTags,
    } = filters;
    let skill: string[] = [],
      patternType: string = "",
      patterns: string[] = [],
      concepts: string[] = [];
    if (this.state.showContentTagFilter && contentTags.length > 0) {
      contentTags.forEach((element: any) => {
        if (element.name == "Concept Categorization") {
          concepts = element.values;
        } else if (element.name == "Objective Pattern Type") {
          patternType = "Objective";
          patterns = element.values;
        } else if (element.name == "Subjective Pattern Type") {
          patternType = "Subjective";
          patterns = element.values;
        } else {
          skill = element.values;
        }
      });
    }
    this.setState(
      {
        difficultyLevels: [...difficultyLevels],
        difficultyTypes: [...difficultyTypes],
        goalLevelId,
        isDialogFilter: false,
        selectedskill: [...skill],
        selectedConcepts: [...concepts],
        selectedPattern: [...patterns],
        patternType: patternType,
      },
      () => {
        this.getFilteredContent();
      }
    );
  }
  getAddedQuestions(data: any, sectionId: any, subSectionId: any) {
    const questions = _.get(
      _.find(data, {
        sectionId: sectionId,
        subSectionId: subSectionId,
      }),
      "questions",
      []
    );
    let count = 0;
    for (let i = 0; i < questions.length; i++) {
      if (questions[i].contentId) {
        count++;
      }
    }
    return count;
  }
  addTemplateNameToCurrentlyEditingTemplate = (testTemplateName: string) => {
    this.setState(prevState => {
      const newTemplate = prevState.templateCurrentlyEditing;
      newTemplate.name = testTemplateName;
      return {
        ...prevState,
        templateCurrentlyEditing: newTemplate
      }
    })
  }
  addTemplateNameToNewTemplate = (testTemplateName: string) => {
    this.setState((prevState) => {
      const newtemplate = prevState.newtemplate;
      newtemplate.name = testTemplateName;
      return {
        ...prevState,
        newtemplate,
        updatedTestName: testTemplateName,
        isTestNameChanged: true,
        showEditButton: true,
        UpdateNameOfTable: true,
      };
    });
  };
  handleSelectClose = (type: string) => {
    if (type == "concepts") {
      this.setState({ isSelectConceptOpen: false });
    } else this.setState({ isSelectPatternOpen: false });
  };

  handleSelectOpen = (type: string) => {
    if (type == "concepts") this.setState({ isSelectConceptOpen: true });
    else this.setState({ isSelectPatternOpen: true });
  };
  handleMultiSelect(event: any) {
    let newSelectedPattern = [...this.state.selectedPattern];
    if (newSelectedPattern.includes(event)) {
      let index = newSelectedPattern.indexOf(event);
      newSelectedPattern.splice(index, 1);
    } else {
      newSelectedPattern.push(event);
    }
    this.setState({ selectedPattern: newSelectedPattern }, () => {
      this.getFilteredContent();
    });
  }
  handleConceptMultiSelect(event: any) {
    let newSelectedConcepts = [...this.state.selectedConcepts];
    if (newSelectedConcepts.includes(event)) {
      let index = newSelectedConcepts.indexOf(event);
      newSelectedConcepts.splice(index, 1);
    } else {
      newSelectedConcepts.push(event);
    }
    this.setState({ selectedConcepts: newSelectedConcepts }, () => {
      this.getFilteredContent();
    });
  }
  handleMultiSelectskill(event: any) {
    let newSelectedskill = [...this.state.selectedskill];
    if (newSelectedskill.includes(event)) {
      let index = newSelectedskill.indexOf(event);
      newSelectedskill.splice(index, 1);
    } else {
      newSelectedskill.push(event);
    }
    this.setState({ selectedskill: newSelectedskill }, () => {
      this.getFilteredContent();
    });
  }
  handlePatternType(event: any) {
    this.setState({ patternType: event.target.value, selectedPattern: [] });
  }
  getContentTags() {
    const contentTags = [
      {
        name: "Concept Categorization",
        values: [...this.state.selectedConcepts],
      },
      {
        name: "Skill",
        values: [...this.state.selectedskill],
      },
    ];
    if (this.state.patternType != "") {
      contentTags.push({
        name: `${this.state.patternType} Pattern Type`,
        values: [...this.state.selectedPattern],
      });
    }
    return contentTags;
  }
  getFilteredContent() {
    const { formData } = this.props;
    const subSection = this.getCurrentSubsection();
    const { data, groupId } = this.props.formData;
    let sections = _.get(data, "sections", []).filter(
      (s: any) => s._id == this.state.selectedSectionId
    );

    let courseSyllabusId = _.get(
      sections,
      "[0].courseSyllabusId._id",
      sections[0].courseSyllabusId
    );

    let courseSyllabusIds = [courseSyllabusId];
    

    let reqBody: any = {
      questionCode: subSection[0].quesCodeAllowed,
      courseSyllabusIds,
      groupId,
      difficultyLevels: this.state.difficultyLevels,
      difficultyTypes: this.state.difficultyTypes,
      goalLevelId: this.state.goalLevelId,
      bucketType: (formData.specialPurposes && formData.specialPurposes[0]) || CONTENT_SECTION_KEYS.GLORIFIRE,
      
    };
    if (this.state.showContentTagFilter) {
      let contentTags = this.getContentTags();
      reqBody.contentTags = contentTags;
      this.removeEmptyValuesTags(reqBody);
    }
    this.props.getAutoQuesCount(reqBody);
  }
  getSyllabusCustomHeading = () => {
    const { classes, clickedfeedbackData } = this.props;
    return (
      <Grid
        container
        alignItems="center"
        justify="space-between"
        wrap="nowrap"
        className={classes.p0}
      >
        <Grid item xs="auto">
          <Typography
            variant="h6"
            onClick={(event) => {
              event.stopPropagation();
              this.addFeedback("testSyllabus")}}
            className={classes.cardHeading}
          >
            <span
              id={
                this.props.openFeedback && this.state.tag === "testSyllabus"
                  ? "feedbackScroll"
                  : ""
              }
              className={`${classes.feedbackContainer} ${
                this.props.openFeedback && this.state.tag === "testSyllabus"
                  ? classes.blueColor
                  : ""
              } ${this.props.openFeedback ? classes.feedbackHighlight : ""}`}
            >
              Add Test Syllabus
              {this.props.openFeedback && this.state.tag === "testSyllabus" && (
                <Grid className="feedbackBlock">
                  <AddFeedback
                    replyFeedback={this.replyFeedback}
                    closeFeedback={this.closeFeedback}
                    resolveFeedback={this.resolveFeedback}
                    clickedfeedbackData={clickedfeedbackData}
                    addNewFeedback={this.addNewFeedback}
                    author={this.props.authorType}
                  />
                </Grid>
              )}
            </span>

            <CustomInfoIcon
              infoDialogContentType="Goal Management"
              isInfoIcon={true}
              isRightArrow={false}
              isCenterArrow={true}
              knowMoreAbout={false}
              dialogTitle="Create Test"
              imageURL="/assets/svg/infoIcon/createQuestion/information.svg"
              dialogPara="Add the syllabus which will be communicated to the students for preparation before the test. Start by adding the chapters or directly select the complete subject."
              details="Click to know more"
              toolTipDirection="top"
            />
          </Typography>
        </Grid>
      </Grid>
    );
  };
  setSubjects = (subjects: any[]) => {
    const testId = _.get(this.props.content, "contentId", "");
    const newSubjects = JSON.parse(JSON.stringify(subjects));
    convertSubjectIdFromObjectToString(newSubjects)
    this.props.updateSubjects({ testId, subjects: newSubjects });
    // this.props.eventFired("conceptCode", statusType.edit);
  };
  getTabStateClasses = (tab: Distribution) => {
    const { classes } = this.props;
    return this.state.activeTypeOfDistribution === tab
      ? classes.tabsActive
      : classes.tabsInactive;
  };
  setCurrentlyActiveDistribution = (distribution: Distribution) => {
    this.setState({
      activeTypeOfDistribution: distribution
    })
  }
  getAppliedFiltersCount = (subSectionId: string) => {
    const { filters } = this.state;
    if(!filters || _.isEmpty(filters) || !filters[subSectionId]) {
      return 0;
    }
    const appliedFilters = filters[subSectionId];

    return Object.values(appliedFilters).reduce((acc: number, filterValue: any) => {
      if(Array.isArray(filterValue)) {
        acc+=filterValue.length;
      } else if (filterValue) {
        acc+=1
      }
      return acc;
    }, 0)

    

  }
  render() {
    const {
      classes,
      formData,
      formDataError,
      subType,
      backFromQuestion,
      questionData,
      content,
      contentsubType,
      goalLevels,
      testPaperContentSubtype,
      clickedfeedbackData,
      editRights,
      loadingCount,
      match,
    } = this.props;
    const lockData = _.get(formData, "lockData");
    let isLock = false;
    let message = "";
    if (lockData) {
      isLock = lockData.isLock;
      message = lockData.message;
    }
    const {
      selectedTemplateId,
      courseName,
      showDialog,
      isGraceStudents,
      isEditTemplateOpen,
      isGraceMarksOverrideActive,
      markingShemeOverwriteMsg,
      isEditMarkingActive,
      isEditMarkingActive423,
      graceMraks,
      isEditMode,
      courseSyllabusList,
      difficultyTypes,
      difficultyLevels,
      standardTemplate,
      isDelete,
      filters,
      showTemplateNamePopup,
      generateAutomatic,
      templateCurrentlyEditing,
      isCreatetabel,
      selectedConcepts,
      selectedPattern,
      selectedskill,
      showContentTagFilter,
      data
    } = this.state;
    let {
      selectedSectionId,
      selectedSubSectionId,
      isSelectConceptOpen,
      isSelectPatternOpen,
    } = this.state;

    let filteredTemplates: TestTemplateBody[] = [];
    filteredTemplates = this.getSelectedTemplateList();
    const testId = _.get(content, "contentId", "");

    const defaultExpanded = true;

    const isTemplateListDisabled =
      _.get(templateCurrentlyEditing, "_id") ===
        _.get(standardTemplate, "_id") || isCreatetabel;
    const createOrEditTemplateDisabled = !_.isEmpty(selectedTemplateId);

    return (
      <>
        <MyPATExpansionPanel
          isDisable={!editRights.includes('basicDetails')}
          hasExpandIcon={true}
          variant="white"
          showErrorOnTouch
          sectionId="basicInfo" // used for scrolling to this section
          // error={formDataError["title"].error || formDataError["content"].error}
          // errorText={formDataError["title"].errorText || formDataError["content"].errorText}
          customCollapseTitle={
            <Grid
              container
              alignItems="center"
              justify="space-between"
              wrap="nowrap"
              className={classes.p0}
            >
              <Grid item xs="auto">
                <Typography
                  variant="h6"
                  className={classes.cardHeading}
                  onClick={(event) => {
                    event.stopPropagation();
                    this.addFeedback("testName")}}
                >
                  <span
                    id={
                      this.props.openFeedback && this.state.tag === "testName"
                        ? "feedbackScroll"
                        : ""
                    }
                    className={`${classes.feedbackContainer} ${
                      this.props.openFeedback && this.state.tag === "testName"
                        ? classes.blueColor
                        : ""
                    } ${
                      this.props.openFeedback ? classes.feedbackHighlight : ""
                    }`}
                  >
                    Basic Information
                    {this.props.openFeedback && this.state.tag === "testName" && (
                      <Grid className="feedbackBlock">
                        <AddFeedback
                          replyFeedback={this.replyFeedback}
                          closeFeedback={this.closeFeedback}
                          resolveFeedback={this.resolveFeedback}
                          clickedfeedbackData={clickedfeedbackData}
                          addNewFeedback={this.addNewFeedback}
                          author={this.props.authorType}
                        />
                      </Grid>
                    )}
                  </span>

                  <CustomInfoIcon
                    infoDialogContentType="Goal Management"
                    isInfoIcon={true}
                    isRightArrow={false}
                    isCenterArrow={true}
                    knowMoreAbout={false}
                    dialogTitle="Basic Information"
                    imageURL="/assets/svg/infoIcon/createQuestion/information.svg"
                    dialogPara="The Select goal in this section to get the appropriate test formats, syllabus tagging and paper balance"
                    details="Click to know more"
                    toolTipDirection="top"
                  />
                </Typography>
              </Grid>
              {/* {(!_.isEmpty(formData.name) || !_.isEmpty(courseName)) && (
                <Grid item xs className={classes.textAlignRight}>
                  <Typography variant="body1" style={{ marginRight: 25 }}>
                    <strong style={{ marginRight: 4 }}>{formData.name}</strong>
                    {!_.isEmpty(courseName) && `(${courseName})`}
                  </Typography>
                </Grid>
              )} */}
              {/* {formData.name &&
                formData.name.trim().length > 5 &&
                !_.isEmpty(courseName) && (
                  <Grid item xs="auto">
                    <SuccessIcon className={classes.successIcon} />
                  </Grid>
                )} */}
            </Grid>
          }
        >
          {this.getBasicInformation()}
        </MyPATExpansionPanel>
        {testId ? (
          <AddConceptOrChapter
            isDisable={!editRights.includes('syllabus')}
            panelProps={{
              disabled: this.collapsableEvent("goal"),
              expanded: !this.collapsableEvent("goal") && this.state.expandPanels.testSyllabus,
              onChange: this.handlePanelExpansion('testSyllabus')
            }}
            sectionId="addTestSyllabus"
            // defaultExpanded={this.expandPanel("goal")}
            tag={this.state.tag}
            customHeading={this.getSyllabusCustomHeading()}
            formData={this.props.subjects}
            handleFormChange={this.setSubjects}
            reInitialiseValues
            authorType={this.props.authorType}
            populateQuestionSyllabus={this.state.populateQuestionSyllabusRef}
            autoPopulateConcepts={this.state.autoPopulateConceptsRef}
            data={data}
            alreadyAddedQuestions={this.props.alreadyAddedQuestions}
            match={match}
          />
        ) : (
          // <AddSyllabusComponent
          // 	panelProps={{
          // 		 disabled: this.collapsableEvent("goal"),
          // 		 expanded: this.expandPanel("goal"),
          // 	}}
          // 	defaultExpanded={defaultExpanded}
          // 	testId={testId}
          // 	tag={this.state.tag}
          // 	openFeedback={this.props.openFeedback}
          // 	addFeedback={this.addFeedback}
          // 	replyFeedback={this.replyFeedback}
          // 	closeFeedback={this.closeFeedback}
          // 	resolveFeedback={this.resolveFeedback}
          // 	clickedfeedbackData={clickedfeedbackData}
          // 	addNewFeedback={this.addNewFeedback}
          // 	/>
          // TODO - make a common component later
          <MyPATExpansionPanel
            hasExpandIcon={true}
            panelProps={{
              disabled: this.collapsableEvent("goal"),
              expanded: !this.collapsableEvent("goal") && this.state.expandPanels.testSyllabus,
              onChange: this.handlePanelExpansion('testSyllabus')
              // expanded: this.expandPanel("goal"),
            }}
            // defaultExpanded={this.expandPanel("goal")}
            variant="white"
            customCollapseTitle={this.getSyllabusCustomHeading()}
          />
        )}
        <MyPATExpansionPanel
          isDisable={!editRights.includes('format')}
          panelProps={{
            disabled: this.collapsableEvent("goal"),
            expanded: !this.collapsableEvent("goal") && this.state.expandPanels.testFormat,
            onChange: this.handlePanelExpansion('testFormat')
            // expanded: this.expandPanel("goal"),
          }}
          hasExpandIcon={true}
          sectionId="testFormat"
          showErrorOnTouch
          variant="white"
          // defaultExpanded={this.expandPanel("goal")}
          customCollapseTitle={
            <Grid
              container
              alignItems="center"
              justify="space-between"
              wrap="nowrap"
              className={classes.p0}
            >
              <Grid item xs="auto">
                <Typography variant="h6" className={classes.cardHeading}>
                  Test Format&nbsp;
                  <CustomInfoIcon
                    infoDialogContentType="Goal Management"
                    isInfoIcon={true}
                    isRightArrow={false}
                    isCenterArrow={true}
                    knowMoreAbout={false}
                    dialogTitle="Create Test"
                    imageURL="/assets/svg/infoIcon/createQuestion/information.svg"
                    dialogPara="Based on the goal selected, standard test format will appear. You can edit it or choose any template from the existing templates."
                    details="Click to know more"
                    toolTipDirection="top"
                  />
                </Typography>
              </Grid>
              {/* {!_.isEmpty(selectedTemplateId) && (
                <Grid item xs="auto">
                  <SuccessIcon className={classes.successIcon} />
                </Grid>
              )} */}
            </Grid>
          }
        >
          {this.getTemplates()}
        </MyPATExpansionPanel>

        <MyPATExpansionPanel
          isDisable={!editRights.includes('questions')}
          panelProps={{
            disabled: this.collapsableEvent("selectedTemplateId"),
            expanded: !this.collapsableEvent("selectedTemplateId") && this.state.expandPanels.testQuestions,
            onChange: this.handlePanelExpansion('testQuestions')
            // expanded: this.expandPanel("selectedTemplateId"),
          }}
          hasExpandIcon
          defaultExpanded={this.expandPanel("selectedTemplateId")}
          sectionId="testQuestions"
          variant="white"
          showErrorOnTouch
          customCollapseTitle={
            <Grid
              container
              alignItems="center"
              justify="space-between"
              wrap="nowrap"
              className={classes.p0}
            >
              <Grid item xs="auto">
                <Typography
                  variant="h6"
                  className={classes.cardHeading}
                  onClick={(event) => {
                    event.stopPropagation();
                    this.addFeedback("testSection")}}
                >
                  <span
                    id={
                      this.props.openFeedback &&
                      this.state.tag === "testSection"
                        ? "feedbackScroll"
                        : ""
                    }
                    className={`${classes.feedbackContainer} ${
                      this.props.openFeedback &&
                      this.state.tag === "testSection"
                        ? classes.blueColor
                        : ""
                    } ${
                      this.props.openFeedback ? classes.feedbackHighlight : ""
                    }`}
                  >
                    Test Questions
                    {this.props.openFeedback &&
                      this.state.tag === "testSection" && (
                        <Grid className="feedbackBlock">
                          <AddFeedback
                            replyFeedback={this.replyFeedback}
                            closeFeedback={this.closeFeedback}
                            resolveFeedback={this.resolveFeedback}
                            clickedfeedbackData={clickedfeedbackData}
                            addNewFeedback={this.addNewFeedback}
                            author={this.props.authorType}
                          />
                        </Grid>
                      )}
                  </span>
                  <CustomInfoIcon
                    infoDialogContentType="Goal Management"
                    isInfoIcon={true}
                    isRightArrow={false}
                    isCenterArrow={true}
                    knowMoreAbout={false}
                    dialogTitle="Create Test"
                    imageURL="/assets/svg/infoIcon/createQuestion/information.svg"
                    dialogPara="Based on the selected test format, fill your test sections from the questions in the library or create new questions from here directly."
                    details="Click to know more"
                    toolTipDirection="top"
                  />
                </Typography>
              </Grid>
              {this.state.loadingTemplates && <LoaderComponent />}
              {/* {this.testPaperQuestionSuccess(filteredTemplates) && (
                <Grid item xs="auto">
                  <SuccessIcon className={classes.successIcon} />
                </Grid>
              )} */}
            </Grid>
          }
        >
          <div
            className={`${classes.borderBox} ${classes.mb2x} ${
              classes.subQuestionBox
            }`}
          >
            {!_.isEmpty(selectedTemplateId) && !_.isEmpty(filteredTemplates)
              ? this.getTestQuestions(
                  selectedSectionId,
                  selectedSubSectionId,
                  filteredTemplates
                )
              : this.blankTestQuestions()}
          </div>
        </MyPATExpansionPanel>

        <MyPATExpansionPanel
          panelProps={{
            disabled: this.collapsableEvent("goal"),
            expanded: !this.collapsableEvent("goal") && this.state.expandPanels.testBalance,
            onChange: this.handlePanelExpansion('testBalance')
            // expanded: this.expandPanel("balance"),
          }}
          hasExpandIcon={true}
          // defaultExpanded={this.expandPanel("balance")}
          showErrorOnTouch
          variant="white"
          customCollapseTitle={
            <Grid
              onClick={() => {
                this.collapsablePaperBalance("balance");
              }}
              container
              alignItems="center"
              justify="space-between"
              wrap="nowrap"
              className={classes.p0}
            >
              <Grid item xs="auto">
                <Typography variant="h6" className={classes.cardHeading}>
                  Test Paper Balance
                  <CustomInfoIcon
                    infoDialogContentType="Goal Management"
                    isInfoIcon={true}
                    isRightArrow={false}
                    isCenterArrow={true}
                    knowMoreAbout={false}
                    dialogTitle="Create Test"
                    imageURL="/assets/svg/infoIcon/createQuestion/information.svg"
                    dialogPara="Check the distribution of various parameters like difficulty, skill etc. in your test to create a balanced assessment."
                    details="Click to know more"
                    toolTipDirection="top"
                  />
                </Typography>
              </Grid>
              {/* {this.testPaperQuestionSuccess(filteredTemplates) && (
                <Grid item xs="auto">
                  <SuccessIcon className={classes.successIcon} />
                </Grid>
              )} */}
            </Grid>
          }
        >
          {this.state.loadingTemplates && <LoaderComponent />}
          {this.testPaperBalance(filteredTemplates)}
        </MyPATExpansionPanel>

        {this.addContentDialog()}

        {isLock ? (
          <ModalComponent
            component={() => (
              <>
                <MuiDialogContent className={classes.paddingSet}>
                  <div className={classes.popupBlock}>
                    <b className={classes.attentionTitle}>Attention</b>
                    <img
                      src="https://mypat-v2-prod.s3-us-west-2.amazonaws.com/webcontent/cms/attention.png"
                      alt="Attention"
                    />
                    <p>{message}</p>
                  </div>
                  <div style={{ textAlign: "right" }}>
                    <Button
                      autoFocus
                      variant="contained"
                      color="primary"
                      onClick={this.handleClose}
                    >
                      OK
                    </Button>
                  </div>
                </MuiDialogContent>
                <MuiDialogActions />
              </>
            )}
          />
        ) : (
          ""
        )}
        <MyPATDialog
          dialogOpen={showDialog || isGraceMarksOverrideActive}
          dialogHasActions={true}
          isAlignCenter={true}
          dialogHeading={isGraceMarksOverrideActive ? " " : "Award Grace Marks"}
          customButtonVariant="withoutBorderCloseIcon"
          onDialogClose={this.handleDialogClose.bind(this)}
          isCustomBackground={!isGraceMarksOverrideActive}
          isborderDialogAction={isGraceMarksOverrideActive}
          otherDialogProps={{
            fullWidth: false,
            maxWidth: false,
          }}
          customDialogActions={
            <>
              <Grid
                container
                justify="flex-end"
                alignItems="flex-end"
                className={
                  isGraceMarksOverrideActive ? classes.marginBottom2x : ""
                }
              >
                <Button onClick={this.handleDialogClose.bind(this)}>
                  Cancel
                </Button>
                {isGraceMarksOverrideActive ? (
                  <Button
                    onClick={() => {
                      this.handleAddToQueue(true);
                    }}
                    className={classes.okButton}
                  >
                    Ok
                  </Button>
                ) : (
                  <Button
                    onClick={() => {
                      this.handleAddToQueue(false);
                    }}
                    className={classes.okButton}
                    disabled={
                      (this.currentGraceMarkQuestion &&
                        this.currentGraceMarkQuestion.positiveMarks <
                          graceMraks) ||
                      graceMraks < 1
                    }
                  >
                    Add to Queue
                  </Button>
                )}
              </Grid>
            </>
          }
        >
          {isGraceMarksOverrideActive ? (
            <Grid
              container
              justify="center"
              alignItems="center"
              className={classes.errorCard}
            >
              <Typography variant="body1" className={classes.fontMD}>
                Alternate answer marks were already added to this question. This
                action will override the Alternate Answer.
              </Typography>
            </Grid>
          ) : (
            <>
              <Grid
                container
                justify="center"
                alignItems="center"
                className={[classes.graceCard, classes.widthSM].join(" ")}
              >
                <Grid item xs={12}>
                  <span className={classes.fontSM}>Set Grace Marks :</span>
                  &nbsp; &nbsp;
                  <span>
                    <TextField
                      variant="outlined"
                      value={graceMraks}
                      onChange={this.setGraceMarks}
                      classes={{ root: classes.graceTextField }}
                      type="number"
                      inputProps={{ min: "0", max: "10", step: "1" }}
                    />
                    {this.currentGraceMarkQuestion &&
                      this.currentGraceMarkQuestion.positiveMarks <
                        graceMraks && (
                        <span style={{ color: "red" }}>
                          {" "}
                          Grace marks should not exceed the max marks.
                        </span>
                      )}
                    {graceMraks < 1 && (
                      <span style={{ color: "red" }}>
                        {" "}
                        Grace marks should be greater than 0.
                      </span>
                    )}
                  </span>
                </Grid>
                <Grid item xs={12}>
                  {this.state.isGraceOnlyForAttemptedStudents && (
                    <Typography
                      style={{
                        fontSize: "1rem",
                        margin: "1.5rem",
                        display: "flex",
                      }}
                    >
                      <span style={{ marginRight: "5px" }}>
                        <img
                          src="/assets/svg/infoIcon/info-outlined.svg"
                          alt="info"
                          width="14px"
                        />
                      </span>
                      <span>
                        Grace Marks to be given to only students who have
                        attempted this question
                      </span>
                    </Typography>
                  )}
                  {!this.state.isGraceOnlyForAttemptedStudents && (
                    <FormControl component="fieldset">
                      <RadioGroup onChange={this.handleAnswerChange}>
                        <FormControlLabel
                          classes={{ label: classes.labelText }}
                          className={classes.marginTopMD}
                          control={
                            <Radio
                              color="primary"
                              checked={isGraceStudents}
                              onChange={this.handleGraceChanges}
                              name="graceOneStudent"
                            />
                          }
                          label="Grace Marks to be given to only students who have attempted this question"
                        />
                        <FormControlLabel
                          classes={{ label: classes.labelText }}
                          className={classes.marginTopMD}
                          control={
                            <Radio
                              color="primary"
                              checked={!isGraceStudents}
                              onChange={this.handleAllStudentsGrace}
                              name="graceAllStudent"
                            />
                          }
                          label="Grace Marks to be given to all the students who have attempted the test"
                        />
                      </RadioGroup>
                    </FormControl>
                  )}
                </Grid>
              </Grid>
              <Grid
                container
                className={[classes.widthSM, classes.marginTopSM].join(" ")}
              >
                <Grid item xs={12}>
                  <Typography variant="body1" className={classes.fontSM}>
                    <strong>* NOTE :</strong> Grace Marks will be awarded to
                    students for this test only. Please edit and correct this
                    question for future use.
                  </Typography>
                </Grid>
              </Grid>

              <Grid
                container
                className={[classes.addQueue, classes.widthSM].join(" ")}
              >
                <Typography
                  variant="body1"
                  className={[classes.fontSizeSM, classes.whiteBox].join(" ")}
                >
                  <strong>Add to Queue:</strong> Add this changes to the
                  Re-publish Queue to regenerate results for multiple
                  Questions/Tests at once from MyLibrary Homepage
                </Typography>
              </Grid>
              <Grid container className={classes.whiteCard}>
                <Grid>
                  Reason for Re-publish
                </Grid>
                <MyPATTextArea
                  inputId="republishReason"
                  name="republishReason"
                  placeholder="Enter reason here"
                  onChange={this.handleRepublishQueueChange.bind(this)}
                  value={this.state.republishQueue}
                  multiline
                  fullWidthControl
                  className={classes.customTextarea}
                />
              </Grid>
            </>
          )}
        </MyPATDialog>
        <MyPATDialog
          dialogOpen={isEditMarkingActive}
          dialogHasActions={true}
          isAlignCenter={true}
          dialogHeading={""}
          customButtonVariant="withoutBorderCloseIcon"
          onDialogClose={this.handleEditMarksActiveClose.bind(this)}
          // isCustomBackground={!isGraceMarksOverrideActive}
          // isborderDialogAction={isGraceMarksOverrideActive}
          otherDialogProps={{
            fullWidth: false,
            maxWidth: false,
          }}
          customDialogActions={
            <>
              <Grid
                container
                justify="flex-end"
                alignItems="flex-end"
                className={
                  isGraceMarksOverrideActive ? classes.marginBottom2x : ""
                }
              >
                <Button onClick={this.handleEditMarksActiveClose.bind(this)}>
                  Cancel
                </Button>
                <Button
                  onClick={() => {
                    this.addToQueueMarkingSheme(true);
                  }}
                  className={classes.okButton}
                >
                  Ok
                </Button>
              </Grid>
            </>
          }
        >
          <Grid
            container
            justify="center"
            alignItems="center"
            className={classes.errorCard}
          >
            <Typography variant="body1" className={classes.fontMD}>
              {markingShemeOverwriteMsg}
            </Typography>
          </Grid>
        </MyPATDialog>
        <MyPATDialog
          dialogOpen={isEditMarkingActive423}
          dialogHasActions={true}
          isAlignCenter={true}
          dialogHeading={""}
          customButtonVariant="withoutBorderCloseIcon"
          onDialogClose={this.handleEditMarksActiveClose.bind(this)}
          // isCustomBackground={!isGraceMarksOverrideActive}
          // isborderDialogAction={isGraceMarksOverrideActive}
          otherDialogProps={{
            fullWidth: false,
            maxWidth: false,
          }}
          customDialogActions={
            <>
              <Grid
                container
                justify="flex-end"
                alignItems="flex-end"
                className={
                  isGraceMarksOverrideActive ? classes.marginBottom2x : ""
                }
              >
                <Button
                  onClick={this.handleEditMarksActiveClose.bind(this)}
                  className={classes.okButton}
                >
                  Close
                </Button>
              </Grid>
            </>
          }
        >
          <Grid
            container
            justify="center"
            alignItems="center"
            className={classes.errorCard}
          >
            <Typography variant="body1" className={classes.fontMD}>
              {markingShemeOverwriteMsg}
            </Typography>
          </Grid>
        </MyPATDialog>
        <MyPATDialog
          dialogOpen={this.state.isDialogFilter}
          dialogHasActions={true}
          dialogHeading="Filters"
          isAlignCenter={true}
          customButtonVariant="withoutBorderCloseIcon"
          isCustomBackground={false}
          isborderDialogAction={true}
          onDialogClose={this.removeFilters}
          otherDialogProps={{
            fullWidth: false,
            maxWidth: false,
          }}
          customDialogActions={
            <>
              <Grid container justify="flex-end" alignItems="center">
                <Grid item>
                  <Button
                    onClick={() => {
                      this.removeFilters();
                    }}
                  >
                    Cancel
                  </Button>
                </Grid>
                <Grid item>
                  <Button
                    variant="contained"
                    color="primary"
                    className={classes.filterOkBtn}
                    onClick={() => {
                      this.saveFilters();
                    }}
                    disabled={this.props.contentCount.questionCount == 0}
                  >
                    Save
                  </Button>
                </Grid>
              </Grid>
            </>
          }
        >
          <Grid
            container
            justify="center"
            className={classes.width_SM}
            align-item="center"
          >
            <Grid container className={classes.greyContainer}>
              <Grid item xs={6}>
                <span>Total Content</span>
                &nbsp; &nbsp;
                <span>{loadingCount ? 'Loading...' : this.props.contentCount.totalQuestionCount}</span>
              </Grid>
              <Grid item xs={6}>
                <span>Filtered Content</span>
                &nbsp; &nbsp;
                <span>{loadingCount ? 'Loading...' : this.props.contentCount.questionCount}</span>
              </Grid>
            </Grid>

            <Grid container className="goalAction">
              <Grid item xs={6}>
                <Typography variant="body1">
                  <span>Goal Level</span>{" "}
                  <span>
                    <CustomInfoIcon
                      isCenterArrow={true}
                      isRightArrow={false}
                      isInfoIcon={true}
                      knowMoreAbout={false}
                      dialogTitle="Favourites"
                      imageURL="/assets/svg/infoIcon/myLibrary/favourite.svg"
                      dialogPara="You can view the content marked as “Favourite” by you in this tab. You can mark any content as “Favourite” by clicking on the star icon next to it."
                      details="Click to know more"
                      toolTipDirection="top"
                    />
                  </span>
                </Typography>
                <Grid>
                  {goalLevels.hasGoalLevels && (
                    <select
                      name="goalLevlID"
                      value={this.state.goalLevelId}
                      onChange={(e) => {
                        this.setGoalLevelId(e);
                      }}
                    >
                      <option value="">None</option>
                      {goalLevels.goalLevels.map((e: any, key: any) => {
                        return (
                          <option key={key} value={e._id}>
                            {e.name}
                          </option>
                        );
                      })}
                    </select>
                  )}
                </Grid>
              </Grid>
              {showContentTagFilter && (
                <Grid item xs={6}>
                  <Typography variant="body1">
                    <span>Concept Categorisation</span>{" "}
                    <span>
                      <CustomInfoIcon
                        isCenterArrow={true}
                        isRightArrow={false}
                        isInfoIcon={true}
                        knowMoreAbout={false}
                        dialogTitle="Favourites"
                        imageURL="/assets/svg/infoIcon/myLibrary/favourite.svg"
                        dialogPara="You can view the content marked as “Favourite” by you in this tab. You can mark any content as “Favourite” by clicking on the star icon next to it."
                        details="Click to know more"
                        toolTipDirection="top"
                      />
                    </span>
                  </Typography>
                  <FormControl>
                    <MyPATMultiSelect
                      placeholderText="Search and Select subjects"
                      options={concepts}
                      onChange={this.handleConceptMultiSelect.bind(this)}
                      selectedOption={selectedConcepts}
                      isMulti={true}
                    />
                  </FormControl>
                </Grid>
              )}
            </Grid>
            {showContentTagFilter && (
              <Grid container className="goalAction">
                <Grid item xs={6}>
                  <Typography variant="body1">
                    <span>Pattern Type</span>{" "}
                    <span>
                      <CustomInfoIcon
                        isCenterArrow={true}
                        isRightArrow={false}
                        isInfoIcon={true}
                        knowMoreAbout={false}
                        dialogTitle="Favourites"
                        imageURL="/assets/svg/infoIcon/myLibrary/favourite.svg"
                        dialogPara="You can view the content marked as “Favourite” by you in this tab. You can mark any content as “Favourite” by clicking on the star icon next to it."
                        details="Click to know more"
                        toolTipDirection="top"
                      />
                    </span>
                  </Typography>
                  <Grid>
                    <RadioGroup
                      name="patternType"
                      value={this.state.patternType}
                      onChange={this.handlePatternType.bind(this)}
                      classes={{
                        root: classes.testRadioGroup,
                      }}
                      row
                    >
                      <FormControlLabel
                        control={
                          <Radio
                            color="primary"
                            classes={{ root: classes.testRadioRoot }}
                          />
                        }
                        label="Subjective"
                        value="Subjective"
                      />
                      <FormControlLabel
                        control={
                          <Radio
                            color="primary"
                            classes={{ root: classes.testRadioRoot }}
                          />
                        }
                        label="Objective"
                        value="Objective"
                      />
                    </RadioGroup>
                  </Grid>
                  <div className={classes.filterSelect}>
                    {pattern[this.state.patternType] && (
                      <FormControl>
                        <MyPATMultiSelect
                          placeholderText="Search and Select subjects"
                          options={pattern[this.state.patternType]}
                          onChange={this.handleMultiSelect.bind(this)}
                          selectedOption={selectedPattern}
                          isMulti={true}
                        />
                      </FormControl>
                    )}
                  </div>
                </Grid>
                <Grid item xs={6}>
                  <Typography variant="body1">
                    <span>Skill Type</span>{" "}
                    <span>
                      <CustomInfoIcon
                        isCenterArrow={true}
                        isRightArrow={false}
                        isInfoIcon={true}
                        knowMoreAbout={false}
                        dialogTitle="Favourites"
                        imageURL="/assets/svg/infoIcon/myLibrary/favourite.svg"
                        dialogPara="You can view the content marked as “Favourite” by you in this tab. You can mark any content as “Favourite” by clicking on the star icon next to it."
                        details="Click to know more"
                        toolTipDirection="top"
                      />
                    </span>
                  </Typography>
                  <Grid>
                    <FormControl>
                      <MyPATMultiSelect
                        placeholderText="Search and Select subjects"
                        options={skill}
                        onChange={this.handleMultiSelectskill.bind(this)}
                        selectedOption={selectedskill}
                        isMulti={true}
                      />
                    </FormControl>
                  </Grid>
                </Grid>
              </Grid>
            )}

            <Grid container className={classes.sliderContainer}>
              <Grid item xs={6}>
                <Grid>
                  <Typography variant="body1">
                    <span>Difficult Level</span>
                    <span>
                      <CustomInfoIcon
                        isCenterArrow={true}
                        isRightArrow={false}
                        isInfoIcon={true}
                        knowMoreAbout={false}
                        dialogTitle="Favourites"
                        imageURL="/assets/svg/infoIcon/myLibrary/favourite.svg"
                        dialogPara="You can view the content marked as “Favourite” by you in this tab. You can mark any content as “Favourite” by clicking on the star icon next to it."
                        details="Click to know more"
                        toolTipDirection="top"
                      />
                    </span>
                  </Typography>
                </Grid>
                <Grid container alignItems="center">
                  <Grid item xs={12}>
                    <span>
                      <FormControlLabel
                        control={
                          <Checkbox
                            classes={{
                              root: classes.checkBoxElement,
                              checked: classes.checkedCheckbox,
                              colorPrimary: classes.primaryColor,
                            }}
                            onChange={(event: any) => {
                              this.handleFilterChange(event);
                            }}
                            color="primary"
                            checked={difficultyLevels.includes("easy")}
                            // checkedIcon={<span className={[classes.icon, classes.checkedIcon].join(' ')} />}
                            name="difficultyLvl"
                          />
                        }
                        classes={{ label: classes.formControlLabel }}
                        label="Easy"
                        value="easy"
                      />
                    </span>
                    <span>
                      <FormControlLabel
                        control={
                          <Checkbox
                            classes={{
                              root: classes.checkBoxElement,
                              checked: classes.checkedCheckbox,
                              colorPrimary: classes.primaryColor,
                            }}
                            onChange={(event: any) => {
                              this.handleFilterChange(event);
                            }}
                            color="primary"
                            checked={difficultyLevels.includes("medium")}
                            // checkedIcon={<span className={[classes.icon, classes.checkedIcon].join(' ')} />}
                            name="difficultyLvl"
                          />
                        }
                        classes={{ label: classes.formControlLabel }}
                        label="Medium"
                        value="medium"
                      />
                    </span>
                    <span>
                      <FormControlLabel
                        control={
                          <Checkbox
                            classes={{
                              root: classes.checkBoxElement,
                              checked: classes.checkedCheckbox,
                              colorPrimary: classes.primaryColor,
                            }}
                            onChange={(event: any) => {
                              this.handleFilterChange(event);
                            }}
                            color="primary"
                            checked={difficultyLevels.includes("hard")}
                            // checkedIcon={<span className={[classes.icon, classes.checkedIcon].join(' ')} />}
                            name="difficultyLvl"
                          />
                        }
                        classes={{ label: classes.formControlLabel }}
                        label="Hard"
                        value="hard"
                      />
                    </span>
                  </Grid>
                </Grid>
              </Grid>
              <Grid item xs={6}>
                <Grid>
                  <Typography variant="body1">
                    <span>Skill Level</span>{" "}
                    <span>
                      <CustomInfoIcon
                        isCenterArrow={true}
                        isRightArrow={false}
                        isInfoIcon={true}
                        knowMoreAbout={false}
                        dialogTitle="Favourites"
                        imageURL="/assets/svg/infoIcon/myLibrary/favourite.svg"
                        dialogPara="You can view the content marked as “Favourite” by you in this tab. You can mark any content as “Favourite” by clicking on the star icon next to it."
                        details="Click to know more"
                        toolTipDirection="top"
                      />
                    </span>
                  </Typography>
                </Grid>
                <Grid container alignItems="center">
                  <Grid item xs={12}>
                    <span>
                      <FormControlLabel
                        control={
                          <Checkbox
                            classes={{
                              root: classes.checkBoxElement,
                              checked: classes.checkedCheckbox,
                              colorPrimary: classes.primaryColor,
                            }}
                            onChange={(event: any) => {
                              this.handleFilterChange(event);
                            }}
                            color="primary"
                            // checkedIcon={<span className={[classes.icon, classes.checkedIcon].join(' ')} />}
                            name="skillLvl"
                            checked={difficultyTypes.includes("analytical")}
                          />
                        }
                        classes={{ label: classes.formControlLabel }}
                        label="Analytical"
                        value="analytical"
                      />
                    </span>

                    <span>
                      <FormControlLabel
                        control={
                          <Checkbox
                            classes={{
                              root: classes.checkBoxElement,
                              checked: classes.checkedCheckbox,
                              colorPrimary: classes.primaryColor,
                            }}
                            onChange={(event: any) => {
                              this.handleFilterChange(event);
                            }}
                            checked={difficultyTypes.includes("conceptual")}
                            color="primary"
                            // checkedIcon={<span className={[classes.icon, classes.checkedIcon].join(' ')} />}
                            name="skillLvl"
                          />
                        }
                        classes={{ label: classes.formControlLabel }}
                        label="Conceptual"
                        value="conceptual"
                      />
                    </span>
                    <span>
                      <FormControlLabel
                        control={
                          <Checkbox
                            classes={{
                              root: classes.checkBoxElement,
                              checked: classes.checkedCheckbox,
                              colorPrimary: classes.primaryColor,
                            }}
                            onChange={(event: any) => {
                              this.handleFilterChange(event);
                            }}
                            checked={difficultyTypes.includes("intuitive")}
                            color="primary"
                            name="skillLvl"
                          />
                        }
                        classes={{ label: classes.formControlLabel }}
                        label="Intuitive"
                        value="intuitive"
                      />
                    </span>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </MyPATDialog>
        {showTemplateNamePopup && (
          <TestTemplateNamePopup
            onClose={this.toggleTemplateNamePopup}
            onSave={(templateName: string) => {
              if(this.state.templateCurrentlyEditing._id) {
                this.addTemplateNameToCurrentlyEditingTemplate(templateName);
              } else {
                this.addTemplateNameToNewTemplate(templateName)
              }
            }}
          />
        )}
      </>
    );
  }
}

const mapStateToProps = (state: any) => ({
  sectionsTouched: state.commonData.focusedSection.sectionsTouched,
  contentSubtype: _.get(state, "mylibraryData.contentSubtype.list", []),
  modalTrigger: _.get(state, "mylibraryData.syllabus.modalTrigger", undefined),
  contentsubType: _.get(state, "testTemplate.contentSubType.list", {}),
  selectedTempQuestions: _.get(
    state,
    "mylibraryData.syllabus.selectedQuestions",
    []
  ),
  goalLevels: _.get(state, "mylibraryData.content.goalLevels"),
  contentCount: _.get(state, "mylibraryData.syllabus.contentCount", 0),
  loadingCount: _.get(state, "mylibraryData.syllabus.loadingCount", false),
  testPaperContentSubtype: _.get(
    state,
    "mylibraryData.contentSubtype.testpapers",
    []
  ),
  questionContentSubtype: _.get(
    state,
    "mylibraryData.contentSubtype.question",
    []
  ),
  subjects: _.get(state, "mylibraryData.syllabus.subjects.subjects", []),
  editRights: _.get(state, 'questionCreate.editRights', [])

});

const mapDispatchToProps = (dispatch: any) =>
  bindActionCreators(
    {
      contentSubtypeList: contentSubtypeActions.list,
      contentSubtypeByContentTypeCode: contentSubtypeActions.contentSubtypeByContentTypeCode,
      showMsg: showMsg,
      eventFired: eventFired,
      updateTestId: contentActions.updateTestId,
      setModalFunction: contentActions.setModalFunction,
      updateContent: contentActions.updateContent,
      templateChanged: contentActions.templateChanged,
      resetBenchMarkInfo: contentActions.resetBenchMarkInfo,
      getAutoQuestions: contentActions.getAutoQuestions,
      getContentSubType,
      fetchGoalLevels: contentActions.fetchGoalLevels,
      getAutoQuesCount: contentActions.getAutoQuesCount,
      saveTestTemplate,
      addNewFeedback: addNewFeedback,
      resolveFeedback: resolveFeedback,
      replyFeedback: replyFeedback,
      fetchSubjects: syllabusActions.fetchSubjects,
      updateSubjects: syllabusActions.updateSubject,
    },

    dispatch
  );

export default connect(
  mapStateToProps,
  mapDispatchToProps
  // @ts-ignore
)(withRouter(withStyles(styles)(TestPaperCreate)));